//#region \0rolldown/runtime.js
var e = Object.create, t = Object.defineProperty, n = Object.getOwnPropertyDescriptor, r = Object.getOwnPropertyNames, i = Object.getPrototypeOf, a = Object.prototype.hasOwnProperty, o = (e, t) => () => (e && (t = e(e = 0)), t), s = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), c = (e, n) => {
	let r = {};
	for (var i in e) t(r, i, {
		get: e[i],
		enumerable: !0
	});
	return n || t(r, Symbol.toStringTag, { value: "Module" }), r;
}, l = (e, i, o, s) => {
	if (i && typeof i == "object" || typeof i == "function") for (var c = r(i), l = 0, u = c.length, d; l < u; l++) d = c[l], !a.call(e, d) && d !== o && t(e, d, {
		get: ((e) => i[e]).bind(null, d),
		enumerable: !(s = n(i, d)) || s.enumerable
	});
	return e;
}, u = (n, r, a) => (a = n == null ? {} : e(i(n)), l(r || !n || !n.__esModule ? t(a, "default", {
	value: n,
	enumerable: !0
}) : a, n)), d = (e) => a.call(e, "module.exports") ? e["module.exports"] : l(t({}, "__esModule", { value: !0 }), e);
//#endregion
//#region ../../node_modules/xstate/dist/xstate-dev.esm.js
function f() {
	if (typeof globalThis < "u") return globalThis;
	if (typeof self < "u") return self;
	if (typeof window < "u") return window;
	if (typeof global < "u") return global;
}
function p() {
	let e = f();
	if (e.__xstate__) return e.__xstate__;
}
var m = (e) => {
	if (typeof window > "u") return;
	let t = p();
	t && t.register(e);
}, h = class {
	constructor(e) {
		this._process = e, this._active = !1, this._current = null, this._last = null;
	}
	start() {
		this._active = !0, this.flush();
	}
	clear() {
		this._current && (this._current.next = null, this._last = this._current);
	}
	enqueue(e) {
		let t = {
			value: e,
			next: null
		};
		if (this._current) {
			this._last.next = t, this._last = t;
			return;
		}
		this._current = t, this._last = t, this._active && this.flush();
	}
	flush() {
		for (; this._current;) {
			let e = this._current;
			this._process(e.value), this._current = e.next;
		}
		this._last = null;
	}
}, g = "", _ = "#", v = "*", y = "xstate.init", b = "xstate.stop";
function x(e, t) {
	return { type: `xstate.after.${e}.${t}` };
}
function S(e, t) {
	return {
		type: `xstate.done.state.${e}`,
		output: t
	};
}
function C(e, t) {
	return {
		type: `xstate.done.actor.${e}`,
		output: t,
		actorId: e
	};
}
function w(e, t) {
	return {
		type: `xstate.error.actor.${e}`,
		error: t,
		actorId: e
	};
}
function T(e) {
	return {
		type: y,
		input: e
	};
}
function E(e) {
	setTimeout(() => {
		throw e;
	});
}
var D = typeof Symbol == "function" && Symbol.observable || "@@observable";
function O(e, t) {
	let n = A(e), r = A(t);
	return typeof r == "string" ? typeof n == "string" ? r === n : !1 : typeof n == "string" ? n in r : Object.keys(n).every((e) => e in r ? O(n[e], r[e]) : !1);
}
function k(e) {
	if (ee(e)) return e;
	let t = [], n = "";
	for (let r = 0; r < e.length; r++) {
		switch (e.charCodeAt(r)) {
			case 92:
				n += e[r + 1], r++;
				continue;
			case 46:
				t.push(n), n = "";
				continue;
		}
		n += e[r];
	}
	return t.push(n), t;
}
function A(e) {
	return yt(e) ? e.value : typeof e == "string" ? j(k(e)) : e;
}
function j(e) {
	if (e.length === 1) return e[0];
	let t = {}, n = t;
	for (let t = 0; t < e.length - 1; t++) if (t === e.length - 2) n[e[t]] = e[t + 1];
	else {
		let r = n;
		n = {}, r[e[t]] = n;
	}
	return t;
}
function M(e, t) {
	let n = {}, r = Object.keys(e);
	for (let i = 0; i < r.length; i++) {
		let a = r[i];
		n[a] = t(e[a], a, e, i);
	}
	return n;
}
function N(e) {
	return ee(e) ? e : [e];
}
function P(e) {
	return e === void 0 ? [] : N(e);
}
function F(e, t, n, r) {
	return typeof e == "function" ? e({
		context: t,
		event: n,
		self: r
	}) : e;
}
function ee(e) {
	return Array.isArray(e);
}
function te(e) {
	return e.type.startsWith("xstate.error.actor");
}
function I(e) {
	return N(e).map((e) => e === void 0 || typeof e == "string" ? { target: e } : e);
}
function L(e) {
	if (!(e === void 0 || e === g)) return P(e);
}
function R(e, t, n) {
	let r = typeof e == "object", i = r ? e : void 0;
	return {
		next: (r ? e.next : e)?.bind(i),
		error: (r ? e.error : t)?.bind(i),
		complete: (r ? e.complete : n)?.bind(i)
	};
}
function z(e, t) {
	return `${t}.${e}`;
}
function ne(e, t) {
	let n = t.match(/^xstate\.invoke\.(\d+)\.(.*)/);
	if (!n) return e.implementations.actors[t];
	let [, r, i] = n, a = e.getStateNodeById(i).config.invoke;
	return (Array.isArray(a) ? a[r] : a).src;
}
function B(e, t) {
	if (t === e || t === v) return !0;
	if (!t.endsWith(".*")) return !1;
	let n = t.split("."), r = e.split(".");
	for (let e = 0; e < n.length; e++) {
		let t = n[e], i = r[e];
		if (t === "*") return e === n.length - 1;
		if (t !== i) return !1;
	}
	return !0;
}
function V(e, t) {
	return `${e.sessionId}.${t}`;
}
var re = 0;
function H(e, t) {
	let n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new WeakMap(), a = /* @__PURE__ */ new Set(), o = {}, { clock: s, logger: c } = t, l = {
		schedule: (e, t, n, r, i = Math.random().toString(36).slice(2)) => {
			let a = {
				source: e,
				target: t,
				event: n,
				delay: r,
				id: i,
				startedAt: Date.now()
			}, c = V(e, i);
			u._snapshot._scheduledEvents[c] = a, o[c] = s.setTimeout(() => {
				delete o[c], delete u._snapshot._scheduledEvents[c], u._relay(e, t, n);
			}, r);
		},
		cancel: (e, t) => {
			let n = V(e, t), r = o[n];
			delete o[n], delete u._snapshot._scheduledEvents[n], r !== void 0 && s.clearTimeout(r);
		},
		cancelAll: (e) => {
			for (let t in u._snapshot._scheduledEvents) {
				let n = u._snapshot._scheduledEvents[t];
				n.source === e && l.cancel(e, n.id);
			}
		}
	}, u = {
		_snapshot: { _scheduledEvents: (t?.snapshot && t.snapshot.scheduler) ?? {} },
		_bookId: () => `x:${re++}`,
		_register: (e, t) => (n.set(e, t), e),
		_unregister: (e) => {
			n.delete(e.sessionId);
			let t = i.get(e);
			t !== void 0 && (r.delete(t), i.delete(e));
		},
		get: (e) => r.get(e),
		getAll: () => Object.fromEntries(r.entries()),
		_set: (e, t) => {
			let n = r.get(e);
			if (n && n !== t) throw Error(`Actor with system ID '${e}' already exists.`);
			r.set(e, t), i.set(t, e);
		},
		inspect: (e) => {
			let t = R(e);
			return a.add(t), { unsubscribe() {
				a.delete(t);
			} };
		},
		_sendInspectionEvent: (t) => {
			if (!a.size) return;
			let n = {
				...t,
				rootId: e.sessionId
			};
			a.forEach((e) => e.next?.(n));
		},
		_relay: (e, t, n) => {
			u._sendInspectionEvent({
				type: "@xstate.event",
				sourceRef: e,
				actorRef: t,
				event: n
			}), t._send(n);
		},
		scheduler: l,
		getSnapshot: () => ({ _scheduledEvents: { ...u._snapshot._scheduledEvents } }),
		start: () => {
			let e = u._snapshot._scheduledEvents;
			u._snapshot._scheduledEvents = {};
			for (let t in e) {
				let { source: n, target: r, event: i, delay: a, id: o } = e[t];
				l.schedule(n, r, i, a, o);
			}
		},
		_clock: s,
		_logger: c
	};
	return u;
}
var ie = !1, U = /* @__PURE__ */ function(e) {
	return e[e.NotStarted = 0] = "NotStarted", e[e.Running = 1] = "Running", e[e.Stopped = 2] = "Stopped", e;
}({}), ae = {
	clock: {
		setTimeout: (e, t) => setTimeout(e, t),
		clearTimeout: (e) => clearTimeout(e)
	},
	logger: console.log.bind(console),
	devTools: !1
}, oe = class {
	constructor(e, t) {
		this.logic = e, this._snapshot = void 0, this.clock = void 0, this.options = void 0, this.id = void 0, this.mailbox = new h(this._process.bind(this)), this.observers = /* @__PURE__ */ new Set(), this.eventListeners = /* @__PURE__ */ new Map(), this.logger = void 0, this._processingStatus = U.NotStarted, this._parent = void 0, this._syncSnapshot = void 0, this.ref = void 0, this._actorScope = void 0, this.systemId = void 0, this.sessionId = void 0, this.system = void 0, this._doneEvent = void 0, this.src = void 0, this._deferred = [];
		let n = {
			...ae,
			...t
		}, { clock: r, logger: i, parent: a, syncSnapshot: o, id: s, systemId: c, inspect: l } = n;
		this.system = a ? a.system : H(this, {
			clock: r,
			logger: i
		}), l && !a && this.system.inspect(R(l)), this.sessionId = this.system._bookId(), this.id = s ?? this.sessionId, this.logger = t?.logger ?? this.system._logger, this.clock = t?.clock ?? this.system._clock, this._parent = a, this._syncSnapshot = o, this.options = n, this.src = n.src ?? e, this.ref = this, this._actorScope = {
			self: this,
			id: this.id,
			sessionId: this.sessionId,
			logger: this.logger,
			defer: (e) => {
				this._deferred.push(e);
			},
			system: this.system,
			stopChild: (e) => {
				if (e._parent !== this) throw Error(`Cannot stop child actor ${e.id} of ${this.id} because it is not a child`);
				e._stop();
			},
			emit: (e) => {
				let t = this.eventListeners.get(e.type), n = this.eventListeners.get("*");
				if (!t && !n) return;
				let r = [...t ? t.values() : [], ...n ? n.values() : []];
				for (let t of r) try {
					t(e);
				} catch (e) {
					E(e);
				}
			},
			actionExecutor: (e) => {
				let t = () => {
					if (this._actorScope.system._sendInspectionEvent({
						type: "@xstate.action",
						actorRef: this,
						action: {
							type: e.type,
							params: e.params
						}
					}), !e.exec) return;
					let t = ie;
					try {
						ie = !0, e.exec(e.info, e.params);
					} finally {
						ie = t;
					}
				};
				this._processingStatus === U.Running ? t() : this._deferred.push(t);
			}
		}, this.send = this.send.bind(this), this.system._sendInspectionEvent({
			type: "@xstate.actor",
			actorRef: this
		}), c && (this.systemId = c, this.system._set(c, this)), this._initState(t?.snapshot ?? t?.state), c && this._snapshot.status !== "active" && this.system._unregister(this);
	}
	_initState(e) {
		try {
			this._snapshot = e ? this.logic.restoreSnapshot ? this.logic.restoreSnapshot(e, this._actorScope) : e : this.logic.getInitialSnapshot(this._actorScope, this.options?.input);
		} catch (e) {
			this._snapshot = {
				status: "error",
				output: void 0,
				error: e
			};
		}
	}
	update(e, t) {
		this._snapshot = e;
		let n;
		for (; n = this._deferred.shift();) try {
			n();
		} catch (t) {
			this._deferred.length = 0, this._snapshot = {
				...e,
				status: "error",
				error: t
			};
		}
		switch (this._snapshot.status) {
			case "active":
				for (let t of this.observers) try {
					t.next?.(e);
				} catch (e) {
					E(e);
				}
				break;
			case "done":
				for (let t of this.observers) try {
					t.next?.(e);
				} catch (e) {
					E(e);
				}
				this._stopProcedure(), this._complete(), this._doneEvent = C(this.id, this._snapshot.output), this._parent && this.system._relay(this, this._parent, this._doneEvent);
				break;
			case "error":
				this._error(this._snapshot.error);
				break;
		}
		this.system._sendInspectionEvent({
			type: "@xstate.snapshot",
			actorRef: this,
			event: t,
			snapshot: e
		});
	}
	subscribe(e, t, n) {
		let r = R(e, t, n);
		if (this._processingStatus !== U.Stopped) this.observers.add(r);
		else switch (this._snapshot.status) {
			case "done":
				try {
					r.complete?.();
				} catch (e) {
					E(e);
				}
				break;
			case "error": {
				let e = this._snapshot.error;
				if (!r.error) E(e);
				else try {
					r.error(e);
				} catch (e) {
					E(e);
				}
				break;
			}
		}
		return { unsubscribe: () => {
			this.observers.delete(r);
		} };
	}
	on(e, t) {
		let n = this.eventListeners.get(e);
		n || (n = /* @__PURE__ */ new Set(), this.eventListeners.set(e, n));
		let r = t.bind(void 0);
		return n.add(r), { unsubscribe: () => {
			n.delete(r);
		} };
	}
	select(e, t = Object.is) {
		return {
			subscribe: (n) => {
				let r = R(n), i = e(this.getSnapshot());
				return this.subscribe((n) => {
					let a = e(n);
					t(i, a) || (i = a, r.next?.(a));
				});
			},
			get: () => e(this.getSnapshot())
		};
	}
	start() {
		if (this._processingStatus === U.Running) return this;
		this._syncSnapshot && this.subscribe({
			next: (e) => {
				e.status === "active" && this.system._relay(this, this._parent, {
					type: `xstate.snapshot.${this.id}`,
					snapshot: e
				});
			},
			error: () => {}
		}), this.system._register(this.sessionId, this), this.systemId && this.system._set(this.systemId, this), this._processingStatus = U.Running;
		let e = T(this.options.input);
		switch (this.system._sendInspectionEvent({
			type: "@xstate.event",
			sourceRef: this._parent,
			actorRef: this,
			event: e
		}), this._snapshot.status) {
			case "done": return this.update(this._snapshot, e), this;
			case "error": return this._error(this._snapshot.error), this;
		}
		if (this._parent || this.system.start(), this.logic.start) try {
			this.logic.start(this._snapshot, this._actorScope);
		} catch (e) {
			return this._snapshot = {
				...this._snapshot,
				status: "error",
				error: e
			}, this._error(e), this;
		}
		return this.update(this._snapshot, e), this.options.devTools && this.attachDevTools(), this.mailbox.start(), this;
	}
	_process(e) {
		let t, n;
		try {
			t = this.logic.transition(this._snapshot, e, this._actorScope);
		} catch (e) {
			n = { err: e };
		}
		if (n) {
			let { err: e } = n;
			this._snapshot = {
				...this._snapshot,
				status: "error",
				error: e
			}, this._error(e);
			return;
		}
		this.update(t, e), e.type === "xstate.stop" && (this._stopProcedure(), this._complete());
	}
	_stop() {
		return this._processingStatus === U.Stopped ? this : (this.mailbox.clear(), this._processingStatus === U.NotStarted ? (this._processingStatus = U.Stopped, this) : (this.mailbox.enqueue({ type: b }), this));
	}
	stop() {
		if (this._parent) throw Error("A non-root actor cannot be stopped directly.");
		return this._stop();
	}
	_complete() {
		for (let e of this.observers) try {
			e.complete?.();
		} catch (e) {
			E(e);
		}
		this.observers.clear(), this.eventListeners.clear();
	}
	_reportError(e) {
		if (!this.observers.size) {
			this._parent || E(e), this.eventListeners.clear();
			return;
		}
		let t = !1;
		for (let n of this.observers) {
			let r = n.error;
			t ||= !r;
			try {
				r?.(e);
			} catch (e) {
				E(e);
			}
		}
		this.observers.clear(), this.eventListeners.clear(), t && E(e);
	}
	_error(e) {
		this._stopProcedure(), this._reportError(e), this._parent && this.system._relay(this, this._parent, w(this.id, e));
	}
	_stopProcedure() {
		return this._processingStatus === U.Running ? (this.system.scheduler.cancelAll(this), this.mailbox.clear(), this.mailbox = new h(this._process.bind(this)), this._processingStatus = U.Stopped, this.system._unregister(this), this) : this;
	}
	_send(e) {
		this._processingStatus !== U.Stopped && this.mailbox.enqueue(e);
	}
	send(e) {
		this.system._relay(void 0, this, e);
	}
	attachDevTools() {
		let { devTools: e } = this.options;
		e && (typeof e == "function" ? e : m)(this);
	}
	toJSON() {
		return {
			xstate$$type: 1,
			id: this.id
		};
	}
	getPersistedSnapshot(e) {
		return this.logic.getPersistedSnapshot(this._snapshot, e);
	}
	[D]() {
		return this;
	}
	getSnapshot() {
		return this._snapshot;
	}
};
function se(e, ...[t]) {
	return new oe(e, t);
}
function ce(e, t, n, r, { sendId: i }) {
	return [
		t,
		{ sendId: typeof i == "function" ? i(n, r) : i },
		void 0
	];
}
function le(e, t) {
	e.defer(() => {
		e.system.scheduler.cancel(e.self, t.sendId);
	});
}
function ue(e) {
	function t(e, t) {}
	return t.type = "xstate.cancel", t.sendId = e, t.resolve = ce, t.execute = le, t;
}
function de(e, t, n, r, { id: i, systemId: a, src: o, input: s, syncSnapshot: c }) {
	let l = typeof o == "string" ? ne(t.machine, o) : o, u = typeof i == "function" ? i(n) : i, d, f;
	return l && (f = typeof s == "function" ? s({
		context: t.context,
		event: n.event,
		self: e.self
	}) : s, d = se(l, {
		id: u,
		src: o,
		parent: e.self,
		syncSnapshot: c,
		systemId: a,
		input: f
	})), [
		Et(t, { children: {
			...t.children,
			[u]: d
		} }),
		{
			id: i,
			systemId: a,
			actorRef: d,
			src: o,
			input: f
		},
		void 0
	];
}
function fe(e, { actorRef: t }) {
	t && e.defer(() => {
		t._processingStatus !== U.Stopped && t.start();
	});
}
function pe(...[e, { id: t, systemId: n, input: r, syncSnapshot: i = !1 } = {}]) {
	function a(e, t) {}
	return a.type = "xstate.spawnChild", a.id = t, a.systemId = n, a.src = e, a.input = r, a.syncSnapshot = i, a.resolve = de, a.execute = fe, a;
}
function me(e, t, n, r, { actorRef: i }) {
	let a = typeof i == "function" ? i(n, r) : i, o = typeof a == "string" ? t.children[a] : a, s = t.children;
	return o && (s = { ...s }, delete s[o.id]), [
		Et(t, { children: s }),
		o,
		void 0
	];
}
function he(e, t) {
	let n = t.getSnapshot();
	if (n && "children" in n) for (let t of Object.values(n.children)) he(e, t);
	e.system._unregister(t);
}
function ge(e, t) {
	if (t) {
		if (he(e, t), t._processingStatus !== U.Running) {
			e.stopChild(t);
			return;
		}
		e.defer(() => {
			e.stopChild(t);
		});
	}
}
function _e(e) {
	function t(e, t) {}
	return t.type = "xstate.stopChild", t.actorRef = e, t.resolve = me, t.execute = ge, t;
}
function ve(e, { context: t, event: n }, { guards: r }) {
	return r.every((r) => be(r, t, n, e));
}
function ye(e) {
	function t(e, t) {
		return !1;
	}
	return t.check = ve, t.guards = e, t;
}
function be(e, t, n, r) {
	let { machine: i } = r, a = typeof e == "function", o = a ? e : i.implementations.guards[typeof e == "string" ? e : e.type];
	if (!a && !o) throw Error(`Guard '${typeof e == "string" ? e : e.type}' is not implemented.'.`);
	if (typeof o != "function") return be(o, t, n, r);
	let s = {
		context: t,
		event: n
	}, c = a || typeof e == "string" ? void 0 : "params" in e ? typeof e.params == "function" ? e.params({
		context: t,
		event: n
	}) : e.params : void 0;
	return "check" in o ? o.check(r, s, o) : o(s, c);
}
function xe(e) {
	return e.type === "atomic" || e.type === "final";
}
function W(e) {
	return Object.values(e.states).filter((e) => e.type !== "history");
}
function Se(e, t) {
	let n = [];
	if (t === e) return n;
	let r = e.parent;
	for (; r && r !== t;) n.push(r), r = r.parent;
	return n;
}
function Ce(e) {
	let t = new Set(e), n = Te(t);
	for (let e of t) if (e.type === "compound" && (!n.get(e) || !n.get(e).length)) Re(e).forEach((e) => t.add(e));
	else if (e.type === "parallel") {
		for (let n of W(e)) if (n.type !== "history" && !t.has(n)) {
			let e = Re(n);
			for (let n of e) t.add(n);
		}
	}
	for (let e of t) {
		let n = e.parent;
		for (; n;) t.add(n), n = n.parent;
	}
	return t;
}
function we(e, t) {
	let n = t.get(e);
	if (!n) return {};
	if (e.type === "compound") {
		let e = n[0];
		if (e) {
			if (xe(e)) return e.key;
		} else return {};
	}
	let r = {};
	for (let e of n) r[e.key] = we(e, t);
	return r;
}
function Te(e) {
	let t = /* @__PURE__ */ new Map();
	for (let n of e) t.has(n) || t.set(n, []), n.parent && (t.has(n.parent) || t.set(n.parent, []), t.get(n.parent).push(n));
	return t;
}
function Ee(e, t) {
	return we(e, Te(Ce(t)));
}
function De(e, t) {
	return t.type === "compound" ? W(t).some((t) => t.type === "final" && e.has(t)) : t.type === "parallel" ? W(t).every((t) => De(e, t)) : t.type === "final";
}
var Oe = (e) => e[0] === _;
function ke(e, t) {
	let n = e.transitions.get(t), r = [...e.transitions.keys()].filter((e) => e !== t && B(t, e)).sort((e, t) => t.length - e.length).flatMap((t) => e.transitions.get(t));
	return n ? [...n, ...r] : r;
}
function Ae(e) {
	let t = e.config.after;
	if (!t) return [];
	let n = (t) => {
		let n = x(t, e.id), r = n.type;
		return e.entry.push(Mt(n, {
			id: r,
			delay: t
		})), e.exit.push(ue(r)), r;
	};
	return Object.keys(t).flatMap((e) => {
		let r = t[e], i = typeof r == "string" ? { target: r } : r, a = Number.isNaN(+e) ? e : +e, o = n(a);
		return P(i).map((e) => ({
			...e,
			event: o,
			delay: a
		}));
	}).map((t) => {
		let { delay: n } = t;
		return {
			...je(e, t.event, t),
			delay: n
		};
	});
}
function je(e, t, n) {
	let r = L(n.target), i = n.reenter ?? !1, a = Fe(e, r), o = {
		...n,
		actions: P(n.actions),
		guard: n.guard,
		target: a,
		source: e,
		reenter: i,
		eventType: t,
		toJSON: () => ({
			...o,
			source: `#${e.id}`,
			target: a ? a.map((e) => `#${e.id}`) : void 0
		})
	};
	return o;
}
function Me(e) {
	let t = /* @__PURE__ */ new Map();
	if (e.config.on) for (let n of Object.keys(e.config.on)) {
		if (n === "") throw Error("Null events (\"\") cannot be specified as a transition key. Use `always: { ... }` instead.");
		let r = e.config.on[n];
		t.set(n, I(r).map((t) => je(e, n, t)));
	}
	if (e.config.onDone) {
		let n = `xstate.done.state.${e.id}`;
		t.set(n, I(e.config.onDone).map((t) => je(e, n, t)));
	}
	for (let n of e.invoke) {
		if (n.onDone) {
			let r = `xstate.done.actor.${n.id}`;
			t.set(r, I(n.onDone).map((t) => je(e, r, t)));
		}
		if (n.onError) {
			let r = `xstate.error.actor.${n.id}`;
			t.set(r, I(n.onError).map((t) => je(e, r, t)));
		}
		if (n.onSnapshot) {
			let r = `xstate.snapshot.${n.id}`;
			t.set(r, I(n.onSnapshot).map((t) => je(e, r, t)));
		}
	}
	for (let n of e.after) {
		let e = t.get(n.eventType);
		e || (e = [], t.set(n.eventType, e)), e.push(n);
	}
	return t;
}
function Ne(e) {
	let t = [], n = (r) => {
		Object.values(r).forEach((r) => {
			if (r.config.route && r.config.id) {
				let n = r.config.id, i = r.config.route.guard, a = ({ event: e }) => e.to === `#${n}`, o = {
					...r.config.route,
					guard: i ? ye([a, i]) : a,
					target: `#${n}`
				};
				t.push(je(e, "xstate.route", o));
			}
			r.states && n(r.states);
		});
	};
	n(e.states), t.length > 0 && e.transitions.set("xstate.route", t);
}
function Pe(e, t) {
	let n = typeof t == "string" ? e.states[t] : t ? e.states[t.target] : void 0;
	if (!n && t) throw Error(`Initial state node "${t}" not found on parent state node #${e.id}`);
	let r = {
		source: e,
		actions: !t || typeof t == "string" ? [] : P(t.actions),
		eventType: null,
		reenter: !1,
		target: n ? [n] : [],
		toJSON: () => ({
			...r,
			source: `#${e.id}`,
			target: n ? [`#${n.id}`] : []
		})
	};
	return r;
}
function Fe(e, t) {
	if (t !== void 0) return t.map((t) => {
		if (typeof t != "string") return t;
		if (Oe(t)) return e.machine.getStateNodeById(t);
		let n = t[0] === ".";
		if (n && !e.parent) return Ve(e, t.slice(1));
		let r = n ? e.key + t : t;
		if (e.parent) try {
			return Ve(e.parent, r);
		} catch (t) {
			throw Error(`Invalid transition definition for state node '${e.id}':\n${t.message}`);
		}
		else throw Error(`Invalid target: "${t}" is not a valid target from the root node. Did you mean ".${t}"?`);
	});
}
function Ie(e) {
	let t = L(e.config.target);
	return t ? { target: t.map((t) => typeof t == "string" ? Ve(e.parent, t) : t) } : e.parent.type === "parallel" ? { target: [e.parent] } : e.parent.initial;
}
function Le(e) {
	return e.type === "history";
}
function Re(e) {
	let t = ze(e);
	for (let n of t) for (let r of Se(n, e)) t.add(r);
	return t;
}
function ze(e) {
	let t = /* @__PURE__ */ new Set();
	function n(e) {
		if (!t.has(e)) {
			if (t.add(e), e.type === "compound") n(e.initial.target[0]);
			else if (e.type === "parallel") for (let t of W(e)) n(t);
		}
	}
	return n(e), t;
}
function Be(e, t) {
	if (Oe(t)) return e.machine.getStateNodeById(t);
	if (!e.states) throw Error(`Unable to retrieve child state '${t}' from '${e.id}'; no child states exist.`);
	let n = e.states[t];
	if (!n) throw Error(`Child state '${t}' does not exist on '${e.id}'`);
	return n;
}
function Ve(e, t) {
	if (typeof t == "string" && Oe(t)) try {
		return e.machine.getStateNodeById(t);
	} catch {}
	let n = k(t).slice(), r = e;
	for (; n.length;) {
		let e = n.shift();
		if (!e.length) break;
		r = Be(r, e);
	}
	return r;
}
function He(e, t) {
	if (typeof t == "string") {
		let n = e.states[t];
		if (!n) throw Error(`State '${t}' does not exist on '${e.id}'`);
		return [e, n];
	}
	let n = Object.keys(t), r = n.map((t) => Be(e, t)).filter(Boolean);
	return [e.machine.root, e].concat(r, n.reduce((n, r) => {
		let i = Be(e, r);
		if (!i) return n;
		let a = He(i, t[r]);
		return n.concat(a);
	}, []));
}
function Ue(e, t, n, r) {
	let i = Be(e, t).next(n, r);
	return !i || !i.length ? e.next(n, r) : i;
}
function We(e, t, n, r) {
	let i = Object.keys(t), a = Ke(Be(e, i[0]), t[i[0]], n, r);
	return !a || !a.length ? e.next(n, r) : a;
}
function Ge(e, t, n, r) {
	let i = [];
	for (let a of Object.keys(t)) {
		let o = t[a];
		if (!o) continue;
		let s = Ke(Be(e, a), o, n, r);
		s && i.push(...s);
	}
	return i.length ? i : e.next(n, r);
}
function Ke(e, t, n, r) {
	return typeof t == "string" ? Ue(e, t, n, r) : Object.keys(t).length === 1 ? We(e, t, n, r) : Ge(e, t, n, r);
}
function qe(e) {
	return Object.keys(e.states).map((t) => e.states[t]).filter((e) => e.type === "history");
}
function Je(e, t) {
	let n = e;
	for (; n.parent && n.parent !== t;) n = n.parent;
	return n.parent === t;
}
function Ye(e, t) {
	let n = new Set(e), r = new Set(t);
	for (let e of n) if (r.has(e)) return !0;
	for (let e of r) if (n.has(e)) return !0;
	return !1;
}
function Xe(e, t, n) {
	let r = /* @__PURE__ */ new Set();
	for (let i of e) {
		let e = !1, a = /* @__PURE__ */ new Set();
		for (let o of r) if (Ye(et([i], t, n), et([o], t, n))) if (Je(i.source, o.source)) a.add(o);
		else {
			e = !0;
			break;
		}
		if (!e) {
			for (let e of a) r.delete(e);
			r.add(i);
		}
	}
	return Array.from(r);
}
function Ze(e) {
	let [t, ...n] = e;
	for (let e of Se(t, void 0)) if (n.every((t) => Je(t, e))) return e;
}
function Qe(e, t) {
	if (!e.target) return [];
	let n = /* @__PURE__ */ new Set();
	for (let r of e.target) if (Le(r)) if (t[r.id]) for (let e of t[r.id]) n.add(e);
	else for (let e of Qe(Ie(r), t)) n.add(e);
	else n.add(r);
	return [...n];
}
function $e(e, t) {
	let n = Qe(e, t);
	if (!n) return;
	if (!e.reenter && n.every((t) => t === e.source || Je(t, e.source))) return e.source;
	let r = Ze(n.concat(e.source));
	if (r) return r;
	if (!e.reenter) return e.source.machine.root;
}
function et(e, t, n) {
	let r = /* @__PURE__ */ new Set();
	for (let i of e) if (i.target?.length) {
		let e = $e(i, n);
		i.reenter && i.source === e && r.add(e);
		for (let n of t) Je(n, e) && r.add(n);
	}
	return [...r];
}
function tt(e, t) {
	if (e.length !== t.size) return !1;
	for (let n of e) if (!t.has(n)) return !1;
	return !0;
}
function nt(e, t, n, r, i) {
	return rt([{
		target: [...ze(e)],
		source: e,
		reenter: !0,
		actions: [],
		eventType: null,
		toJSON: null
	}], t, n, r, !0, i);
}
function rt(e, t, n, r, i, a) {
	let o = [];
	if (!e.length) return [t, o];
	let s = n.actionExecutor;
	n.actionExecutor = (e) => {
		o.push(e), s(e);
	};
	try {
		let s = new Set(t._nodes), c = t.historyValue, l = Xe(e, s, c), u = t;
		i || ([u, c] = ut(u, r, n, l, s, c, a, n.actionExecutor)), u = pt(u, r, n, l.flatMap((e) => e.actions), a, void 0), u = at(u, r, n, l, s, a, c, i);
		let d = [...s];
		u.status === "done" && (u = pt(u, r, n, d.sort((e, t) => t.order - e.order).flatMap((e) => e.exit), a, void 0));
		try {
			return c === t.historyValue && tt(t._nodes, s) ? [u, o] : [Et(u, {
				_nodes: d,
				historyValue: c
			}), o];
		} catch (e) {
			throw e;
		}
	} finally {
		n.actionExecutor = s;
	}
}
function it(e, t, n, r, i) {
	if (r.output === void 0) return;
	let a = S(i.id, i.output !== void 0 && i.parent ? F(i.output, e.context, t, n.self) : void 0);
	return F(r.output, e.context, a, n.self);
}
function at(e, t, n, r, i, a, o, s) {
	let c = e, l = /* @__PURE__ */ new Set(), u = /* @__PURE__ */ new Set();
	ot(r, o, u, l), s && u.add(e.machine.root);
	let d = /* @__PURE__ */ new Set();
	for (let e of [...l].sort((e, t) => e.order - t.order)) {
		i.add(e);
		let r = [];
		r.push(...e.entry);
		for (let t of e.invoke) r.push(pe(t.src, {
			...t,
			syncSnapshot: !!t.onSnapshot
		}));
		if (u.has(e)) {
			let t = e.initial.actions;
			r.push(...t);
		}
		if (c = pt(c, t, n, r, a, e.invoke.map((e) => e.id)), e.type === "final") {
			let r = e.parent, o = r?.type === "parallel" ? r : r?.parent, s = o || e;
			for (r?.type === "compound" && a.push(S(r.id, e.output === void 0 ? void 0 : F(e.output, c.context, t, n.self))); o?.type === "parallel" && !d.has(o) && De(i, o);) d.add(o), a.push(S(o.id)), s = o, o = o.parent;
			if (o) continue;
			c = Et(c, {
				status: "done",
				output: it(c, t, n, c.machine.root, s)
			});
		}
	}
	return c;
}
function ot(e, t, n, r) {
	for (let i of e) {
		let e = $e(i, t);
		for (let a of i.target || []) !Le(a) && (i.source !== a || i.source !== e || i.reenter) && (r.add(a), n.add(a)), st(a, t, n, r);
		let a = Qe(i, t);
		for (let o of a) {
			let a = Se(o, e);
			e?.type === "parallel" && a.push(e), ct(r, t, n, a, !i.source.parent && i.reenter ? void 0 : e);
		}
	}
}
function st(e, t, n, r) {
	if (Le(e)) if (t[e.id]) {
		let i = t[e.id];
		for (let e of i) r.add(e), st(e, t, n, r);
		for (let a of i) lt(a, e.parent, r, t, n);
	} else {
		let i = Ie(e);
		for (let a of i.target) r.add(a), i === e.parent?.initial && n.add(e.parent), st(a, t, n, r);
		for (let a of i.target) lt(a, e.parent, r, t, n);
	}
	else if (e.type === "compound") {
		let [i] = e.initial.target;
		Le(i) || (r.add(i), n.add(i)), st(i, t, n, r), lt(i, e, r, t, n);
	} else if (e.type === "parallel") for (let i of W(e).filter((e) => !Le(e))) [...r].some((e) => Je(e, i)) || (Le(i) || (r.add(i), n.add(i)), st(i, t, n, r));
}
function ct(e, t, n, r, i) {
	for (let a of r) if ((!i || Je(a, i)) && e.add(a), a.type === "parallel") for (let r of W(a).filter((e) => !Le(e))) [...e].some((e) => Je(e, r)) || (e.add(r), st(r, t, n, e));
}
function lt(e, t, n, r, i) {
	ct(n, r, i, Se(e, t));
}
function ut(e, t, n, r, i, a, o, s) {
	let c = e, l = et(r, i, a);
	l.sort((e, t) => t.order - e.order);
	let u;
	for (let e of l) for (let t of qe(e)) {
		let n;
		n = t.history === "deep" ? (t) => xe(t) && Je(t, e) : (t) => t.parent === e, u ??= { ...a }, u[t.id] = Array.from(i).filter(n);
	}
	for (let e of l) c = pt(c, t, n, [...e.exit, ...e.invoke.map((e) => _e(e.id))], o, void 0), i.delete(e);
	return [c, u || a];
}
function dt(e, t) {
	return e.implementations.actions[t];
}
function ft(e, t, n, r, i, a) {
	let { machine: o } = e, s = e;
	for (let e of r) {
		let r = typeof e == "function", c = r ? e : dt(o, typeof e == "string" ? e : e.type), l = {
			context: s.context,
			event: t,
			self: n.self,
			system: n.system
		}, u = r || typeof e == "string" ? void 0 : "params" in e ? typeof e.params == "function" ? e.params({
			context: s.context,
			event: t
		}) : e.params : void 0;
		if (!c || !("resolve" in c)) {
			n.actionExecutor({
				type: typeof e == "string" ? e : typeof e == "object" ? e.type : e.name || "(anonymous)",
				info: l,
				params: u,
				exec: c
			});
			continue;
		}
		let d = c, [f, p, m] = d.resolve(n, s, l, u, c, i);
		s = f, "retryResolve" in d && a?.push([d, p]), "execute" in d && n.actionExecutor({
			type: d.type,
			info: l,
			params: p,
			exec: d.execute.bind(null, n, p)
		}), m && (s = ft(s, t, n, m, i, a));
	}
	return s;
}
function pt(e, t, n, r, i, a) {
	let o = a ? [] : void 0, s = ft(e, t, n, r, {
		internalQueue: i,
		deferredActorIds: a
	}, o);
	return o?.forEach(([e, t]) => {
		e.retryResolve(n, s, t);
	}), s;
}
function mt(e, t, n, r) {
	let i = e, a = [];
	function o(e, t, r) {
		n.system._sendInspectionEvent({
			type: "@xstate.microstep",
			actorRef: n.self,
			event: t,
			snapshot: e[0],
			_transitions: r
		}), a.push(e);
	}
	if (t.type === "xstate.stop") return i = Et(ht(i, t, n), { status: "stopped" }), o([i, []], t, []), {
		snapshot: i,
		microsteps: a
	};
	let s = t;
	if (s.type !== y) {
		let t = s, c = te(t), l = gt(t, i);
		if (c && !l.length) return i = Et(e, {
			status: "error",
			error: t.error
		}), o([i, []], t, []), {
			snapshot: i,
			microsteps: a
		};
		let u = rt(l, e, n, s, !1, r);
		i = u[0], o(u, t, l);
	}
	let c = !0, l = e.machine.options?.maxIterations ?? Infinity, u = 0;
	for (; i.status === "active";) {
		if (u++, u > l) throw Error(`Infinite loop detected: the machine has processed more than ${l} microsteps without reaching a stable state. This usually happens when there's a cycle of transitions (e.g., eventless transitions or raised events causing state A -> B -> C -> A).`);
		let e = c ? _t(i, s) : [], t = e.length ? i : void 0;
		if (!e.length) {
			if (!r.length) break;
			s = r.shift(), e = gt(s, i);
		}
		let a = rt(e, i, n, s, !1, r);
		i = a[0], c = i !== t, o(a, s, e);
	}
	return i.status !== "active" && ht(i, s, n), {
		snapshot: i,
		microsteps: a
	};
}
function ht(e, t, n) {
	return pt(e, t, n, Object.values(e.children).map((e) => _e(e)), [], void 0);
}
function gt(e, t) {
	return t.machine.getTransitionData(t, e);
}
function _t(e, t) {
	let n = /* @__PURE__ */ new Set(), r = e._nodes.filter(xe);
	for (let i of r) loop: for (let r of [i].concat(Se(i, void 0))) if (r.always) {
		for (let i of r.always) if (i.guard === void 0 || be(i.guard, e.context, t, e)) {
			n.add(i);
			break loop;
		}
	}
	return Xe(Array.from(n), new Set(e._nodes), e.historyValue);
}
function vt(e, t) {
	return Ee(e, [...Ce(He(e, t))]);
}
function yt(e) {
	return !!e && typeof e == "object" && "machine" in e && "value" in e;
}
var bt = function(e) {
	return O(e, this.value);
}, xt = function(e) {
	return this.tags.has(e);
}, St = function(e) {
	let t = this.machine.getTransitionData(this, e);
	return !!t?.length && t.some((e) => e.target !== void 0 || e.actions.length);
}, Ct = function() {
	let { _nodes: e, tags: t, machine: n, getMeta: r, toJSON: i, can: a, hasTag: o, matches: s, ...c } = this;
	return {
		...c,
		tags: Array.from(t)
	};
}, wt = function() {
	return this._nodes.reduce((e, t) => (t.meta !== void 0 && (e[t.id] = t.meta), e), {});
};
function Tt(e, t) {
	return {
		status: e.status,
		output: e.output,
		error: e.error,
		machine: t,
		context: e.context,
		_nodes: e._nodes,
		value: Ee(t.root, e._nodes),
		tags: new Set(e._nodes.flatMap((e) => e.tags)),
		children: e.children,
		historyValue: e.historyValue || {},
		matches: bt,
		hasTag: xt,
		can: St,
		getMeta: wt,
		toJSON: Ct
	};
}
function Et(e, t = {}) {
	return Tt({
		...e,
		...t
	}, e.machine);
}
function Dt(e) {
	if (typeof e != "object" || !e) return {};
	let t = {};
	for (let n in e) {
		let r = e[n];
		Array.isArray(r) && (t[n] = r.map((e) => ({ id: e.id })));
	}
	return t;
}
function Ot(e, t) {
	let { _nodes: n, tags: r, machine: i, children: a, context: o, can: s, hasTag: c, matches: l, getMeta: u, toJSON: d, ...f } = e, p = {};
	for (let e in a) {
		let n = a[e];
		p[e] = {
			snapshot: n.getPersistedSnapshot(t),
			src: n.src,
			systemId: n.systemId,
			syncSnapshot: n._syncSnapshot
		};
	}
	return {
		...f,
		context: kt(o),
		children: p,
		historyValue: Dt(f.historyValue)
	};
}
function kt(e) {
	let t;
	for (let n in e) {
		let r = e[n];
		if (r && typeof r == "object") if ("sessionId" in r && "send" in r && "ref" in r) t ??= Array.isArray(e) ? e.slice() : { ...e }, t[n] = {
			xstate$$type: 1,
			id: r.id
		};
		else {
			let i = kt(r);
			i !== r && (t ??= Array.isArray(e) ? e.slice() : { ...e }, t[n] = i);
		}
	}
	return t ?? e;
}
function At(e, t, n, r, { event: i, id: a, delay: o }, { internalQueue: s }) {
	let c = t.machine.implementations.delays;
	if (typeof i == "string") throw Error(`Only event objects may be used with raise; use raise({ type: "${i}" }) instead`);
	let l = typeof i == "function" ? i(n, r) : i, u;
	if (typeof o == "string") {
		let e = c && c[o];
		u = typeof e == "function" ? e(n, r) : e;
	} else u = typeof o == "function" ? o(n, r) : o;
	return typeof u != "number" && s.push(l), [
		t,
		{
			event: l,
			id: a,
			delay: u
		},
		void 0
	];
}
function jt(e, t) {
	let { event: n, delay: r, id: i } = t;
	if (typeof r == "number") {
		e.defer(() => {
			let t = e.self;
			e.system.scheduler.schedule(t, t, n, r, i);
		});
		return;
	}
}
function Mt(e, t) {
	function n(e, t) {}
	return n.type = "xstate.raise", n.event = e, n.id = t?.id, n.delay = t?.delay, n.resolve = At, n.execute = jt, n;
}
var Nt = /* @__PURE__ */ new WeakMap();
function Pt(e) {
	return {
		config: e,
		start: (t, n) => {
			let { self: r, system: i, emit: a } = n, o = {
				receivers: void 0,
				dispose: void 0
			};
			Nt.set(r, o), o.dispose = e({
				input: t.input,
				system: i,
				self: r,
				sendBack: (e) => {
					r.getSnapshot().status !== "stopped" && r._parent && i._relay(r, r._parent, e);
				},
				receive: (e) => {
					o.receivers ??= /* @__PURE__ */ new Set(), o.receivers.add(e);
				},
				emit: a
			});
		},
		transition: (e, t, n) => {
			let r = Nt.get(n.self);
			return t.type === "xstate.stop" ? (e = {
				...e,
				status: "stopped",
				error: void 0
			}, Nt.delete(n.self), r.receivers?.clear(), r.dispose?.(), e) : (r.receivers?.forEach((e) => e(t)), e);
		},
		getInitialSnapshot: (e, t) => ({
			status: "active",
			output: void 0,
			error: void 0,
			input: t
		}),
		getPersistedSnapshot: (e) => e,
		restoreSnapshot: (e) => e
	};
}
var Ft = "xstate.promise.resolve", It = "xstate.promise.reject", Lt = /* @__PURE__ */ new WeakMap();
function Rt(e) {
	return {
		config: e,
		transition: (e, t, n) => {
			if (e.status !== "active") return e;
			switch (t.type) {
				case Ft: {
					let n = t.data;
					return {
						...e,
						status: "done",
						output: n,
						input: void 0
					};
				}
				case It: return {
					...e,
					status: "error",
					error: t.data,
					input: void 0
				};
				case b: return Lt.get(n.self)?.abort(), Lt.delete(n.self), {
					...e,
					status: "stopped",
					input: void 0
				};
				default: return e;
			}
		},
		start: (t, { self: n, system: r, emit: i }) => {
			if (t.status !== "active") return;
			let a = new AbortController();
			Lt.set(n, a), Promise.resolve(e({
				input: t.input,
				system: r,
				self: n,
				signal: a.signal,
				emit: i
			})).then((e) => {
				n.getSnapshot().status === "active" && (Lt.delete(n), r._relay(n, n, {
					type: Ft,
					data: e
				}));
			}, (e) => {
				n.getSnapshot().status === "active" && (Lt.delete(n), r._relay(n, n, {
					type: It,
					data: e
				}));
			});
		},
		getInitialSnapshot: (e, t) => ({
			status: "active",
			output: void 0,
			error: void 0,
			input: t
		}),
		getPersistedSnapshot: (e) => e,
		restoreSnapshot: (e) => e
	};
}
//#endregion
//#region ../../node_modules/xstate/dist/assign-29f23f4d.esm.js
function zt(e, { machine: t, context: n }, r, i) {
	let a = (a, o) => {
		if (typeof a == "string") {
			let s = ne(t, a);
			if (!s) throw Error(`Actor logic '${a}' not implemented in machine '${t.id}'`);
			let c = se(s, {
				id: o?.id,
				parent: e.self,
				syncSnapshot: o?.syncSnapshot,
				input: typeof o?.input == "function" ? o.input({
					context: n,
					event: r,
					self: e.self
				}) : o?.input,
				src: a,
				systemId: o?.systemId
			});
			return i[c.id] = c, c;
		} else return se(a, {
			id: o?.id,
			parent: e.self,
			syncSnapshot: o?.syncSnapshot,
			input: o?.input,
			src: a,
			systemId: o?.systemId
		});
	};
	return (t, n) => {
		let r = a(t, n);
		return i[r.id] = r, e.defer(() => {
			r._processingStatus !== U.Stopped && r.start();
		}), r;
	};
}
function Bt(e, t, n, r, { assignment: i }) {
	if (!t.context) throw Error("Cannot assign to undefined `context`. Ensure that `context` is defined in the machine config.");
	let a = {}, o = {
		context: t.context,
		event: n.event,
		spawn: zt(e, t, n.event, a),
		self: e.self,
		system: e.system
	}, s = {};
	if (typeof i == "function") s = i(o, r);
	else for (let e of Object.keys(i)) {
		let t = i[e];
		s[e] = typeof t == "function" ? t(o, r) : t;
	}
	return [
		Et(t, {
			context: Object.assign({}, t.context, s),
			children: Object.keys(a).length ? {
				...t.children,
				...a
			} : t.children
		}),
		void 0,
		void 0
	];
}
function G(e) {
	function t(e, t) {}
	return t.type = "xstate.assign", t.assignment = e, t.resolve = Bt, t;
}
//#endregion
//#region ../../node_modules/xstate/dist/StateMachine-5f345bba.esm.js
var Vt = /* @__PURE__ */ new WeakMap();
function Ht(e, t, n) {
	let r = Vt.get(e);
	return r ? t in r || (r[t] = n()) : (r = { [t]: n() }, Vt.set(e, r)), r[t];
}
var Ut = {}, Wt = (e) => typeof e == "string" ? { type: e } : typeof e == "function" ? "resolve" in e ? { type: e.type } : { type: e.name } : e, Gt = class e {
	constructor(t, n) {
		if (this.config = t, this.key = void 0, this.id = void 0, this.type = void 0, this.path = void 0, this.states = void 0, this.history = void 0, this.entry = void 0, this.exit = void 0, this.parent = void 0, this.machine = void 0, this.meta = void 0, this.output = void 0, this.order = -1, this.description = void 0, this.tags = [], this.transitions = void 0, this.always = void 0, this.parent = n._parent, this.key = n._key, this.machine = n._machine, this.path = this.parent ? this.parent.path.concat(this.key) : [], this.id = this.config.id || [this.machine.id, ...this.path].join("."), this.type = this.config.type || (this.config.states && Object.keys(this.config.states).length ? "compound" : this.config.history ? "history" : "atomic"), this.description = this.config.description, this.order = this.machine.idMap.size, this.machine.idMap.set(this.id, this), this.states = this.config.states ? M(this.config.states, (t, n) => new e(t, {
			_parent: this,
			_key: n,
			_machine: this.machine
		})) : Ut, this.type === "compound" && !this.config.initial) throw Error(`No initial state specified for compound state node "#${this.id}". Try adding { initial: "${Object.keys(this.states)[0]}" } to the state config.`);
		this.history = this.config.history === !0 ? "shallow" : this.config.history || !1, this.entry = P(this.config.entry).slice(), this.exit = P(this.config.exit).slice(), this.meta = this.config.meta, this.output = this.type === "final" || !this.parent ? this.config.output : void 0, this.tags = P(t.tags).slice();
	}
	_initialize() {
		this.transitions = Me(this), this.config.always && (this.always = I(this.config.always).map((e) => je(this, "", e))), Object.keys(this.states).forEach((e) => {
			this.states[e]._initialize();
		});
	}
	get definition() {
		return {
			id: this.id,
			key: this.key,
			version: this.machine.version,
			type: this.type,
			initial: this.initial ? {
				target: this.initial.target,
				source: this,
				actions: this.initial.actions.map(Wt),
				eventType: null,
				reenter: !1,
				toJSON: () => ({
					target: this.initial.target.map((e) => `#${e.id}`),
					source: `#${this.id}`,
					actions: this.initial.actions.map(Wt),
					eventType: null
				})
			} : void 0,
			history: this.history,
			states: M(this.states, (e) => e.definition),
			on: this.on,
			transitions: [...this.transitions.values()].flat().map((e) => ({
				...e,
				actions: e.actions.map(Wt)
			})),
			entry: this.entry.map(Wt),
			exit: this.exit.map(Wt),
			meta: this.meta,
			order: this.order || -1,
			output: this.output,
			invoke: this.invoke,
			description: this.description,
			tags: this.tags
		};
	}
	toJSON() {
		return this.definition;
	}
	get invoke() {
		return Ht(this, "invoke", () => P(this.config.invoke).map((e, t) => {
			let { src: n, systemId: r } = e, i = e.id ?? z(this.id, t), a = typeof n == "string" ? n : `xstate.invoke.${z(this.id, t)}`;
			return {
				...e,
				src: a,
				id: i,
				systemId: r,
				toJSON() {
					let { onDone: t, onError: n, ...r } = e;
					return {
						...r,
						type: "xstate.invoke",
						src: a,
						id: i
					};
				}
			};
		}));
	}
	get on() {
		return Ht(this, "on", () => [...this.transitions].flatMap(([e, t]) => t.map((t) => [e, t])).reduce((e, [t, n]) => (e[t] = e[t] || [], e[t].push(n), e), {}));
	}
	get after() {
		return Ht(this, "delayedTransitions", () => Ae(this));
	}
	get initial() {
		return Ht(this, "initial", () => Pe(this, this.config.initial));
	}
	next(e, t) {
		let n = t.type, r = [], i, a = Ht(this, `candidates-${n}`, () => ke(this, n));
		for (let o of a) {
			let { guard: a } = o, s = e.context, c = !1;
			try {
				c = !a || be(a, s, t, e);
			} catch (e) {
				let t = typeof a == "string" ? a : typeof a == "object" ? a.type : void 0;
				throw Error(`Unable to evaluate guard ${t ? `'${t}' ` : ""}in transition for event '${n}' in state node '${this.id}':\n${e.message}`);
			}
			if (c) {
				r.push(...o.actions), i = o;
				break;
			}
		}
		return i ? [i] : void 0;
	}
	get events() {
		return Ht(this, "events", () => {
			let { states: e } = this, t = new Set(this.ownEvents);
			if (e) for (let n of Object.keys(e)) {
				let r = e[n];
				if (r.states) for (let e of r.events) t.add(`${e}`);
			}
			return Array.from(t);
		});
	}
	get ownEvents() {
		let e = Object.keys(Object.fromEntries(this.transitions)), t = new Set(e.filter((e) => this.transitions.get(e).some((e) => !(!e.target && !e.actions.length && !e.reenter))));
		return Array.from(t);
	}
}, Kt = class e {
	constructor(e, t) {
		this.config = e, this.version = void 0, this.schemas = void 0, this.implementations = void 0, this.options = void 0, this.__xstatenode = !0, this.idMap = /* @__PURE__ */ new Map(), this.root = void 0, this.id = void 0, this.states = void 0, this.events = void 0, this.id = e.id || "(machine)", this.implementations = {
			actors: t?.actors ?? {},
			actions: t?.actions ?? {},
			delays: t?.delays ?? {},
			guards: t?.guards ?? {}
		}, this.version = this.config.version, this.schemas = this.config.schemas, this.options = {
			maxIterations: Infinity,
			...this.config.options
		}, this.transition = this.transition.bind(this), this.getInitialSnapshot = this.getInitialSnapshot.bind(this), this.getPersistedSnapshot = this.getPersistedSnapshot.bind(this), this.restoreSnapshot = this.restoreSnapshot.bind(this), this.start = this.start.bind(this), this.root = new Gt(e, {
			_key: this.id,
			_machine: this
		}), this.root._initialize(), Ne(this.root), this.states = this.root.states, this.events = this.root.events;
	}
	provide(t) {
		let { actions: n, guards: r, actors: i, delays: a } = this.implementations;
		return new e(this.config, {
			actions: {
				...n,
				...t.actions
			},
			guards: {
				...r,
				...t.guards
			},
			actors: {
				...i,
				...t.actors
			},
			delays: {
				...a,
				...t.delays
			}
		});
	}
	resolveState(e) {
		let t = vt(this.root, e.value), n = Ce(He(this.root, t));
		return Tt({
			_nodes: [...n],
			context: e.context || {},
			children: {},
			status: De(n, this.root) ? "done" : e.status || "active",
			output: e.output,
			error: e.error,
			historyValue: e.historyValue
		}, this);
	}
	transition(e, t, n) {
		return mt(e, t, n, []).snapshot;
	}
	microstep(e, t, n) {
		return mt(e, t, n, []).microsteps.map(([e]) => e);
	}
	getTransitionData(e, t) {
		return Ke(this.root, e.value, e, t) || [];
	}
	_getPreInitialState(e, t, n) {
		let { context: r } = this.config, i = Tt({
			context: typeof r != "function" && r ? r : {},
			_nodes: [this.root],
			children: {},
			status: "active"
		}, this);
		return typeof r == "function" ? pt(i, t, e, [G(({ spawn: e, event: t, self: n }) => r({
			spawn: e,
			input: t.input,
			self: n
		}))], n, void 0) : i;
	}
	getInitialSnapshot(e, t) {
		let n = T(t), r = [], i = this._getPreInitialState(e, n, r), [a] = nt(this.root, i, e, n, r), { snapshot: o } = mt(a, n, e, r);
		return o;
	}
	start(e) {
		Object.values(e.children).forEach((e) => {
			e.getSnapshot().status === "active" && e.start();
		});
	}
	getStateNodeById(e) {
		let t = k(e), n = t.slice(1), r = Oe(t[0]) ? t[0].slice(1) : t[0], i = this.idMap.get(r);
		if (!i) throw Error(`Child state node '#${r}' does not exist on machine '${this.id}'`);
		return Ve(i, n);
	}
	get definition() {
		return this.root.definition;
	}
	toJSON() {
		return this.definition;
	}
	getPersistedSnapshot(e, t) {
		return Ot(e, t);
	}
	restoreSnapshot(e, t) {
		let n = {}, r = e.children;
		Object.keys(r).forEach((e) => {
			let i = r[e], a = i.snapshot, o = i.src, s = typeof o == "string" ? ne(this, o) : o;
			s && (n[e] = se(s, {
				id: e,
				parent: t.self,
				syncSnapshot: i.syncSnapshot,
				snapshot: a,
				src: o,
				systemId: i.systemId
			}));
		});
		function i(e, t) {
			if (t instanceof Gt) return t;
			try {
				return e.machine.getStateNodeById(t.id);
			} catch {}
		}
		function a(e, t) {
			if (!t || typeof t != "object") return {};
			let n = {};
			for (let r in t) {
				let a = t[r];
				for (let t of a) {
					let a = i(e, t);
					a && (n[r] ??= [], n[r].push(a));
				}
			}
			return n;
		}
		let o = a(this.root, e.historyValue), s = Tt({
			...e,
			children: n,
			_nodes: Array.from(Ce(He(this.root, e.value))),
			historyValue: o
		}, this), c = /* @__PURE__ */ new Set();
		function l(e, t) {
			if (!c.has(e)) {
				c.add(e);
				for (let n in e) {
					let r = e[n];
					if (r && typeof r == "object") {
						if ("xstate$$type" in r && r.xstate$$type === 1) {
							e[n] = t[r.id];
							continue;
						}
						l(r, t);
					}
				}
			}
		}
		return l(s.context, n), s;
	}
};
//#endregion
//#region ../../node_modules/xstate/dist/log-79409d72.esm.js
function qt(e, t, n, r, { event: i }) {
	return [
		t,
		{ event: typeof i == "function" ? i(n, r) : i },
		void 0
	];
}
function Jt(e, { event: t }) {
	e.defer(() => e.emit(t));
}
function Yt(e) {
	function t(e, t) {}
	return t.type = "xstate.emit", t.event = e, t.resolve = qt, t.execute = Jt, t;
}
var Xt = /* @__PURE__ */ function(e) {
	return e.Parent = "#_parent", e.Internal = "#_internal", e;
}({});
function Zt(e, t, n, r, { to: i, event: a, id: o, delay: s }, c) {
	let l = t.machine.implementations.delays;
	if (typeof a == "string") throw Error(`Only event objects may be used with sendTo; use sendTo({ type: "${a}" }) instead`);
	let u = typeof a == "function" ? a(n, r) : a, d;
	if (typeof s == "string") {
		let e = l && l[s];
		d = typeof e == "function" ? e(n, r) : e;
	} else d = typeof s == "function" ? s(n, r) : s;
	let f = typeof i == "function" ? i(n, r) : i, p;
	if (typeof f == "string") {
		if (p = f === Xt.Parent ? e.self._parent : f === Xt.Internal ? e.self : f.startsWith("#_") ? t.children[f.slice(2)] : c.deferredActorIds?.includes(f) ? f : t.children[f], !p) throw Error(`Unable to send event to actor '${f}' from machine '${t.machine.id}'.`);
	} else p = f || e.self;
	return [
		t,
		{
			to: p,
			targetId: typeof f == "string" ? f : void 0,
			event: u,
			id: o,
			delay: d
		},
		void 0
	];
}
function Qt(e, t, n) {
	typeof n.to == "string" && (n.to = t.children[n.to]);
}
function $t(e, t) {
	e.defer(() => {
		let { to: n, event: r, delay: i, id: a } = t;
		if (typeof i == "number") {
			e.system.scheduler.schedule(e.self, n, r, i, a);
			return;
		}
		e.system._relay(e.self, n, r.type === "xstate.error" ? w(e.self.id, r.data) : r);
	});
}
function en(e, t, n) {
	function r(e, t) {}
	return r.type = "xstate.sendTo", r.to = e, r.event = t, r.id = n?.id, r.delay = n?.delay, r.resolve = Zt, r.retryResolve = Qt, r.execute = $t, r;
}
function K(e, t) {
	return en(Xt.Parent, e, t);
}
function tn(e, t) {
	return en(e, ({ event: e }) => e, t);
}
function nn(e, t, n, r, { collect: i }) {
	let a = [], o = function(e) {
		a.push(e);
	};
	return o.assign = (...e) => {
		a.push(G(...e));
	}, o.cancel = (...e) => {
		a.push(ue(...e));
	}, o.raise = (...e) => {
		a.push(Mt(...e));
	}, o.sendTo = (...e) => {
		a.push(en(...e));
	}, o.sendParent = (...e) => {
		a.push(K(...e));
	}, o.spawnChild = (...e) => {
		a.push(pe(...e));
	}, o.stopChild = (...e) => {
		a.push(_e(...e));
	}, o.emit = (...e) => {
		a.push(Yt(...e));
	}, i({
		context: n.context,
		event: n.event,
		enqueue: o,
		check: (e) => be(e, t.context, n.event, t),
		self: e.self,
		system: e.system
	}, r), [
		t,
		void 0,
		a
	];
}
function rn(e) {
	function t(e, t) {}
	return t.type = "xstate.enqueueActions", t.collect = e, t.resolve = nn, t;
}
//#endregion
//#region ../../node_modules/xstate/dist/xstate.esm.js
function an(e, t) {
	return new Kt(e, t);
}
//#endregion
//#region ../../node_modules/is-plain-object/dist/is-plain-object.mjs
function on(e) {
	return Object.prototype.toString.call(e) === "[object Object]";
}
function sn(e) {
	var t, n;
	return on(e) === !1 ? !1 : (t = e.constructor, t === void 0 ? !0 : (n = t.prototype, !(on(n) === !1 || n.hasOwnProperty("isPrototypeOf") === !1)));
}
//#endregion
//#region ../../node_modules/object-path-immutable/esm/object-path-immutable.js
var cn = /* @__PURE__ */ u((/* @__PURE__ */ s(((e, t) => {
	(function(e, n) {
		/*istanbul ignore next:cant test*/
		typeof t == "object" && typeof t.exports == "object" ? t.exports = n() : e.objectPath = n();
	})(e, function() {
		var e = Object.prototype.toString;
		function t(e, t) {
			return e == null ? !1 : Object.prototype.hasOwnProperty.call(e, t);
		}
		function n(e) {
			if (!e || a(e) && e.length === 0) return !0;
			if (typeof e != "string") {
				for (var n in e) if (t(e, n)) return !1;
				return !0;
			}
			return !1;
		}
		function r(t) {
			return e.call(t);
		}
		function i(e) {
			return typeof e == "object" && r(e) === "[object Object]";
		}
		var a = Array.isArray || function(t) {
			/*istanbul ignore next:cant test*/
			return e.call(t) === "[object Array]";
		};
		function o(e) {
			return typeof e == "boolean" || r(e) === "[object Boolean]";
		}
		function s(e) {
			var t = parseInt(e);
			return t.toString() === e ? t : e;
		}
		function c(e) {
			e ||= {};
			var r = function(e) {
				return Object.keys(r).reduce(function(t, n) {
					return n === "create" || typeof r[n] == "function" && (t[n] = r[n].bind(r, e)), t;
				}, {});
			}, c = e.includeInheritedProps ? function() {
				return !0;
			} : function(e, n) {
				return typeof n == "number" && Array.isArray(e) || t(e, n);
			};
			function l(e, t) {
				if (c(e, t)) return e[t];
			}
			var u = e.includeInheritedProps ? function(e, t) {
				typeof t != "string" && typeof t != "number" && (t = String(t));
				var n = l(e, t);
				if (t === "__proto__" || t === "prototype" || t === "constructor" && typeof n == "function") throw Error("For security reasons, object's magic properties cannot be set");
				return n;
			} : function(e, t) {
				return l(e, t);
			};
			function d(e, t, n, r) {
				if (typeof t == "number" && (t = [t]), !t || t.length === 0) return e;
				if (typeof t == "string") return d(e, t.split(".").map(s), n, r);
				var i = t[0], a = u(e, i);
				return t.length === 1 ? ((a === void 0 || !r) && (e[i] = n), a) : (a === void 0 && (typeof t[1] == "number" ? e[i] = [] : e[i] = {}), d(e[i], t.slice(1), n, r));
			}
			return r.has = function(n, r) {
				if (typeof r == "number" ? r = [r] : typeof r == "string" && (r = r.split(".")), !r || r.length === 0) return !!n;
				for (var i = 0; i < r.length; i++) {
					var o = s(r[i]);
					if (typeof o == "number" && a(n) && o < n.length || (e.includeInheritedProps ? o in Object(n) : t(n, o))) n = n[o];
					else return !1;
				}
				return !0;
			}, r.ensureExists = function(e, t, n) {
				return d(e, t, n, !0);
			}, r.set = function(e, t, n, r) {
				return d(e, t, n, r);
			}, r.insert = function(e, t, n, i) {
				var o = r.get(e, t);
				i = ~~i, a(o) || (o = [], r.set(e, t, o)), o.splice(i, 0, n);
			}, r.empty = function(e, t) {
				if (!n(t) && e != null) {
					var s, l;
					if (s = r.get(e, t)) {
						if (typeof s == "string") return r.set(e, t, "");
						if (o(s)) return r.set(e, t, !1);
						if (typeof s == "number") return r.set(e, t, 0);
						if (a(s)) s.length = 0;
						else if (i(s)) for (l in s) c(s, l) && delete s[l];
						else return r.set(e, t, null);
					}
				}
			}, r.push = function(e, t) {
				var n = r.get(e, t);
				a(n) || (n = [], r.set(e, t, n)), n.push.apply(n, Array.prototype.slice.call(arguments, 2));
			}, r.coalesce = function(e, t, n) {
				for (var i, a = 0, o = t.length; a < o; a++) if ((i = r.get(e, t[a])) !== void 0) return i;
				return n;
			}, r.get = function(e, t, n) {
				if (typeof t == "number" && (t = [t]), !t || t.length === 0) return e;
				if (e == null) return n;
				if (typeof t == "string") return r.get(e, t.split("."), n);
				var i = s(t[0]), a = u(e, i);
				return a === void 0 ? n : t.length === 1 ? a : r.get(e[i], t.slice(1), n);
			}, r.del = function(e, t) {
				if (typeof t == "number" && (t = [t]), e == null || n(t)) return e;
				if (typeof t == "string") return r.del(e, t.split("."));
				var i = s(t[0]);
				if (u(e, i), !c(e, i)) return e;
				if (t.length === 1) a(e) ? e.splice(i, 1) : delete e[i];
				else return r.del(e[i], t.slice(1));
				return e;
			}, r;
		}
		var l = c();
		return l.create = c, l.withInheritedProps = c({ includeInheritedProps: !0 }), l;
	});
})))()), ln = Object.prototype.hasOwnProperty;
function un(e) {
	if (dn(e)) return !1;
	if (!e || pn(e) && e.length === 0) return !0;
	if (!fn(e)) {
		for (var t in e) if (ln.call(e, t)) return !1;
		return !0;
	}
	return !1;
}
function dn(e) {
	return typeof e == "number";
}
function fn(e) {
	return typeof e == "string";
}
function pn(e) {
	return Array.isArray(e);
}
function mn(e, t) {
	for (var n in t) ln.call(t, n) && (e[n] = t[n]);
	return e;
}
function hn(e) {
	var t = parseInt(e);
	return t.toString() === e ? t : e;
}
function gn(e, t, n) {
	return e == null ? t ? n ? [] : {} : e : pn(e) ? e.slice() : mn({}, e);
}
function _n(e, t) {
	if (e !== t && sn(e) && sn(t)) {
		var n = {};
		for (var r in e) ln.call(e, r) && (ln.call(t, r) ? n[r] = _n(e[r], t[r]) : n[r] = e[r]);
		for (r in t) ln.call(t, r) && (n[r] = _n(e[r], t[r]));
		return n;
	}
	return t;
}
function vn(e, t, n, r) {
	if (dn(n) && (n = [n]), un(n)) return t;
	if (fn(n)) return vn(e, t, n.split(".").map(hn), r);
	var i = n[0];
	return (!e || e === t) && (e = gn(t, !0, dn(i))), n.length === 1 ? r(e, i) : (t != null && (t = t[i]), e[i] = vn(e[i], t, n.slice(1), r), e);
}
var q = {};
q.set = function(e, t, n, r) {
	return un(n) ? r : vn(e, t, n, function(e, t) {
		return e[t] = r, e;
	});
}, q.update = function(e, t, n, r) {
	return un(n) ? r(gn(t)) : vn(e, t, n, function(e, t) {
		return e[t] = r(e[t]), e;
	});
}, q.push = function(e, t, n) {
	var r = Array.prototype.slice.call(arguments, 3);
	return un(n) ? pn(t) ? t.concat(r) : r : vn(e, t, n, function(e, t) {
		return pn(e[t]) ? e[t] = e[t].concat(r) : e[t] = r, e;
	});
}, q.insert = function(e, t, n, r, i) {
	if (i = ~~i, un(n)) {
		if (!pn(t)) return [r];
		var a = t.slice(0, i);
		return a.push(r), a.concat(t.slice(i));
	}
	return vn(e, t, n, function(e, t) {
		var a = e[t];
		if (!pn(a)) {
			if (a != null && a !== void 0) throw Error("Expected " + n + "to be an array. Instead got " + typeof n);
			a = [];
		}
		var o = a.slice(0, i);
		return o.push(r), e[t] = o.concat(a.slice(i)), e;
	});
}, q.del = function(e, t, n) {
	if (!un(n)) return vn(e, t, n, function(e, t) {
		return Array.isArray(e) ? e[t] !== void 0 && e.splice(t, 1) : ln.call(e, t) && delete e[t], e;
	});
}, q.assign = function(e, t, n, r) {
	return un(n) ? un(r) ? t : mn(gn(t), r) : vn(e, t, n, function(e, t) {
		r = Object(r);
		var n = gn(e[t], !0);
		return mn(n, r), e[t] = n, e;
	});
}, q.merge = function(e, t, n, r) {
	return un(n) ? un(r) ? t : _n(t, r) : vn(e, t, n, function(e, t) {
		return r = Object(r), e[t] = _n(e[t], r), e;
	});
};
var yn = q.set.bind(null, null), bn = q.update.bind(null, null);
q.push.bind(null, null), q.insert.bind(null, null), q.del.bind(null, null), q.assign.bind(null, null), q.merge.bind(null, null);
var xn = cn.default.get, J = [];
for (let e = 0; e < 256; ++e) J.push((e + 256).toString(16).slice(1));
function Sn(e, t = 0) {
	return (J[e[t + 0]] + J[e[t + 1]] + J[e[t + 2]] + J[e[t + 3]] + "-" + J[e[t + 4]] + J[e[t + 5]] + "-" + J[e[t + 6]] + J[e[t + 7]] + "-" + J[e[t + 8]] + J[e[t + 9]] + "-" + J[e[t + 10]] + J[e[t + 11]] + J[e[t + 12]] + J[e[t + 13]] + J[e[t + 14]] + J[e[t + 15]]).toLowerCase();
}
//#endregion
//#region ../../node_modules/uuid/dist/rng.js
var Cn = new Uint8Array(16);
function wn() {
	return crypto.getRandomValues(Cn);
}
//#endregion
//#region ../../node_modules/uuid/dist/v4.js
function Tn(e, t, n) {
	return !t && !e && crypto.randomUUID ? crypto.randomUUID() : En(e, t, n);
}
function En(e, t, n) {
	e ||= {};
	let r = e.random ?? e.rng?.() ?? wn();
	if (r.length < 16) throw Error("Random bytes length must be >= 16");
	if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, t) {
		if (n ||= 0, n < 0 || n + 16 > t.length) throw RangeError(`UUID byte range ${n}:${n + 15} is out of buffer bounds`);
		for (let e = 0; e < 16; ++e) t[n + e] = r[e];
		return t;
	}
	return Sn(r);
}
//#endregion
//#region src/core/constants.js
var Dn = /* @__PURE__ */ u((/* @__PURE__ */ s(((e, t) => {
	var n = 200, r = "__lodash_hash_undefined__", i = 1, a = 2, o = 9007199254740991, s = "[object Arguments]", c = "[object Array]", l = "[object AsyncFunction]", u = "[object Boolean]", d = "[object Date]", f = "[object Error]", p = "[object Function]", m = "[object GeneratorFunction]", h = "[object Map]", g = "[object Number]", _ = "[object Null]", v = "[object Object]", y = "[object Promise]", b = "[object Proxy]", x = "[object RegExp]", S = "[object Set]", C = "[object String]", w = "[object Symbol]", T = "[object Undefined]", E = "[object WeakMap]", D = "[object ArrayBuffer]", O = "[object DataView]", k = "[object Float32Array]", A = "[object Float64Array]", j = "[object Int8Array]", M = "[object Int16Array]", N = "[object Int32Array]", P = "[object Uint8Array]", F = "[object Uint8ClampedArray]", ee = "[object Uint16Array]", te = "[object Uint32Array]", I = /[\\^$.*+?()[\]{}|]/g, L = /^\[object .+?Constructor\]$/, R = /^(?:0|[1-9]\d*)$/, z = {};
	z[k] = z[A] = z[j] = z[M] = z[N] = z[P] = z[F] = z[ee] = z[te] = !0, z[s] = z[c] = z[D] = z[u] = z[O] = z[d] = z[f] = z[p] = z[h] = z[g] = z[v] = z[x] = z[S] = z[C] = z[E] = !1;
	var ne = typeof global == "object" && global && global.Object === Object && global, B = typeof self == "object" && self && self.Object === Object && self, V = ne || B || Function("return this")(), re = typeof e == "object" && e && !e.nodeType && e, H = re && typeof t == "object" && t && !t.nodeType && t, ie = H && H.exports === re, U = ie && ne.process, ae = function() {
		try {
			return U && U.binding && U.binding("util");
		} catch {}
	}(), oe = ae && ae.isTypedArray;
	function se(e, t) {
		for (var n = -1, r = e == null ? 0 : e.length, i = 0, a = []; ++n < r;) {
			var o = e[n];
			t(o, n, e) && (a[i++] = o);
		}
		return a;
	}
	function ce(e, t) {
		for (var n = -1, r = t.length, i = e.length; ++n < r;) e[i + n] = t[n];
		return e;
	}
	function le(e, t) {
		for (var n = -1, r = e == null ? 0 : e.length; ++n < r;) if (t(e[n], n, e)) return !0;
		return !1;
	}
	function ue(e, t) {
		for (var n = -1, r = Array(e); ++n < e;) r[n] = t(n);
		return r;
	}
	function de(e) {
		return function(t) {
			return e(t);
		};
	}
	function fe(e, t) {
		return e.has(t);
	}
	function pe(e, t) {
		return e?.[t];
	}
	function me(e) {
		var t = -1, n = Array(e.size);
		return e.forEach(function(e, r) {
			n[++t] = [r, e];
		}), n;
	}
	function he(e, t) {
		return function(n) {
			return e(t(n));
		};
	}
	function ge(e) {
		var t = -1, n = Array(e.size);
		return e.forEach(function(e) {
			n[++t] = e;
		}), n;
	}
	var _e = Array.prototype, ve = Function.prototype, ye = Object.prototype, be = V["__core-js_shared__"], xe = ve.toString, W = ye.hasOwnProperty, Se = function() {
		var e = /[^.]+$/.exec(be && be.keys && be.keys.IE_PROTO || "");
		return e ? "Symbol(src)_1." + e : "";
	}(), Ce = ye.toString, we = RegExp("^" + xe.call(W).replace(I, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), Te = ie ? V.Buffer : void 0, Ee = V.Symbol, De = V.Uint8Array, Oe = ye.propertyIsEnumerable, ke = _e.splice, Ae = Ee ? Ee.toStringTag : void 0, je = Object.getOwnPropertySymbols, Me = Te ? Te.isBuffer : void 0, Ne = he(Object.keys, Object), Pe = Ft(V, "DataView"), Fe = Ft(V, "Map"), Ie = Ft(V, "Promise"), Le = Ft(V, "Set"), Re = Ft(V, "WeakMap"), ze = Ft(Object, "create"), Be = Ut(Pe), Ve = Ut(Fe), He = Ut(Ie), Ue = Ut(Le), We = Ut(Re), Ge = Ee ? Ee.prototype : void 0, Ke = Ge ? Ge.valueOf : void 0;
	function qe(e) {
		var t = -1, n = e == null ? 0 : e.length;
		for (this.clear(); ++t < n;) {
			var r = e[t];
			this.set(r[0], r[1]);
		}
	}
	function Je() {
		this.__data__ = ze ? ze(null) : {}, this.size = 0;
	}
	function Ye(e) {
		var t = this.has(e) && delete this.__data__[e];
		return this.size -= +!!t, t;
	}
	function Xe(e) {
		var t = this.__data__;
		if (ze) {
			var n = t[e];
			return n === r ? void 0 : n;
		}
		return W.call(t, e) ? t[e] : void 0;
	}
	function Ze(e) {
		var t = this.__data__;
		return ze ? t[e] !== void 0 : W.call(t, e);
	}
	function Qe(e, t) {
		var n = this.__data__;
		return this.size += +!this.has(e), n[e] = ze && t === void 0 ? r : t, this;
	}
	qe.prototype.clear = Je, qe.prototype.delete = Ye, qe.prototype.get = Xe, qe.prototype.has = Ze, qe.prototype.set = Qe;
	function $e(e) {
		var t = -1, n = e == null ? 0 : e.length;
		for (this.clear(); ++t < n;) {
			var r = e[t];
			this.set(r[0], r[1]);
		}
	}
	function et() {
		this.__data__ = [], this.size = 0;
	}
	function tt(e) {
		var t = this.__data__, n = xt(t, e);
		return n < 0 ? !1 : (n == t.length - 1 ? t.pop() : ke.call(t, n, 1), --this.size, !0);
	}
	function nt(e) {
		var t = this.__data__, n = xt(t, e);
		return n < 0 ? void 0 : t[n][1];
	}
	function rt(e) {
		return xt(this.__data__, e) > -1;
	}
	function it(e, t) {
		var n = this.__data__, r = xt(n, e);
		return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
	}
	$e.prototype.clear = et, $e.prototype.delete = tt, $e.prototype.get = nt, $e.prototype.has = rt, $e.prototype.set = it;
	function at(e) {
		var t = -1, n = e == null ? 0 : e.length;
		for (this.clear(); ++t < n;) {
			var r = e[t];
			this.set(r[0], r[1]);
		}
	}
	function ot() {
		this.size = 0, this.__data__ = {
			hash: new qe(),
			map: new (Fe || $e)(),
			string: new qe()
		};
	}
	function st(e) {
		var t = Pt(this, e).delete(e);
		return this.size -= +!!t, t;
	}
	function ct(e) {
		return Pt(this, e).get(e);
	}
	function lt(e) {
		return Pt(this, e).has(e);
	}
	function ut(e, t) {
		var n = Pt(this, e), r = n.size;
		return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
	}
	at.prototype.clear = ot, at.prototype.delete = st, at.prototype.get = ct, at.prototype.has = lt, at.prototype.set = ut;
	function dt(e) {
		var t = -1, n = e == null ? 0 : e.length;
		for (this.__data__ = new at(); ++t < n;) this.add(e[t]);
	}
	function ft(e) {
		return this.__data__.set(e, r), this;
	}
	function pt(e) {
		return this.__data__.has(e);
	}
	dt.prototype.add = dt.prototype.push = ft, dt.prototype.has = pt;
	function mt(e) {
		var t = this.__data__ = new $e(e);
		this.size = t.size;
	}
	function ht() {
		this.__data__ = new $e(), this.size = 0;
	}
	function gt(e) {
		var t = this.__data__, n = t.delete(e);
		return this.size = t.size, n;
	}
	function _t(e) {
		return this.__data__.get(e);
	}
	function vt(e) {
		return this.__data__.has(e);
	}
	function yt(e, t) {
		var r = this.__data__;
		if (r instanceof $e) {
			var i = r.__data__;
			if (!Fe || i.length < n - 1) return i.push([e, t]), this.size = ++r.size, this;
			r = this.__data__ = new at(i);
		}
		return r.set(e, t), this.size = r.size, this;
	}
	mt.prototype.clear = ht, mt.prototype.delete = gt, mt.prototype.get = _t, mt.prototype.has = vt, mt.prototype.set = yt;
	function bt(e, t) {
		var n = Kt(e), r = !n && Gt(e), i = !n && !r && Jt(e), a = !n && !r && !i && en(e), o = n || r || i || a, s = o ? ue(e.length, String) : [], c = s.length;
		for (var l in e) (t || W.call(e, l)) && !(o && (l == "length" || i && (l == "offset" || l == "parent") || a && (l == "buffer" || l == "byteLength" || l == "byteOffset") || zt(l, c))) && s.push(l);
		return s;
	}
	function xt(e, t) {
		for (var n = e.length; n--;) if (Wt(e[n][0], t)) return n;
		return -1;
	}
	function St(e, t, n) {
		var r = t(e);
		return Kt(e) ? r : ce(r, n(e));
	}
	function Ct(e) {
		return e == null ? e === void 0 ? T : _ : Ae && Ae in Object(e) ? It(e) : Ht(e);
	}
	function wt(e) {
		return $t(e) && Ct(e) == s;
	}
	function Tt(e, t, n, r, i) {
		return e === t ? !0 : e == null || t == null || !$t(e) && !$t(t) ? e !== e && t !== t : Et(e, t, n, r, Tt, i);
	}
	function Et(e, t, n, r, a, o) {
		var l = Kt(e), u = Kt(t), d = l ? c : Rt(e), f = u ? c : Rt(t);
		d = d == s ? v : d, f = f == s ? v : f;
		var p = d == v, m = f == v, h = d == f;
		if (h && Jt(e)) {
			if (!Jt(t)) return !1;
			l = !0, p = !1;
		}
		if (h && !p) return o ||= new mt(), l || en(e) ? At(e, t, n, r, a, o) : jt(e, t, d, n, r, a, o);
		if (!(n & i)) {
			var g = p && W.call(e, "__wrapped__"), _ = m && W.call(t, "__wrapped__");
			if (g || _) {
				var y = g ? e.value() : e, b = _ ? t.value() : t;
				return o ||= new mt(), a(y, b, n, r, o);
			}
		}
		return h ? (o ||= new mt(), Mt(e, t, n, r, a, o)) : !1;
	}
	function Dt(e) {
		return !Qt(e) || G(e) ? !1 : (Xt(e) ? we : L).test(Ut(e));
	}
	function Ot(e) {
		return $t(e) && Zt(e.length) && !!z[Ct(e)];
	}
	function kt(e) {
		if (!Vt(e)) return Ne(e);
		var t = [];
		for (var n in Object(e)) W.call(e, n) && n != "constructor" && t.push(n);
		return t;
	}
	function At(e, t, n, r, o, s) {
		var c = n & i, l = e.length, u = t.length;
		if (l != u && !(c && u > l)) return !1;
		var d = s.get(e);
		if (d && s.get(t)) return d == t;
		var f = -1, p = !0, m = n & a ? new dt() : void 0;
		for (s.set(e, t), s.set(t, e); ++f < l;) {
			var h = e[f], g = t[f];
			if (r) var _ = c ? r(g, h, f, t, e, s) : r(h, g, f, e, t, s);
			if (_ !== void 0) {
				if (_) continue;
				p = !1;
				break;
			}
			if (m) {
				if (!le(t, function(e, t) {
					if (!fe(m, t) && (h === e || o(h, e, n, r, s))) return m.push(t);
				})) {
					p = !1;
					break;
				}
			} else if (!(h === g || o(h, g, n, r, s))) {
				p = !1;
				break;
			}
		}
		return s.delete(e), s.delete(t), p;
	}
	function jt(e, t, n, r, o, s, c) {
		switch (n) {
			case O:
				if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
				e = e.buffer, t = t.buffer;
			case D: return !(e.byteLength != t.byteLength || !s(new De(e), new De(t)));
			case u:
			case d:
			case g: return Wt(+e, +t);
			case f: return e.name == t.name && e.message == t.message;
			case x:
			case C: return e == t + "";
			case h: var l = me;
			case S:
				var p = r & i;
				if (l ||= ge, e.size != t.size && !p) return !1;
				var m = c.get(e);
				if (m) return m == t;
				r |= a, c.set(e, t);
				var _ = At(l(e), l(t), r, o, s, c);
				return c.delete(e), _;
			case w: if (Ke) return Ke.call(e) == Ke.call(t);
		}
		return !1;
	}
	function Mt(e, t, n, r, a, o) {
		var s = n & i, c = Nt(e), l = c.length;
		if (l != Nt(t).length && !s) return !1;
		for (var u = l; u--;) {
			var d = c[u];
			if (!(s ? d in t : W.call(t, d))) return !1;
		}
		var f = o.get(e);
		if (f && o.get(t)) return f == t;
		var p = !0;
		o.set(e, t), o.set(t, e);
		for (var m = s; ++u < l;) {
			d = c[u];
			var h = e[d], g = t[d];
			if (r) var _ = s ? r(g, h, d, t, e, o) : r(h, g, d, e, t, o);
			if (!(_ === void 0 ? h === g || a(h, g, n, r, o) : _)) {
				p = !1;
				break;
			}
			m ||= d == "constructor";
		}
		if (p && !m) {
			var v = e.constructor, y = t.constructor;
			v != y && "constructor" in e && "constructor" in t && !(typeof v == "function" && v instanceof v && typeof y == "function" && y instanceof y) && (p = !1);
		}
		return o.delete(e), o.delete(t), p;
	}
	function Nt(e) {
		return St(e, K, Lt);
	}
	function Pt(e, t) {
		var n = e.__data__;
		return Bt(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
	}
	function Ft(e, t) {
		var n = pe(e, t);
		return Dt(n) ? n : void 0;
	}
	function It(e) {
		var t = W.call(e, Ae), n = e[Ae];
		try {
			e[Ae] = void 0;
			var r = !0;
		} catch {}
		var i = Ce.call(e);
		return r && (t ? e[Ae] = n : delete e[Ae]), i;
	}
	var Lt = je ? function(e) {
		return e == null ? [] : (e = Object(e), se(je(e), function(t) {
			return Oe.call(e, t);
		}));
	} : tn, Rt = Ct;
	(Pe && Rt(new Pe(/* @__PURE__ */ new ArrayBuffer(1))) != O || Fe && Rt(new Fe()) != h || Ie && Rt(Ie.resolve()) != y || Le && Rt(new Le()) != S || Re && Rt(new Re()) != E) && (Rt = function(e) {
		var t = Ct(e), n = t == v ? e.constructor : void 0, r = n ? Ut(n) : "";
		if (r) switch (r) {
			case Be: return O;
			case Ve: return h;
			case He: return y;
			case Ue: return S;
			case We: return E;
		}
		return t;
	});
	function zt(e, t) {
		return t ??= o, !!t && (typeof e == "number" || R.test(e)) && e > -1 && e % 1 == 0 && e < t;
	}
	function Bt(e) {
		var t = typeof e;
		return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
	}
	function G(e) {
		return !!Se && Se in e;
	}
	function Vt(e) {
		var t = e && e.constructor;
		return e === (typeof t == "function" && t.prototype || ye);
	}
	function Ht(e) {
		return Ce.call(e);
	}
	function Ut(e) {
		if (e != null) {
			try {
				return xe.call(e);
			} catch {}
			try {
				return e + "";
			} catch {}
		}
		return "";
	}
	function Wt(e, t) {
		return e === t || e !== e && t !== t;
	}
	var Gt = wt(function() {
		return arguments;
	}()) ? wt : function(e) {
		return $t(e) && W.call(e, "callee") && !Oe.call(e, "callee");
	}, Kt = Array.isArray;
	function qt(e) {
		return e != null && Zt(e.length) && !Xt(e);
	}
	var Jt = Me || nn;
	function Yt(e, t) {
		return Tt(e, t);
	}
	function Xt(e) {
		if (!Qt(e)) return !1;
		var t = Ct(e);
		return t == p || t == m || t == l || t == b;
	}
	function Zt(e) {
		return typeof e == "number" && e > -1 && e % 1 == 0 && e <= o;
	}
	function Qt(e) {
		var t = typeof e;
		return e != null && (t == "object" || t == "function");
	}
	function $t(e) {
		return typeof e == "object" && !!e;
	}
	var en = oe ? de(oe) : Ot;
	function K(e) {
		return qt(e) ? bt(e) : kt(e);
	}
	function tn() {
		return [];
	}
	function nn() {
		return !1;
	}
	t.exports = Yt;
})))(), 1), On = "EXPERIENCE_STARTED", kn = "SHOW", An = "STOP_EXPERIENCE", jn = {
	NAVIGATION: "navigation",
	COMPLETED: "completed",
	DISMISSED: "dismissed",
	ERROR: "error"
}, Mn = "EXTENDED_EVENT", Nn = "START_STEP", Pn = "STOP_STEP", Fn = "PAGE_HANDOFF", In = "UPDATE_STEP", Ln = "SET_STEP_CONTAINER_TARGET", Rn = "UPDATE_STEP_CONTENT", zn = "RECOVER_STEP", Bn = "AUTO_RECOVER_STEP", Vn = "PARENT_RECOVER_STEP", Hn = "ERROR", Un = "STEP_INTERACTION", Wn = "STEP_SEEN", Gn = "TARGET_RESOLVED", Kn = "UPDATE_ROOT_STYLE", qn = "RELOAD", Jn = "STEP_STOPPED", Yn = "EXPERIENCE_DISMISSED", Xn = "EXPERIENCE_SNOOZED", Zn = "FORWARD_TO_PARENT", Qn = "TRANSITION_TO_END", $n = "ACTIONS_STARTED", er = "ACTIONS_FINISHED", tr = "experience.begin", nr = "experience.end", rr = "step.prebegin", ir = "step.begin", ar = "step.prerender", or = "step.postrender", sr = "step.end", cr = "step.error", lr = "step.container_change", ur = "RUN_HOOKS", dr = "RUN_HOOKS_DONE", fr = "START_THEME_REMOVAL_LISTENER", pr = "STOP_THEME_REMOVAL_LISTENER", mr = "GLOBAL_CONTAINER_REMOVED", hr = "STEP_CONTAINER_REMOVED", gr = "appcues-experience-container", _r = "APPCUES-EXPERIENCE-CONTAINER", vr = "APPCUES-EXPERIENCE-CONTAINER-BUILDER", yr = "data-appcues-container-id", br = "RUN_TRAITS_DONE", xr = "RUN_TRAITS_ERROR", Sr = "BIND_ACTIONS_ERROR", Cr = window.AppcuesBundleSettings?.VERSION === "dev" ? "https://fast.appcues.com/v1" : window.AppcuesBundleSettings?.GENERIC_BUNDLE_DOMAIN ? `${window.AppcuesBundleSettings.GENERIC_BUNDLE_DOMAIN}/v1` : "https://fast.appcues.com/v1", wr = 9999, Tr = "There is already a key registered with this name", Er = "Key name should be string and callback a valid function", Dr = () => {
	let e = /* @__PURE__ */ new Map(), t = (t) => e.get(t);
	return {
		getCallback: t,
		registerCallback: (n, r) => {
			if (t(n) && console.info(`${Tr}: ${n}, the callback will be replaced by the new one`), typeof n != "string" || typeof r != "function") throw TypeError(Er);
			e.set(n, r);
		}
	};
}, Or = ({ getTrait: e, trait: t, ...n }) => {
	let r = e(t.type);
	r && r(n, t.config ?? {});
}, { getCallback: kr, registerCallback: Y } = Dr(), Ar = {
	pixels: "px",
	percentage: "%"
};
function jr(e, t, n, r) {
	let i = Ar[n] || "px";
	switch (e) {
		case "left": return {
			left: 0,
			transform: `translateX(${t}${i})`,
			...r && { right: "unset" }
		};
		case "center": return {
			left: "50%",
			transform: `translateX(calc(-50% + ${t}${i}))`,
			...r && { right: "unset" }
		};
		default: return {
			right: 0,
			transform: `translateX(-${t}${i})`,
			...r && { left: "unset" }
		};
	}
}
function Mr(e, t, n, r) {
	let i = Ar[n] || "px";
	switch (e) {
		case "top": return {
			top: 0,
			transform: `translateY(${t}${i})`,
			...r && { bottom: "unset" }
		};
		case "center": return {
			top: "50%",
			transform: `translateY(calc(-50% + ${t}${i}))`,
			...r && { bottom: "unset" }
		};
		default: return {
			bottom: 0,
			transform: `translateY(-${t}${i})`,
			...r && { top: "unset" }
		};
	}
}
Y("@appcues/floating", ({ addHook: e }) => {
	e("step.begin", ({ getTraitConfig: e, updateStyle: t, updateRootStyle: n }) => {
		let { target: r, strategy: i = "fixed", xOffset: a = 0, yOffset: o = 0, xPosition: s = "left", yPosition: c = "top", placementUnit: l = "pixels", unsetOppositeDirection: u = !1, applyToRoot: d = !1, clearTransition: f = !1 } = e(), p = {
			position: i,
			...[jr(s, a, l, u), Mr(c, o, l, u)].reduce((e, t) => {
				let { transform: n, ...r } = t;
				return n && (e.transform = e.transform ? `${e.transform} ${n}` : n), {
					...e,
					...r
				};
			}, {}),
			...f ? { transition: "none" } : {}
		};
		if (d) {
			n(p, { forceUpdate: !0 });
			return;
		}
		t(r.selector, p);
	});
});
var Nr = (() => {
	let e = /* @__PURE__ */ new Map(), t = (t) => {
		let { observerInstance: n } = e.get(t);
		if (n) return;
		let r = {
			childList: !0,
			subtree: !0
		}, i = new MutationObserver((...n) => {
			let { callbacks: r } = e.get(t);
			r.forEach((e) => e(...n));
		});
		i.observe(t, r);
		let { callbacks: a } = e.get(t);
		e.set(t, {
			callbacks: a,
			observerInstance: i
		});
	}, n = (t, n) => {
		let r = e.get(t);
		if (r) {
			let { callbacks: i, observerInstance: a } = r, o = i.filter((e) => e !== n);
			if (o.length > 0) {
				e.set(t, {
					callbacks: o,
					observerInstance: a
				});
				return;
			}
			a.disconnect(), e.delete(t);
		}
	};
	return (r, i) => {
		let { callbacks: a = [], observerInstance: o = null } = e.get(r) ?? {};
		return e.set(r, {
			observerInstance: o,
			callbacks: [...a, i]
		}), t(r), () => n(r, i);
	};
})(), Pr = (e, ...t) => {
	t.forEach((t) => e.addEventListener(t, (e) => {
		e.stopPropagation();
	}));
}, Fr = "|shadow-root|", Ir = "|iframe|", Lr = (e, t) => {
	try {
		return e.includes(Fr) || e.includes("|iframe|") ? e.split(Fr).flatMap((e) => e.split("|iframe|")).reduce((e, n) => e === null ? [...t.querySelectorAll(n)] : e.flatMap((e) => e.shadowRoot ? [...e.shadowRoot.querySelectorAll(n)] : e.tagName === "IFRAME" ? [...e.contentDocument.querySelectorAll(n)] : []), null) ?? [] : t.querySelectorAll(e);
	} catch {
		return [];
	}
}, Rr = (e, t) => {
	let n = Lr(e, t);
	return n.length > 0 ? n[0] : null;
}, zr = (e) => `appcues-container-${e}`, Br = (e, t, n) => {
	try {
		if (e.contentDocument && e.contentDocument.body && e.contentDocument.body.children.length > 0) {
			if (n()) return;
			t(e.contentDocument.body);
		} else e.addEventListener("load", () => {
			try {
				let r = e.contentDocument;
				if (!r || !r.body || n()) return;
				t(r.body);
			} catch {}
		}, { once: !0 });
	} catch {}
}, Vr = (e, t) => {
	e.forEach((e) => {
		e.type === "childList" && e.addedNodes.forEach((e) => {
			e.nodeType === 1 && e.tagName === "IFRAME" && t(e);
		});
	});
}, Hr = ({ getTarget: e, onInserted: t, getWindowReference: n }) => {
	let r = n().document, i = [], a = () => {
		i.forEach((e) => e()), i = [];
	}, o = () => {
		let n = e();
		return n.length === 1 ? (t(n[0]), a(), !0) : !1;
	};
	if (o()) return () => {};
	let s = (e) => {
		e.some((e) => e.addedNodes.length > 0) && (Vr(e, (e) => {
			Br(e, (e) => i.push(Nr(e, s)), o);
		}), o());
	};
	i.push(Nr(r.body, s));
	let c, l = r.createNodeIterator(r.body, NodeFilter.SHOW_ELEMENT, (e) => e.shadowRoot && e.nodeName !== "APPCUES-EXPERIENCE-CONTAINER" && e.nodeName !== "APPCUES-EXPERIENCE-CONTAINER-BUILDER" ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT);
	for (; (c = l.nextNode()) !== null;) i.push(Nr(c.shadowRoot, s));
	let u, d = r.createNodeIterator(r.body, NodeFilter.SHOW_ELEMENT, (e) => e.tagName === "IFRAME" ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT);
	for (; (u = d.nextNode()) !== null;) Br(u, (e) => i.push(Nr(e, s)), o);
	return () => a();
}, Ur = ({ getTarget: e, onRemoved: t, getWindowReference: n }) => {
	let r = n().document, [i] = e(), a, o = (n) => {
		if (!n.some((e) => e.removedNodes.length > 0)) return;
		let r = e(), o = i ? r[0] !== i : !1;
		[i] = r, (r.length === 0 || o || !i.isConnected) && (t(), a());
	};
	return a = i && i.getRootNode().nodeType === Node.DOCUMENT_FRAGMENT_NODE ? Nr(i.getRootNode(), o) : Nr(r.body, o), () => a();
}, Wr = (e) => {
	let t = 0;
	for (let n = 0; n < e.length && !(e[n].nodeName !== "APPCUES-EXPERIENCE-CONTAINER" || e[n].nodeName !== "APPCUES-EXPERIENCE-CONTAINER-BUILDER"); n++) t = n;
	return e.slice(t + 1);
}, Gr = (e, t = document) => {
	try {
		let n = e.match(/^((body\s(>?\s?))?)(?<tagName>[\da-z]+):nth-child\((?<index>\d+)\)(?<remainingSelector>.*)/i), r = t.body.firstChild?.nodeName === "APPCUES-EXPERIENCE-CONTAINER" || t.body.firstChild?.nodeName === "APPCUES-EXPERIENCE-CONTAINER-BUILDER";
		if (!n || !r) return [];
		let { tagName: i, index: a, remainingSelector: o } = n.groups, s = Number.parseInt(a, 10) - 1, c = Wr([...t.body.children]), l = c[s]?.nodeName === i.toUpperCase() ? c[s] : null;
		return o ? l ? Lr(`* ${o}`, l) : [] : [l];
	} catch (e) {
		return console.log(e), [];
	}
}, Kr = (e, { step: t, stepContainer: n, checkOutsideContainer: r, getWindowReference: i }) => {
	let a = zr(t.id), o = [];
	if (r) {
		let t = i().document, n = Gr(e, t), r = [...n.length > 0 ? n : Lr(e, t.documentElement)].filter(Boolean);
		r.length > 0 && (o = r);
	}
	if (!n || o.length > 0) return o;
	let s = Rr(`[${yr}=${a}]`, n);
	return s &&= Lr(e, s), s ??= [], [...s];
}, qr = [
	"keypress",
	"keydown",
	"keyup",
	"click",
	"dblclick",
	"input",
	"change",
	"submit"
], Jr = ({ accountId: e, id: t, theme: n, getWindowReference: r }) => {
	let i = r().document.createElement(gr);
	return n && i.setAttribute("themeId", n), i.setAttribute("accountId", e), i.setAttribute("id", zr(t)), Pr(i, ...qr), i;
}, Yr = ({ steps: e }) => Array.isArray(e) && e.length > 0 && e.every((e) => (e?.traits ?? []).some((e) => e?.type === "@appcues/floating" && e?.config?.documentPlacement === "start")), Xr = (e) => ({ context: { experience: t } }) => {
	let { theme: n, themeSystem: r, accountId: i, id: a } = t;
	if (!i) return;
	let o = e("getWindowReference"), s = o().document, c = Jr({
		accountId: i,
		id: a,
		...!r && { theme: n },
		getWindowReference: o
	});
	Yr(t) ? s.body.prepend(c) : s.body.append(c);
}, Zr = (e) => ({ context: { experience: t } }) => {
	let n = e("getWindowReference")().document;
	Lr(`#${zr(t.id)}`, n.documentElement).forEach((e) => n.body.removeChild(e));
}, Qr = ({ getRoot: e }) => {
	let t = e();
	t.parentElement && t.remove();
}, $r = ({ getRoot: e }) => rn(({ enqueue: t, check: n }) => {
	n("hasCustomContainer") && t(() => {
		Qr({ getRoot: e });
	});
}), ei = (e) => Pt(({ sendBack: t, receive: n, input: r }) => {
	let { experience: i } = r;
	n(({ type: n }) => {
		if (n !== "START_THEME_REMOVAL_LISTENER") return;
		let r = e("getWindowReference"), a = r().document, o = zr(i.id);
		Ur({
			getTarget: () => Lr(`#${o}`, a.documentElement),
			onRemoved: () => {
				t({ type: mr });
			},
			getWindowReference: r
		});
	});
}), ti = ({ getRoot: e, getWindowReference: t }) => Pt(({ sendBack: n, receive: r }) => {
	let i;
	r(({ type: r }) => {
		if (r === "STOP_THEME_REMOVAL_LISTENER" && i) {
			i();
			return;
		}
		r === "START_THEME_REMOVAL_LISTENER" && (i && i(), i = Ur({
			getTarget: () => [e()],
			onRemoved: () => {
				n({ type: hr });
			},
			getWindowReference: t
		}));
	});
}), ni = en("themeRemovalService", { type: fr }), ri = en("themeRemovalService", { type: pr }), ii = /* @__PURE__ */ s(((e, t) => {
	(function() {
		function e(e, t, n) {
			return e.call.apply(e.bind, arguments);
		}
		function n(e, t, n) {
			if (!e) throw Error();
			if (2 < arguments.length) {
				var r = Array.prototype.slice.call(arguments, 2);
				return function() {
					var n = Array.prototype.slice.call(arguments);
					return Array.prototype.unshift.apply(n, r), e.apply(t, n);
				};
			}
			return function() {
				return e.apply(t, arguments);
			};
		}
		function r(t, i, a) {
			return r = Function.prototype.bind && Function.prototype.bind.toString().indexOf("native code") != -1 ? e : n, r.apply(null, arguments);
		}
		var i = Date.now || function() {
			return +/* @__PURE__ */ new Date();
		};
		function a(e, t) {
			this.a = e, this.o = t || e, this.c = this.o.document;
		}
		var o = !!window.FontFace;
		function s(e, t, n, r) {
			if (t = e.c.createElement(t), n) for (var i in n) n.hasOwnProperty(i) && (i == "style" ? t.style.cssText = n[i] : t.setAttribute(i, n[i]));
			return r && t.appendChild(e.c.createTextNode(r)), t;
		}
		function c(e, t, n) {
			e = e.c.getElementsByTagName(t)[0], e ||= document.documentElement, e.insertBefore(n, e.lastChild);
		}
		function l(e) {
			e.parentNode && e.parentNode.removeChild(e);
		}
		function u(e, t, n) {
			t ||= [], n ||= [];
			for (var r = e.className.split(/\s+/), i = 0; i < t.length; i += 1) {
				for (var a = !1, o = 0; o < r.length; o += 1) if (t[i] === r[o]) {
					a = !0;
					break;
				}
				a || r.push(t[i]);
			}
			for (t = [], i = 0; i < r.length; i += 1) {
				for (a = !1, o = 0; o < n.length; o += 1) if (r[i] === n[o]) {
					a = !0;
					break;
				}
				a || t.push(r[i]);
			}
			e.className = t.join(" ").replace(/\s+/g, " ").replace(/^\s+|\s+$/, "");
		}
		function d(e, t) {
			for (var n = e.className.split(/\s+/), r = 0, i = n.length; r < i; r++) if (n[r] == t) return !0;
			return !1;
		}
		function f(e) {
			return e.o.location.hostname || e.a.location.hostname;
		}
		function p(e, t, n) {
			function r() {
				u && i && a && (u(l), u = null);
			}
			t = s(e, "link", {
				rel: "stylesheet",
				href: t,
				media: "all"
			});
			var i = !1, a = !0, l = null, u = n || null;
			o ? (t.onload = function() {
				i = !0, r();
			}, t.onerror = function() {
				i = !0, l = Error("Stylesheet failed to load"), r();
			}) : setTimeout(function() {
				i = !0, r();
			}, 0), c(e, "head", t);
		}
		function m(e, t, n, r) {
			var i = e.c.getElementsByTagName("head")[0];
			if (i) {
				var a = s(e, "script", { src: t }), o = !1;
				return a.onload = a.onreadystatechange = function() {
					o || this.readyState && this.readyState != "loaded" && this.readyState != "complete" || (o = !0, n && n(null), a.onload = a.onreadystatechange = null, a.parentNode.tagName == "HEAD" && i.removeChild(a));
				}, i.appendChild(a), setTimeout(function() {
					o || (o = !0, n && n(Error("Script load timeout")));
				}, r || 5e3), a;
			}
			return null;
		}
		function h() {
			this.a = 0, this.c = null;
		}
		function g(e) {
			return e.a++, function() {
				e.a--, v(e);
			};
		}
		function _(e, t) {
			e.c = t, v(e);
		}
		function v(e) {
			e.a == 0 && e.c && (e.c(), e.c = null);
		}
		function y(e) {
			this.a = e || "-";
		}
		y.prototype.c = function(e) {
			for (var t = [], n = 0; n < arguments.length; n++) t.push(arguments[n].replace(/[\W_]+/g, "").toLowerCase());
			return t.join(this.a);
		};
		function b(e, t) {
			this.c = e, this.f = 4, this.a = "n";
			var n = (t || "n4").match(/^([nio])([1-9])$/i);
			n && (this.a = n[1], this.f = parseInt(n[2], 10));
		}
		function x(e) {
			return w(e) + " " + (e.f + "00") + " 300px " + S(e.c);
		}
		function S(e) {
			var t = [];
			e = e.split(/,\s*/);
			for (var n = 0; n < e.length; n++) {
				var r = e[n].replace(/['"]/g, "");
				r.indexOf(" ") != -1 || /^\d/.test(r) ? t.push("'" + r + "'") : t.push(r);
			}
			return t.join(",");
		}
		function C(e) {
			return e.a + e.f;
		}
		function w(e) {
			var t = "normal";
			return e.a === "o" ? t = "oblique" : e.a === "i" && (t = "italic"), t;
		}
		function T(e) {
			var t = 4, n = "n", r = null;
			return e && ((r = e.match(/(normal|oblique|italic)/i)) && r[1] && (n = r[1].substr(0, 1).toLowerCase()), (r = e.match(/([1-9]00|normal|bold)/i)) && r[1] && (/bold/i.test(r[1]) ? t = 7 : /[1-9]00/.test(r[1]) && (t = parseInt(r[1].substr(0, 1), 10)))), n + t;
		}
		function E(e, t) {
			this.c = e, this.f = e.o.document.documentElement, this.h = t, this.a = new y("-"), this.j = !1 !== t.events, this.g = !1 !== t.classes;
		}
		function D(e) {
			e.g && u(e.f, [e.a.c("wf", "loading")]), k(e, "loading");
		}
		function O(e) {
			if (e.g) {
				var t = d(e.f, e.a.c("wf", "active")), n = [], r = [e.a.c("wf", "loading")];
				t || n.push(e.a.c("wf", "inactive")), u(e.f, n, r);
			}
			k(e, "inactive");
		}
		function k(e, t, n) {
			e.j && e.h[t] && (n ? e.h[t](n.c, C(n)) : e.h[t]());
		}
		function A() {
			this.c = {};
		}
		function j(e, t, n) {
			var r = [], i;
			for (i in t) if (t.hasOwnProperty(i)) {
				var a = e.c[i];
				a && r.push(a(t[i], n));
			}
			return r;
		}
		function M(e, t) {
			this.c = e, this.f = t, this.a = s(this.c, "span", { "aria-hidden": "true" }, this.f);
		}
		function N(e) {
			c(e.c, "body", e.a);
		}
		function P(e) {
			return "display:block;position:absolute;top:-9999px;left:-9999px;font-size:300px;width:auto;height:auto;line-height:normal;margin:0;padding:0;font-variant:normal;white-space:nowrap;font-family:" + S(e.c) + ";" + ("font-style:" + w(e) + ";font-weight:" + (e.f + "00") + ";");
		}
		function F(e, t, n, r, i, a) {
			this.g = e, this.j = t, this.a = r, this.c = n, this.f = i || 3e3, this.h = a || void 0;
		}
		F.prototype.start = function() {
			var e = this.c.o.document, t = this, n = i(), r = new Promise(function(r, a) {
				function o() {
					i() - n >= t.f ? a() : e.fonts.load(x(t.a), t.h).then(function(e) {
						1 <= e.length ? r() : setTimeout(o, 25);
					}, function() {
						a();
					});
				}
				o();
			}), a = null, o = new Promise(function(e, n) {
				a = setTimeout(n, t.f);
			});
			Promise.race([o, r]).then(function() {
				a &&= (clearTimeout(a), null), t.g(t.a);
			}, function() {
				t.j(t.a);
			});
		};
		function ee(e, t, n, r, i, a, o) {
			this.v = e, this.B = t, this.c = n, this.a = r, this.s = o || "BESbswy", this.f = {}, this.w = i || 3e3, this.u = a || null, this.m = this.j = this.h = this.g = null, this.g = new M(this.c, this.s), this.h = new M(this.c, this.s), this.j = new M(this.c, this.s), this.m = new M(this.c, this.s), e = new b(this.a.c + ",serif", C(this.a)), e = P(e), this.g.a.style.cssText = e, e = new b(this.a.c + ",sans-serif", C(this.a)), e = P(e), this.h.a.style.cssText = e, e = new b("serif", C(this.a)), e = P(e), this.j.a.style.cssText = e, e = new b("sans-serif", C(this.a)), e = P(e), this.m.a.style.cssText = e, N(this.g), N(this.h), N(this.j), N(this.m);
		}
		var te = {
			D: "serif",
			C: "sans-serif"
		}, I = null;
		function L() {
			if (I === null) {
				var e = /AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent);
				I = !!e && (536 > parseInt(e[1], 10) || parseInt(e[1], 10) === 536 && 11 >= parseInt(e[2], 10));
			}
			return I;
		}
		ee.prototype.start = function() {
			this.f.serif = this.j.a.offsetWidth, this.f["sans-serif"] = this.m.a.offsetWidth, this.A = i(), z(this);
		};
		function R(e, t, n) {
			for (var r in te) if (te.hasOwnProperty(r) && t === e.f[te[r]] && n === e.f[te[r]]) return !0;
			return !1;
		}
		function z(e) {
			var t = e.g.a.offsetWidth, n = e.h.a.offsetWidth, r;
			(r = t === e.f.serif && n === e.f["sans-serif"]) || (r = L() && R(e, t, n)), r ? i() - e.A >= e.w ? L() && R(e, t, n) && (e.u === null || e.u.hasOwnProperty(e.a.c)) ? B(e, e.v) : B(e, e.B) : ne(e) : B(e, e.v);
		}
		function ne(e) {
			setTimeout(r(function() {
				z(this);
			}, e), 50);
		}
		function B(e, t) {
			setTimeout(r(function() {
				l(this.g.a), l(this.h.a), l(this.j.a), l(this.m.a), t(this.a);
			}, e), 0);
		}
		function V(e, t, n) {
			this.c = e, this.a = t, this.f = 0, this.m = this.j = !1, this.s = n;
		}
		var re = null;
		V.prototype.g = function(e) {
			var t = this.a;
			t.g && u(t.f, [t.a.c("wf", e.c, C(e).toString(), "active")], [t.a.c("wf", e.c, C(e).toString(), "loading"), t.a.c("wf", e.c, C(e).toString(), "inactive")]), k(t, "fontactive", e), this.m = !0, H(this);
		}, V.prototype.h = function(e) {
			var t = this.a;
			if (t.g) {
				var n = d(t.f, t.a.c("wf", e.c, C(e).toString(), "active")), r = [], i = [t.a.c("wf", e.c, C(e).toString(), "loading")];
				n || r.push(t.a.c("wf", e.c, C(e).toString(), "inactive")), u(t.f, r, i);
			}
			k(t, "fontinactive", e), H(this);
		};
		function H(e) {
			--e.f == 0 && e.j && (e.m ? (e = e.a, e.g && u(e.f, [e.a.c("wf", "active")], [e.a.c("wf", "loading"), e.a.c("wf", "inactive")]), k(e, "active")) : O(e.a));
		}
		function ie(e) {
			this.j = e, this.a = new A(), this.h = 0, this.f = this.g = !0;
		}
		ie.prototype.load = function(e) {
			this.c = new a(this.j, e.context || this.j), this.g = !1 !== e.events, this.f = !1 !== e.classes, ae(this, new E(this.c, e), e);
		};
		function U(e, t, n, i, a) {
			var o = --e.h == 0;
			(e.f || e.g) && setTimeout(function() {
				var e = a || null, s = i || {};
				if (n.length === 0 && o) O(t.a);
				else {
					t.f += n.length, o && (t.j = o);
					var c, l = [];
					for (c = 0; c < n.length; c++) {
						var d = n[c], f = s[d.c], p = t.a, m = d;
						if (p.g && u(p.f, [p.a.c("wf", m.c, C(m).toString(), "loading")]), k(p, "fontloading", m), p = null, re === null) if (window.FontFace) {
							var m = /Gecko.*Firefox\/(\d+)/.exec(window.navigator.userAgent), h = /OS X.*Version\/10\..*Safari/.exec(window.navigator.userAgent) && /Apple/.exec(window.navigator.vendor);
							re = m ? 42 < parseInt(m[1], 10) : !h;
						} else re = !1;
						p = re ? new F(r(t.g, t), r(t.h, t), t.c, d, t.s, f) : new ee(r(t.g, t), r(t.h, t), t.c, d, t.s, e, f), l.push(p);
					}
					for (c = 0; c < l.length; c++) l[c].start();
				}
			}, 0);
		}
		function ae(e, t, n) {
			var r = [], i = n.timeout;
			D(t);
			var r = j(e.a, n, e.c), a = new V(e.c, t, i);
			for (e.h = r.length, t = 0, n = r.length; t < n; t++) r[t].load(function(t, n, r) {
				U(e, a, t, n, r);
			});
		}
		function oe(e, t) {
			this.c = e, this.a = t;
		}
		oe.prototype.load = function(e) {
			function t() {
				if (a["__mti_fntLst" + r]) {
					var n = a["__mti_fntLst" + r](), i = [], o;
					if (n) for (var s = 0; s < n.length; s++) {
						var c = n[s].fontfamily;
						n[s].fontStyle != null && n[s].fontWeight != null ? (o = n[s].fontStyle + n[s].fontWeight, i.push(new b(c, o))) : i.push(new b(c));
					}
					e(i);
				} else setTimeout(function() {
					t();
				}, 50);
			}
			var n = this, r = n.a.projectId, i = n.a.version;
			if (r) {
				var a = n.c.o;
				m(this.c, (n.a.api || "https://fast.fonts.net/jsapi") + "/" + r + ".js" + (i ? "?v=" + i : ""), function(i) {
					i ? e([]) : (a["__MonotypeConfiguration__" + r] = function() {
						return n.a;
					}, t());
				}).id = "__MonotypeAPIScript__" + r;
			} else e([]);
		};
		function se(e, t) {
			this.c = e, this.a = t;
		}
		se.prototype.load = function(e) {
			var t, n, r = this.a.urls || [], i = this.a.families || [], a = this.a.testStrings || {}, o = new h();
			for (t = 0, n = r.length; t < n; t++) p(this.c, r[t], g(o));
			var s = [];
			for (t = 0, n = i.length; t < n; t++) if (r = i[t].split(":"), r[1]) for (var c = r[1].split(","), l = 0; l < c.length; l += 1) s.push(new b(r[0], c[l]));
			else s.push(new b(r[0]));
			_(o, function() {
				e(s, a);
			});
		};
		function ce(e, t) {
			e ? this.c = e : this.c = le, this.a = [], this.f = [], this.g = t || "";
		}
		var le = "https://fonts.googleapis.com/css";
		function ue(e, t) {
			for (var n = t.length, r = 0; r < n; r++) {
				var i = t[r].split(":");
				i.length == 3 && e.f.push(i.pop());
				var a = "";
				i.length == 2 && i[1] != "" && (a = ":"), e.a.push(i.join(a));
			}
		}
		function de(e) {
			if (e.a.length == 0) throw Error("No fonts to load!");
			if (e.c.indexOf("kit=") != -1) return e.c;
			for (var t = e.a.length, n = [], r = 0; r < t; r++) n.push(e.a[r].replace(/ /g, "+"));
			return t = e.c + "?family=" + n.join("%7C"), 0 < e.f.length && (t += "&subset=" + e.f.join(",")), 0 < e.g.length && (t += "&text=" + encodeURIComponent(e.g)), t;
		}
		function fe(e) {
			this.f = e, this.a = [], this.c = {};
		}
		var pe = {
			latin: "BESbswy",
			"latin-ext": "çöüğş",
			cyrillic: "йяЖ",
			greek: "αβΣ",
			khmer: "កខគ",
			Hanuman: "កខគ"
		}, me = {
			thin: "1",
			extralight: "2",
			"extra-light": "2",
			ultralight: "2",
			"ultra-light": "2",
			light: "3",
			regular: "4",
			book: "4",
			medium: "5",
			"semi-bold": "6",
			semibold: "6",
			"demi-bold": "6",
			demibold: "6",
			bold: "7",
			"extra-bold": "8",
			extrabold: "8",
			"ultra-bold": "8",
			ultrabold: "8",
			black: "9",
			heavy: "9",
			l: "3",
			r: "4",
			b: "7"
		}, he = {
			i: "i",
			italic: "i",
			n: "n",
			normal: "n"
		}, ge = /^(thin|(?:(?:extra|ultra)-?)?light|regular|book|medium|(?:(?:semi|demi|extra|ultra)-?)?bold|black|heavy|l|r|b|[1-9]00)?(n|i|normal|italic)?$/;
		function _e(e) {
			for (var t = e.f.length, n = 0; n < t; n++) {
				var r = e.f[n].split(":"), i = r[0].replace(/\+/g, " "), a = ["n4"];
				if (2 <= r.length) {
					var o, s = r[1];
					if (o = [], s) for (var s = s.split(","), c = s.length, l = 0; l < c; l++) {
						var u = s[l];
						if (u.match(/^[\w-]+$/)) {
							var d = ge.exec(u.toLowerCase());
							if (d == null) u = "";
							else {
								if (u = d[2], u = u == null || u == "" ? "n" : he[u], d = d[1], d == null || d == "") d = "4";
								else var f = me[d], d = f || (isNaN(d) ? "4" : d.substr(0, 1));
								u = [u, d].join("");
							}
						} else u = "";
						u && o.push(u);
					}
					0 < o.length && (a = o), r.length == 3 && (r = r[2], o = [], r = r ? r.split(",") : o, 0 < r.length && (r = pe[r[0]]) && (e.c[i] = r));
				}
				for (e.c[i] || (r = pe[i]) && (e.c[i] = r), r = 0; r < a.length; r += 1) e.a.push(new b(i, a[r]));
			}
		}
		function ve(e, t) {
			this.c = e, this.a = t;
		}
		var ye = {
			Arimo: !0,
			Cousine: !0,
			Tinos: !0
		};
		ve.prototype.load = function(e) {
			var t = new h(), n = this.c, r = new ce(this.a.api, this.a.text), i = this.a.families;
			ue(r, i);
			var a = new fe(i);
			_e(a), p(n, de(r), g(t)), _(t, function() {
				e(a.a, a.c, ye);
			});
		};
		function be(e, t) {
			this.c = e, this.a = t;
		}
		be.prototype.load = function(e) {
			var t = this.a.id, n = this.c.o;
			t ? m(this.c, (this.a.api || "https://use.typekit.net") + "/" + t + ".js", function(t) {
				if (t) e([]);
				else if (n.Typekit && n.Typekit.config && n.Typekit.config.fn) {
					t = n.Typekit.config.fn;
					for (var r = [], i = 0; i < t.length; i += 2) for (var a = t[i], o = t[i + 1], s = 0; s < o.length; s++) r.push(new b(a, o[s]));
					try {
						n.Typekit.load({
							events: !1,
							classes: !1,
							async: !0
						});
					} catch {}
					e(r);
				}
			}, 2e3) : e([]);
		};
		function xe(e, t) {
			this.c = e, this.f = t, this.a = [];
		}
		xe.prototype.load = function(e) {
			var t = this.f.id, n = this.c.o, r = this;
			t ? (n.__webfontfontdeckmodule__ ||= {}, n.__webfontfontdeckmodule__[t] = function(t, n) {
				for (var i = 0, a = n.fonts.length; i < a; ++i) {
					var o = n.fonts[i];
					r.a.push(new b(o.name, T("font-weight:" + o.weight + ";font-style:" + o.style)));
				}
				e(r.a);
			}, m(this.c, (this.f.api || "https://f.fontdeck.com/s/css/js/") + f(this.c) + "/" + t + ".js", function(t) {
				t && e([]);
			})) : e([]);
		};
		var W = new ie(window);
		W.a.c.custom = function(e, t) {
			return new se(t, e);
		}, W.a.c.fontdeck = function(e, t) {
			return new xe(t, e);
		}, W.a.c.monotype = function(e, t) {
			return new oe(t, e);
		}, W.a.c.typekit = function(e, t) {
			return new be(t, e);
		}, W.a.c.google = function(e, t) {
			return new ve(t, e);
		};
		var Se = { load: r(W.load, W) };
		t !== void 0 && t.exports ? t.exports = Se : (window.WebFont = Se, window.WebFontConfig && W.load(window.WebFontConfig));
	})();
})), ai = /* @__PURE__ */ s(((e, t) => {
	function n(e, t) {
		var n = t && t.cache ? t.cache : f, r = t && t.serializer ? t.serializer : u;
		return (t && t.strategy ? t.strategy : s)(e, {
			cache: n,
			serializer: r
		});
	}
	function r(e) {
		return e == null || typeof e == "number" || typeof e == "boolean";
	}
	function i(e, t, n, i) {
		var a = r(i) ? i : n(i), o = t.get(a);
		return o === void 0 && (o = e.call(this, i), t.set(a, o)), o;
	}
	function a(e, t, n) {
		var r = Array.prototype.slice.call(arguments, 3), i = n(r), a = t.get(i);
		return a === void 0 && (a = e.apply(this, r), t.set(i, a)), a;
	}
	function o(e, t, n, r, i) {
		return n.bind(t, e, r, i);
	}
	function s(e, t) {
		var n = e.length === 1 ? i : a;
		return o(e, this, n, t.cache.create(), t.serializer);
	}
	function c(e, t) {
		var n = a;
		return o(e, this, n, t.cache.create(), t.serializer);
	}
	function l(e, t) {
		var n = i;
		return o(e, this, n, t.cache.create(), t.serializer);
	}
	function u() {
		return JSON.stringify(arguments);
	}
	function d() {
		this.cache = Object.create(null);
	}
	d.prototype.has = function(e) {
		return e in this.cache;
	}, d.prototype.get = function(e) {
		return this.cache[e];
	}, d.prototype.set = function(e, t) {
		this.cache[e] = t;
	};
	var f = { create: function() {
		return new d();
	} };
	t.exports = n, t.exports.strategies = {
		variadic: c,
		monadic: l
	};
})), oi = /* @__PURE__ */ u(ii(), 1), si = /* @__PURE__ */ u(ai(), 1), ci = {
	fastBaseUrl: null,
	useAssetsPath: !1
}, li = (e = {}) => {
	ci = {
		...ci,
		...e
	};
}, ui = () => ci.fastBaseUrl ?? Cr, di = () => ci.useAssetsPath;
//#endregion
//#region src/lib/url.js
function fi(e) {
	return e.replace(/\/+$/, "");
}
//#endregion
//#region src/api.js
var pi = (0, si.default)((e, t) => {
	let n = ui();
	if (di()) {
		let t = fi(n);
		return fetch(`${t}/themes/${encodeURIComponent(e)}.json`).then((e) => e.json());
	}
	return fetch(`${n}/accounts/${t}/styles/${e}`).then((e) => e.json());
}, { serializer: ([e, t]) => `${e}:${t}:${di()}` }), mi = (e, t) => {
	let n = { classes: !1 };
	t != null && (n.custom = { urls: [t.general.headerFontUrl, t.general.bodyFontUrl] }), e && (n.typekit = { id: e }), Object.keys(n).length > 1 && oi.default.load(n);
}, hi = (e, t, n) => {
	if (!e) return;
	let r = (n.ownerDocument || document).createElement("style");
	r.innerHTML = `${e}`, t && r.classList.add(`theme-${t}`), n.shadowRoot.prepend(r);
}, gi = async (e) => {
	let t = e.getAttribute("themeId"), { globalStyling: n, theme: r, typekitId: i } = await pi(t, e.getAttribute("accountId")).catch(() => {}) ?? {
		globalStyling: "",
		theme: {},
		typekitId: ""
	};
	mi(r?.json?.typekitId ?? i, r?.json), hi(r?.css, t, e), hi(n, t, e);
}, _i = async (e, t) => {
	await gi(e), t && e.shadowRoot.querySelectorAll(`.theme-${t}`).forEach((e) => e.remove());
}, vi = G({ step: ({ context: { step: e }, event: t }) => ({
	...e,
	virtualizedContent: t.virtualizedContent
}) }), yi = (e) => G({ step: ({ event: t }) => ({
	stepConfig: t.stepConfig,
	virtualizedContent: e(t.stepConfig)
}) }), bi = G({
	experience: ({ event: e }) => e.experience,
	step: ({ context: { step: e }, event: t }) => ({
		...e,
		...t.stepConfig
	})
}), xi = K({ type: On }), Si = K(({ context: { step: e, stopReason: t } }) => ({
	type: Jn,
	id: e.id,
	reason: t
})), Ci = ({ event: { styles: e, getRoot: t } }) => {
	let n = t();
	n && Object.entries(e).forEach(([e, t]) => {
		e.startsWith("--") ? n.style.setProperty(e, t) : n.style[e] = t;
	});
}, wi = (e) => ({ context: t }) => {
	let { theme: n, themeSystem: r, id: i } = t.experience;
	if (r || !n) return;
	let a = e("getWindowReference")().document.documentElement.querySelector(`#${zr(i)}`), o = a.getAttribute("themeId");
	a?.setAttribute("themeId", n), _i(a, o);
}, Ti = (e) => G({ step: ({ context: { step: t } }) => {
	if (t.type !== "tooltip" || t.contentType === "application/json") return t;
	let n = Object.entries(t.actions).filter(([, e]) => e.find((e) => e.on === "click")).map(([e]) => e), r = t.traits.filter(({ config: e }) => e.targetId).map(({ config: e }) => e.targetId);
	return {
		...t,
		virtualizedContent: e(t, {
			interactiveEls: n,
			focusableEls: r
		})
	};
} }), Ei = rn(({ enqueue: e, event: t }) => {
	t.errorEvent?.type === "STEP_CONTAINER_REMOVED" && e.raise({
		type: Bn,
		isAutoRecoverEvent: !0
	});
}), Di = G({ actionsRunning: !0 }), Oi = G({ actionsRunning: !1 }), ki = ({ event: e }) => {
	let t = e.changedExperienceTraits && e.changedExperienceTraits.changedTraits.length > 0, n = e.changedExperienceTraits && (e.changedExperienceTraits.addedTraits.length > 0 || e.changedExperienceTraits.removedTraits.length > 0), r = e.changedStepTraits && e.changedStepTraits.changedTraits.length > 0, i = e.changedStepTraits && (e.changedStepTraits.addedTraits.length > 0 || e.changedStepTraits.removedTraits.length > 0);
	return n || i ? !1 : !!(t || r);
}, Ai = (e = 21) => crypto.getRandomValues(new Uint8Array(e)).reduce((e, t) => (t &= 63, t < 36 ? e += t.toString(36) : t < 62 ? e += (t - 26).toString(36).toUpperCase() : t > 62 ? e += "-" : e += "_", e), ""), ji = (e, t) => {
	if (!e?.localized) return e;
	let { localized: n, ...r } = e, i = Object.entries(t && n[t] || {}).filter(([, e]) => e !== "");
	return {
		...r,
		...Object.fromEntries(i)
	};
}, Mi = (e) => e?.context?.locale_id, Ni = ({ experience: e, callback: t, step: n, findId: r, getContainer: i, getWindowReference: a, sendToExperience: o }) => {
	let s = (e, { forwardToParent: r = !1 } = {}) => {
		let s = ({ type: e, ...n }) => t(r ? {
			...n,
			eventType: e,
			type: Zn
		} : {
			type: e,
			...n
		}), c = (e) => r && o ? o(e) : s(e);
		return {
			querySelector: (e) => Kr(e, {
				step: n,
				checkOutsideContainer: !1,
				stepContainer: i(),
				getWindowReference: a
			}),
			start: () => c({
				type: Nn,
				id: e.id
			}),
			stop: (t, n) => {
				c({
					type: Pn,
					id: e.id,
					onStopped: t,
					reason: n
				});
			},
			setStepContainerTarget: (t) => {
				s({
					type: Ln,
					id: e.id,
					container: t
				});
			},
			recover: ({ errorId: t }) => {
				s({
					type: zn,
					id: e.id,
					errorId: t
				});
			},
			dismissExperience: () => s({ type: Yn }),
			snoozeExperience: () => s({ type: Xn }),
			seen: () => s({
				type: Wn,
				id: e.id
			}),
			targetResolved: (t) => s({
				...t,
				type: Gn,
				id: e.id
			}),
			getConfig: () => e,
			interaction: (t, n) => s({
				type: Un,
				id: e.id,
				interactionType: t,
				interactionData: n
			}),
			extendedEvent: (t, n) => s({
				type: Mn,
				id: e.id,
				name: t,
				...n
			})
		};
	}, c = e.steps.map((e) => s(e, { forwardToParent: !!n }));
	return n ? {
		getRootNodeId: () => r(n.virtualizedContent),
		steps: c,
		step: s(n, { forwardToParent: !1 })
	} : {
		getRootNodeId: () => r(n.virtualizedContent),
		steps: c
	};
}, Pi = ({ experience: e, step: t, overrideStyle: n, getContainer: r, getRoot: i, callback: a, get: o, getAction: s = () => null, handleNavigation: c }) => {
	let { findId: l } = o("vNodeHandlers"), u = o("getWindowReference"), d = o("getExperienceSend"), f = Ni({
		experience: e,
		step: t,
		callback: a,
		findId: l,
		getContainer: r,
		getWindowReference: u,
		sendToExperience: typeof d == "function" ? d(e.id) : void 0
	}), p = (e, t) => {
		let n = Ai();
		return console.info("error reported:", e), a({
			...t,
			type: Hn,
			message: e,
			errorId: n
		}), n;
	}, m = () => a({ type: An }), h = () => e.id, g = {
		getContainer: r,
		querySelector: (e) => Kr(e, {
			step: t,
			checkOutsideContainer: !0,
			stepContainer: r(),
			getWindowReference: u
		}),
		reportError: p,
		onElementInserted: (e) => Hr({
			...e,
			getWindowReference: u
		}),
		onElementRemoved: (e) => Ur({
			...e,
			getWindowReference: u
		}),
		...f,
		stopExperience: m,
		getExperienceId: h,
		getLocaleId: () => Mi(e),
		getWindowReference: u,
		sendEvent: o("sendEvent"),
		sendCustomEvent: o("sendCustomEvent"),
		showFlow: (t) => o("showFlow")({
			campaignId: e.campaignId ?? null,
			tacticId: e.tacticId ?? null,
			...t
		}),
		updateUserProfile: o("updateUserProfile"),
		getUserProfile: () => {
			let e = o("getUserProfile");
			return typeof e == "function" ? e() ?? {} : {};
		},
		handleNavigation: (() => {
			let n = (n) => c({
				...ji(n, Mi(e)),
				experienceId: e.id,
				stepId: t.id,
				campaignId: e.campaignId ?? null,
				tacticId: e.tacticId ?? null
			});
			return typeof c == "function" && (n.doesLocationMatch = c.doesLocationMatch, n.armWaitForUrl = (t) => {
				typeof c.armWaitForUrl == "function" && c.armWaitForUrl({
					experienceId: e.id,
					campaignId: e.campaignId ?? null,
					tacticId: e.tacticId ?? null,
					...t
				});
			}), n;
		})(),
		getAction: (n) => s(`${e.id}.${n}`) ?? s(`${t.id}.${n}`) ?? s(n)
	};
	return n ? {
		updateStyle: (e, r) => {
			n(e, r), a({
				type: In,
				id: t.id
			});
		},
		updateRootStyle: (e, t = {}) => {
			a({
				type: Kn,
				styles: e,
				options: t,
				getRoot: i
			});
		},
		...g
	} : g;
}, Fi = "formData.", Ii = "a, button, video, input, textarea, select, form", Li = (e, t, n = () => window) => {
	if (t.startsWith(Fi)) {
		let r = t.replace(Fi, ""), { FormData: i } = n(), a = new i(e.target).getAll(r);
		return a.length > 1 ? JSON.stringify(a) : a[0];
	}
	return xn(e, t);
}, { getCallback: Ri, registerCallback: zi } = Dr(), Bi = (e, t, n, r) => {
	let i = {
		target: t.target,
		detail: t.detail
	};
	return Object.entries(e).reduce((e, [t, n]) => {
		let a = Li(i, t, r);
		return a ? yn(e, n, a) : e;
	}, n);
}, Vi = ({ step: e, experience: t, overrideStyle: n, getContainer: r, callback: i, get: a }) => {
	let o = a("getWindowReference"), s = [], c = [], l = (e) => {
		try {
			return [...Lr(e, o().document.documentElement)];
		} catch {
			return [];
		}
	}, u = (c, l) => {
		if (c.length === 0) return;
		let u = {};
		l.forEach(({ on: n, type: r, config: i, allowedKeys: a, mapEventToConfig: o }) => {
			if (!i?.external || n.startsWith("hooks/")) return;
			let s = Ri(`${t.id}.${r}`) ?? Ri(`${e.id}.${r}`) ?? Ri(r);
			u[n] || (u[n] = []), s && u[n].push([
				s,
				ji(i, Mi(t)),
				a,
				o
			]);
		}), Object.entries(u).forEach(([l, u]) => {
			let d = (s) => {
				i({ type: $n });
				let c = Pi({
					experience: t,
					step: e,
					overrideStyle: n,
					getContainer: r,
					callback: i,
					get: a,
					getAction: Ri
				});
				try {
					u.forEach(([e, t, n, r]) => {
						n && !n.includes(s.code) || e(r ? {
							...t,
							...Bi(r, s, t, o)
						} : t, c, s);
					});
				} catch {
					c.reportError("something bad happened while running an action.");
				} finally {
					i({ type: er });
				}
			};
			c.forEach((e) => {
				e.addEventListener(l, d), s.push({
					el: e,
					event: l,
					handler: d
				});
			});
		});
	};
	return Object.entries(e.actions ?? {}).forEach(([e, t]) => {
		if (!t.some((e) => e.config?.external)) return;
		let n = l(e);
		if (n.length > 0) {
			u(n, t);
			return;
		}
		let r = Hr({
			getTarget: () => l(e),
			onInserted: () => {
				u(l(e), t);
			},
			getWindowReference: o
		});
		c.push(r);
	}), () => {
		s.forEach(({ el: e, event: t, handler: n }) => e.removeEventListener(t, n)), c.forEach((e) => e());
	};
}, Hi = ({ overrideStyle: e, getContainer: t }, n) => Pt(({ sendBack: r, receive: i }) => {
	let a = () => {};
	return i(({ type: i, step: o, experience: s }) => {
		if (i === "RUN_TRAITS_DONE") {
			a();
			try {
				let { findId: i, traverseTree: c, injectHandlers: l } = n("vNodeHandlers"), u = n("getWindowReference"), d = JSON.parse(JSON.stringify(o.virtualizedContent));
				c(d, (a) => {
					let c = i(a);
					if (!o.actions[c]) return;
					let d = {}, f = (i, a) => {
						r({ type: $n });
						let c = Pi({
							experience: s,
							step: o,
							overrideStyle: e,
							getContainer: t,
							callback: r,
							get: n,
							getAction: Ri,
							handleNavigation: n("handleNavigation")
						});
						try {
							d[i].forEach(([e, t, n]) => {
								e(n && a ? {
									...t,
									...Bi(n, a, t, u)
								} : t, c, a);
							});
						} catch {
							c.reportError("something bad happened while running an action.");
						} finally {
							r({ type: er });
						}
					}, p = {}, m = o.actions[c].reduce((e, { on: t, type: n, config: r, allowedKeys: i, mapEventToConfig: a, guardInteractiveChildren: c }) => {
						c && (p[t] = !0);
						let l = Ri(`${s.id}.${n}`) ?? Ri(`${o.id}.${n}`) ?? Ri(n);
						return d[t] || (d[t] = []), l && d[t].push([
							l,
							ji(r, Mi(s)),
							a
						]), t.startsWith("hooks/") ? e.hook[t.replace("hooks/", "")] = () => f(t) : e.on[t] = (e) => {
							if (!(i && !i.includes(e.code))) {
								if (p[t]) {
									let t = e.target.closest(Ii);
									if (t && t !== e.currentTarget) return;
								}
								t === "click" && e.currentTarget?.type === "submit" && e.currentTarget?.form || e.preventDefault(), e.stopPropagation(), f(t, e);
							}
						}, e;
					}, {
						on: {},
						hook: {}
					});
					a = l(a, m);
				}), r({
					type: Rn,
					virtualizedContent: d
				}), a = Vi({
					step: o,
					experience: s,
					overrideStyle: e,
					getContainer: t,
					callback: r,
					get: n
				});
			} catch (e) {
				console.error("[actions service] Error binding actions:", e), r({ type: Sr });
			}
		}
	}), () => a();
}), Ui = ({ addHook: e }) => Pt(({ sendBack: t, input: n }) => {
	let { step: r } = n;
	try {
		r.traits.forEach((t) => Or({
			getTrait: kr,
			addHook: (n, r) => {
				e(n, {
					callback: r,
					traitId: t.id
				});
			},
			registerAction: (e, n) => {
				zi(`${r.id}.${t.type}.${e}`, n);
			},
			trait: t
		})), t({ type: br });
	} catch {
		t({ type: xr });
	}
}), Wi = "@appcues/navigation", Gi = "waitForUrl";
function Ki(e) {
	return typeof e == "string" && e.startsWith("Target got removed");
}
function qi(e) {
	let t = e?.traits?.find((e) => e?.type === Wi);
	return t?.config?.type !== Gi || !t.config.urlPattern ? null : t.config;
}
function Ji(e, t) {
	let n = e?.steps;
	if (!Array.isArray(n) || t?.id == null) return {
		currentWaitUrl: null,
		nextWaitUrl: null
	};
	let r = n.findIndex((e) => e?.id === t.id), i = r >= 0 ? n[r + 1] : void 0;
	return {
		currentWaitUrl: qi(t)?.urlPattern ?? null,
		nextWaitUrl: qi(i)?.urlPattern ?? null
	};
}
//#endregion
//#region src/core/lib/overrides.js
var Yi = ({ applyOverridesToVnode: e }) => {
	let t = {}, n = (e) => (n, r) => {
		t[n] || (t[n] = {}), t[n][e] || (t[n][e] = {}), t[n][e] = {
			...t[n][e],
			...r
		};
	}, r = (e) => t[e];
	return {
		createOverrideCallback: n,
		getOverrides: r,
		applyOverrides: G(({ context: { step: t } }) => ({ step: {
			...t,
			virtualizedContent: e(t.virtualizedContent, r)
		} })),
		clearOverrides: () => {
			t = {};
		}
	};
};
//#endregion
//#region ../../node_modules/snabbdom/build/htmldomapi.js
function Xi(e, t) {
	return document.createElement(e, t);
}
function Zi(e, t, n) {
	return document.createElementNS(e, t, n);
}
function Qi() {
	return pa(document.createDocumentFragment());
}
function $i(e) {
	return document.createTextNode(e);
}
function ea(e) {
	return document.createComment(e);
}
function ta(e, t, n) {
	if (fa(e)) {
		let t = e;
		for (; t && fa(t);) t = pa(t).parent;
		e = t ?? e;
	}
	fa(t) && (t = pa(t, e)), n && fa(n) && (n = pa(n).firstChildNode), e.insertBefore(t, n);
}
function na(e, t) {
	e.removeChild(t);
}
function ra(e, t) {
	fa(t) && (t = pa(t, e)), e.appendChild(t);
}
function ia(e) {
	if (fa(e)) {
		for (; e && fa(e);) e = pa(e).parent;
		return e ?? null;
	}
	return e.parentNode;
}
function aa(e) {
	if (fa(e)) {
		let t = pa(e), n = ia(t);
		if (n && t.lastChildNode) {
			let e = Array.from(n.childNodes);
			return e[e.indexOf(t.lastChildNode) + 1] ?? null;
		}
		return null;
	}
	return e.nextSibling;
}
function oa(e) {
	return e.tagName;
}
function sa(e, t) {
	e.textContent = t;
}
function ca(e) {
	return e.textContent;
}
function la(e) {
	return e.nodeType === 1;
}
function ua(e) {
	return e.nodeType === 3;
}
function da(e) {
	return e.nodeType === 8;
}
function fa(e) {
	return e.nodeType === 11;
}
function pa(e, t) {
	let n = e;
	return n.parent ??= t ?? null, n.firstChildNode ??= e.firstChild, n.lastChildNode ??= e.lastChild, n;
}
var ma, ha = o((() => {
	ma = {
		createElement: Xi,
		createElementNS: Zi,
		createTextNode: $i,
		createDocumentFragment: Qi,
		createComment: ea,
		insertBefore: ta,
		removeChild: na,
		appendChild: ra,
		parentNode: ia,
		nextSibling: aa,
		tagName: oa,
		setTextContent: sa,
		getTextContent: ca,
		isElement: la,
		isText: ua,
		isComment: da,
		isDocumentFragment: fa
	};
}));
//#endregion
//#region ../../node_modules/snabbdom/build/vnode.js
function X(e, t, n, r, i) {
	return {
		sel: e,
		data: t,
		children: n,
		text: r,
		elm: i,
		key: t === void 0 ? void 0 : t.key
	};
}
var ga = o((() => {}));
//#endregion
//#region ../../node_modules/snabbdom/build/is.js
function _a(e) {
	return typeof e == "string" || typeof e == "number" || e instanceof String || e instanceof Number;
}
var va, ya = o((() => {
	va = Array.isArray;
}));
//#endregion
//#region ../../node_modules/snabbdom/build/init.js
function ba(e, t) {
	let n = e.key === t.key, r = e.data?.is === t.data?.is, i = e.sel === t.sel, a = !e.sel && e.sel === t.sel ? typeof e.text == typeof t.text : !0;
	return i && n && r && a;
}
function xa() {
	throw Error("The document fragment is not supported on this platform.");
}
function Sa(e, t) {
	return e.isElement(t);
}
function Ca(e, t) {
	return e.isDocumentFragment(t);
}
function wa(e, t, n) {
	let r = {};
	for (let i = t; i <= n; ++i) {
		let t = e[i]?.key;
		t !== void 0 && (r[t] = i);
	}
	return r;
}
function Ta(e, t, n) {
	let r = {
		create: [],
		update: [],
		remove: [],
		destroy: [],
		pre: [],
		post: []
	}, i = t === void 0 ? ma : t;
	for (let t of Da) for (let n of e) {
		let e = n[t];
		e !== void 0 && r[t].push(e);
	}
	function a(e) {
		let t = e.id ? "#" + e.id : "", n = e.getAttribute("class"), r = n ? "." + n.split(" ").join(".") : "";
		return X(i.tagName(e).toLowerCase() + t + r, {}, [], void 0, e);
	}
	function o(e) {
		return X(void 0, {}, [], void 0, e);
	}
	function s(e, t) {
		return function() {
			if (--t === 0) {
				let t = i.parentNode(e);
				t !== null && i.removeChild(t, e);
			}
		};
	}
	function c(e, t) {
		var a, o;
		let s, l = e.data, u = l?.hook;
		(a = u?.init) == null || a.call(u, e);
		let d = e.children, f = e.sel;
		if (f === "!") e.text ??= "", e.elm = i.createComment(e.text);
		else if (f === "") e.elm = i.createTextNode(e.text);
		else if (f !== void 0) {
			let n = f.indexOf("#"), a = f.indexOf(".", n), p = n > 0 ? n : f.length, m = a > 0 ? a : f.length, h = n !== -1 || a !== -1 ? f.slice(0, Math.min(p, m)) : f, g = l?.ns, _ = g === void 0 ? i.createElement(h, l) : i.createElementNS(g, h, l);
			for (e.elm = _, p < m && _.setAttribute("id", f.slice(p + 1, m)), a > 0 && _.setAttribute("class", f.slice(m + 1).replace(/\./g, " ")), s = 0; s < r.create.length; ++s) r.create[s](Ea, e);
			if (_a(e.text) && (!va(d) || d.length === 0) && i.appendChild(_, i.createTextNode(e.text)), va(d)) for (s = 0; s < d.length; ++s) {
				let e = d[s];
				e != null && i.appendChild(_, c(e, t));
			}
			u !== void 0 && ((o = u.create) == null || o.call(u, Ea, e), u.insert !== void 0 && t.push(e));
		} else if (n?.experimental?.fragments && e.children) {
			for (e.elm = (i.createDocumentFragment ?? xa)(), s = 0; s < r.create.length; ++s) r.create[s](Ea, e);
			for (s = 0; s < e.children.length; ++s) {
				let n = e.children[s];
				n != null && i.appendChild(e.elm, c(n, t));
			}
		} else e.elm = i.createTextNode(e.text);
		return e.elm;
	}
	function l(e, t, n, r, a, o) {
		for (; r <= a; ++r) {
			let a = n[r];
			a != null && i.insertBefore(e, c(a, o), t);
		}
	}
	function u(e) {
		var t, n;
		let i = e.data;
		if (i !== void 0) {
			(n = (t = i?.hook)?.destroy) == null || n.call(t, e);
			for (let t = 0; t < r.destroy.length; ++t) r.destroy[t](e);
			if (e.children !== void 0) for (let t = 0; t < e.children.length; ++t) {
				let n = e.children[t];
				n != null && typeof n != "string" && u(n);
			}
		}
	}
	function d(e, t, n, a) {
		for (; n <= a; ++n) {
			let a, o = t[n];
			if (o != null) if (o.sel !== void 0) {
				u(o), a = r.remove.length + 1;
				let e = s(o.elm, a);
				for (let t = 0; t < r.remove.length; ++t) r.remove[t](o, e);
				let t = o?.data?.hook?.remove;
				t === void 0 ? e() : t(o, e);
			} else o.children ? (u(o), d(e, o.children, 0, o.children.length - 1)) : i.removeChild(e, o.elm);
		}
	}
	function f(e, t, n, r) {
		let a = 0, o = 0, s = t.length - 1, u = t[0], f = t[s], m = n.length - 1, h = n[0], g = n[m], _, v, y, b;
		for (; a <= s && o <= m;) u == null ? u = t[++a] : f == null ? f = t[--s] : h == null ? h = n[++o] : g == null ? g = n[--m] : ba(u, h) ? (p(u, h, r), u = t[++a], h = n[++o]) : ba(f, g) ? (p(f, g, r), f = t[--s], g = n[--m]) : ba(u, g) ? (p(u, g, r), i.insertBefore(e, u.elm, i.nextSibling(f.elm)), u = t[++a], g = n[--m]) : ba(f, h) ? (p(f, h, r), i.insertBefore(e, f.elm, u.elm), f = t[--s], h = n[++o]) : (_ === void 0 && (_ = wa(t, a, s)), v = _[h.key], v === void 0 ? (i.insertBefore(e, c(h, r), u.elm), h = n[++o]) : _[g.key] === void 0 ? (i.insertBefore(e, c(g, r), i.nextSibling(f.elm)), g = n[--m]) : (y = t[v], y.sel === h.sel ? (p(y, h, r), t[v] = void 0, i.insertBefore(e, y.elm, u.elm)) : i.insertBefore(e, c(h, r), u.elm), h = n[++o]));
		o <= m && (b = n[m + 1] == null ? null : n[m + 1].elm, l(e, b, n, o, m, r)), a <= s && d(e, t, a, s);
	}
	function p(e, t, n) {
		var a, o, s, c;
		let u = t.data?.hook;
		(a = u?.prepatch) == null || a.call(u, e, t);
		let p = t.elm = e.elm;
		if (e === t) return;
		if (t.data !== void 0 || t.text !== void 0 && t.text !== e.text) {
			t.data ??= {}, e.data ??= {};
			for (let n = 0; n < r.update.length; ++n) r.update[n](e, t);
			(s = (o = t.data?.hook)?.update) == null || s.call(o, e, t);
		}
		let m = e.children, h = t.children;
		t.text === void 0 ? m !== void 0 && h !== void 0 ? m !== h && f(p, m, h, n) : h === void 0 ? m === void 0 ? e.text !== void 0 && i.setTextContent(p, "") : d(p, m, 0, m.length - 1) : (e.text !== void 0 && i.setTextContent(p, ""), l(p, null, h, 0, h.length - 1, n)) : e.text !== t.text && (m !== void 0 && d(p, m, 0, m.length - 1), i.setTextContent(p, t.text)), (c = u?.postpatch) == null || c.call(u, e, t);
	}
	return function(e, t) {
		let n, s, l, u = [];
		for (n = 0; n < r.pre.length; ++n) r.pre[n]();
		for (Sa(i, e) ? e = a(e) : Ca(i, e) && (e = o(e)), ba(e, t) ? p(e, t, u) : (s = e.elm, l = i.parentNode(s), c(t, u), l !== null && (i.insertBefore(l, t.elm, i.nextSibling(s)), d(l, [e], 0, 0))), n = 0; n < u.length; ++n) u[n].data.hook.insert(u[n]);
		for (n = 0; n < r.post.length; ++n) r.post[n]();
		return t;
	};
}
var Ea, Da, Oa = o((() => {
	ga(), ya(), ha(), Ea = X("", {}, [], void 0, void 0), Da = [
		"create",
		"update",
		"remove",
		"destroy",
		"pre",
		"post"
	];
}));
//#endregion
//#region ../../node_modules/snabbdom/build/h.js
function ka(e, t, n) {
	if (e.ns = "http://www.w3.org/2000/svg", n !== "foreignObject" && t !== void 0) for (let e = 0; e < t.length; ++e) {
		let n = t[e];
		if (typeof n == "string") continue;
		let r = n.data;
		r !== void 0 && ka(r, n.children, n.sel);
	}
}
function Aa(e, t, n) {
	let r = {}, i, a, o;
	if (n === void 0 ? t != null && (va(t) ? i = t : _a(t) ? a = t.toString() : t && t.sel ? i = [t] : r = t) : (t !== null && (r = t), va(n) ? i = n : _a(n) ? a = n.toString() : n && n.sel && (i = [n])), i !== void 0) for (o = 0; o < i.length; ++o) _a(i[o]) && (i[o] = X(void 0, void 0, void 0, i[o], void 0));
	return e.startsWith("svg") && (e.length === 3 || e[3] === "." || e[3] === "#") && ka(r, i, e), X(e, r, i, a, void 0);
}
function ja(e) {
	let t, n;
	if (va(e) ? t = e : _a(t) ? n = e : t && t.sel && (t = [e]), t !== void 0) for (let e = 0; e < t.length; ++e) _a(t[e]) && (t[e] = X(void 0, void 0, void 0, t[e], void 0));
	return X(void 0, {}, t, n, void 0);
}
var Ma = o((() => {
	ga(), ya();
}));
//#endregion
//#region ../../node_modules/snabbdom/build/thunk.js
function Na(e, t) {
	let n = t.data?.ns;
	e.data.fn = t.data.fn, e.data.args = t.data.args, t.data = e.data, t.children = e.children, t.text = e.text, t.elm = e.elm, n && ka(t.data, t.children, t.sel);
}
function Pa(e) {
	let t = e.data;
	Na(t.fn(...t.args), e);
}
function Fa(e, t) {
	let n, r = e.data, i = t.data, a = r.args, o = i.args;
	if (r.fn !== i.fn || a.length !== o.length) {
		Na(i.fn(...o), t);
		return;
	}
	for (n = 0; n < o.length; ++n) if (a[n] !== o[n]) {
		Na(i.fn(...o), t);
		return;
	}
	Na(e, t);
}
var Ia, La = o((() => {
	Ma(), Ia = function(e, t, n, r) {
		return r === void 0 && (r = n, n = t, t = void 0), Aa(e, {
			key: t,
			hook: {
				init: Pa,
				prepatch: Fa
			},
			fn: n,
			args: r
		});
	};
}));
//#endregion
//#region ../../node_modules/snabbdom/build/helpers/attachto.js
function Ra(e, t) {
	let n = e.data.attachData;
	t.data.attachData.placeholder = n.placeholder, t.data.attachData.real = n.real, e.elm = e.data.attachData.real;
}
function za(e, t) {
	t.elm = t.data.attachData.placeholder;
}
function Ba(e) {
	e.elm !== void 0 && e.elm.parentNode.removeChild(e.elm), e.elm = e.data.attachData.real;
}
function Va(e, t) {
	let n = t.elm, r = t.data.attachData, i = document.createElement("span");
	t.elm = i, r.target.appendChild(n), r.real = n, r.placeholder = i;
}
function Ha(e, t) {
	t.data === void 0 && (t.data = {}), t.data.hook === void 0 && (t.data.hook = {});
	let n = t.data, r = t.data.hook;
	return n.attachData = {
		target: e,
		placeholder: void 0,
		real: void 0
	}, r.create = Va, r.prepatch = Ra, r.postpatch = za, r.destroy = Ba, t;
}
var Ua = o((() => {}));
//#endregion
//#region ../../node_modules/snabbdom/build/tovnode.js
function Wa(e) {
	return e.slice(5).replace(/-([a-z])/g, (e, t) => t.toUpperCase());
}
function Ga(e, t) {
	let n = t === void 0 ? ma : t, r;
	if (n.isElement(e)) {
		let r = e.id ? "#" + e.id : "", i = e.getAttribute("class")?.match(/[^\t\r\n\f ]+/g), a = i ? "." + i.join(".") : "", o = n.tagName(e).toLowerCase() + r + a, s = {}, c = {}, l = {}, u = [], d, f, p, m = e.attributes, h = e.childNodes;
		for (f = 0, p = m.length; f < p; f++) d = m[f].nodeName, d.startsWith("data-") ? c[Wa(d)] = m[f].nodeValue || "" : d !== "id" && d !== "class" && (s[d] = m[f].nodeValue);
		for (f = 0, p = h.length; f < p; f++) u.push(Ga(h[f], t));
		return Object.keys(s).length > 0 && (l.attrs = s), Object.keys(c).length > 0 && (l.dataset = c), o.startsWith("svg") && (o.length === 3 || o[3] === "." || o[3] === "#") && ka(l, u, o), X(o, l, u, void 0, e);
	} else if (n.isText(e)) return r = n.getTextContent(e), X(void 0, void 0, void 0, r, e);
	else if (n.isComment(e)) return r = n.getTextContent(e), X("!", {}, [], r, e);
	else return X("", {}, [], void 0, e);
}
var Ka = o((() => {
	Ma(), ga(), ha();
})), qa = o((() => {}));
//#endregion
//#region ../../node_modules/snabbdom/build/modules/attributes.js
function Ja(e, t) {
	let n, r = t.elm, i = e.data.attrs, a = t.data.attrs;
	if (!(!i && !a) && i !== a) {
		for (n in i ||= {}, a ||= {}, a) {
			let e = a[n];
			i[n] !== e && (e === !0 ? r.setAttribute(n, "") : e === !1 ? r.removeAttribute(n) : n.charCodeAt(0) === $a ? n.charCodeAt(3) === Qa ? r.setAttributeNS(Za, n, e) : n.charCodeAt(5) === Qa ? n.charCodeAt(1) === eo ? r.setAttributeNS(Xa, n, e) : r.setAttributeNS(Ya, n, e) : r.setAttribute(n, e) : r.setAttribute(n, e));
		}
		for (n in i) n in a || r.removeAttribute(n);
	}
}
var Ya, Xa, Za, Qa, $a, eo, to, no = o((() => {
	Ya = "http://www.w3.org/1999/xlink", Xa = "http://www.w3.org/2000/xmlns/", Za = "http://www.w3.org/XML/1998/namespace", Qa = 58, $a = 120, eo = 109, to = {
		create: Ja,
		update: Ja
	};
}));
//#endregion
//#region ../../node_modules/snabbdom/build/modules/class.js
function ro(e, t) {
	let n, r, i = t.elm, a = e.data.class, o = t.data.class;
	if (!(!a && !o) && a !== o) {
		for (r in a ||= {}, o ||= {}, a) a[r] && !Object.prototype.hasOwnProperty.call(o, r) && i.classList.remove(r);
		for (r in o) n = o[r], n !== a[r] && i.classList[n ? "add" : "remove"](r);
	}
}
var io, ao = o((() => {
	io = {
		create: ro,
		update: ro
	};
}));
//#endregion
//#region ../../node_modules/snabbdom/build/modules/dataset.js
function oo(e, t) {
	let n = t.elm, r = e.data.dataset, i = t.data.dataset, a;
	if (!r && !i || r === i) return;
	r ||= {}, i ||= {};
	let o = n.dataset;
	for (a in r) a in i || (o ? a in o && delete o[a] : n.removeAttribute("data-" + a.replace(so, "-$&").toLowerCase()));
	for (a in i) r[a] !== i[a] && (o ? o[a] = i[a] : n.setAttribute("data-" + a.replace(so, "-$&").toLowerCase(), i[a]));
}
var so, co, lo = o((() => {
	so = /[A-Z]/g, co = {
		create: oo,
		update: oo
	};
}));
//#endregion
//#region ../../node_modules/snabbdom/build/modules/eventlisteners.js
function uo(e, t, n) {
	if (typeof e == "function") e.call(t, n, t);
	else if (typeof e == "object") for (let r = 0; r < e.length; r++) uo(e[r], t, n);
}
function fo(e, t) {
	let n = e.type, r = t.data.on;
	r && r[n] && uo(r[n], t, e);
}
function po() {
	return function e(t) {
		fo(t, e.vnode);
	};
}
function mo(e, t) {
	let n = e.data.on, r = e.listener, i = e.elm, a = t && t.data.on, o = t && t.elm, s;
	if (n !== a) {
		if (n && r) if (a) for (s in n) a[s] || i.removeEventListener(s, r, !1);
		else for (s in n) i.removeEventListener(s, r, !1);
		if (a) {
			let r = t.listener = e.listener || po();
			if (r.vnode = t, n) for (s in a) n[s] || o.addEventListener(s, r, !1);
			else for (s in a) o.addEventListener(s, r, !1);
		}
	}
}
var ho, go = o((() => {
	ho = {
		create: mo,
		update: mo,
		destroy: mo
	};
}));
//#endregion
//#region ../../node_modules/snabbdom/build/modules/props.js
function _o(e, t) {
	let n, r, i, a = t.elm, o = e.data.props, s = t.data.props;
	if (!(!o && !s) && o !== s) for (n in o ||= {}, s ||= {}, s) r = s[n], i = o[n], i !== r && (n !== "value" || a[n] !== r) && (a[n] = r);
}
var vo, yo = o((() => {
	vo = {
		create: _o,
		update: _o
	};
}));
//#endregion
//#region ../../node_modules/snabbdom/build/modules/style.js
function bo(e, t, n) {
	Eo(() => {
		e[t] = n;
	});
}
function xo(e, t) {
	let n, r, i = t.elm, a = e.data.style, o = t.data.style;
	if (!a && !o || a === o) return;
	a ||= {}, o ||= {};
	let s = "delayed" in a;
	for (r in a) r in o || (r[0] === "-" && r[1] === "-" ? i.style.removeProperty(r) : i.style[r] = "");
	for (r in o) if (n = o[r], r === "delayed" && o.delayed) for (let e in o.delayed) n = o.delayed[e], (!s || n !== a.delayed[e]) && bo(i.style, e, n);
	else r !== "remove" && n !== a[r] && (r[0] === "-" && r[1] === "-" ? i.style.setProperty(r, n) : i.style[r] = n);
}
function So(e) {
	let t, n, r = e.elm, i = e.data.style;
	if (!(!i || !(t = i.destroy))) for (n in t) r.style[n] = t[n];
}
function Co(e, t) {
	let n = e.data.style;
	if (!n || !n.remove) {
		t();
		return;
	}
	Do ||= (e.elm.offsetLeft, !0);
	let r, i = e.elm, a = 0, o = n.remove, s = 0, c = [];
	for (r in o) c.push(r), i.style[r] = o[r];
	let l = getComputedStyle(i)["transition-property"].split(", ");
	for (; a < l.length; ++a) c.indexOf(l[a]) !== -1 && s++;
	i.addEventListener("transitionend", (e) => {
		e.target === i && --s, s === 0 && t();
	});
}
function wo() {
	Do = !1;
}
var To, Eo, Do, Oo, ko = o((() => {
	To = typeof (window == null ? void 0 : window.requestAnimationFrame) == "function" ? window.requestAnimationFrame.bind(window) : setTimeout, Eo = (e) => {
		To(() => {
			To(e);
		});
	}, Do = !1, Oo = {
		pre: wo,
		create: xo,
		update: xo,
		destroy: So,
		remove: Co
	};
}));
//#endregion
//#region ../../node_modules/snabbdom/build/jsx.js
function Ao(e, ...t) {
	let n = jo(t, []);
	return n.length === 1 && !n[0].sel && n[0].text ? X(void 0, void 0, void 0, n[0].text, void 0) : X(void 0, e ?? {}, n, void 0, void 0);
}
function jo(e, t) {
	for (let n of e) n != null && n !== !1 && n !== "" && (Array.isArray(n) ? jo(n, t) : typeof n == "string" || typeof n == "number" || typeof n == "boolean" ? t.push(X(void 0, void 0, void 0, String(n), void 0)) : t.push(n));
	return t;
}
function Mo(e, t, ...n) {
	let r = jo(n, []);
	return typeof e == "function" ? e(t, r) : r.length === 1 && !r[0].sel && r[0].text ? Aa(e, t, r[0].text) : Aa(e, t, r);
}
var No = o((() => {
	ga(), Ma();
})), Po = /* @__PURE__ */ c({
	Fragment: () => Ao,
	array: () => va,
	attachTo: () => Ha,
	attributesModule: () => to,
	classModule: () => io,
	datasetModule: () => co,
	eventListenersModule: () => ho,
	fragment: () => ja,
	h: () => Aa,
	htmlDomApi: () => ma,
	init: () => Ta,
	jsx: () => Mo,
	primitive: () => _a,
	propsModule: () => vo,
	styleModule: () => Oo,
	thunk: () => Ia,
	toVNode: () => Ga,
	vnode: () => X
}), Fo = o((() => {
	ha(), Oa(), La(), ga(), Ua(), ya(), Ka(), Ma(), qa(), no(), ao(), lo(), go(), yo(), ko(), No();
}));
//#endregion
//#region src/core/lib/functions.js
Fo();
var Io = (...e) => (t) => e.reduce((e, t) => t(e), t), Lo = (e) => e.reduce((e, { callback: t, context: n }) => e.then(() => t(n)), Promise.resolve()), Ro = ({ experience: e, onRender: t, onRenderReset: n, wrapContent: r, getWindowReference: i = () => window }) => {
	let a = null, o = null, s = () => {
		let t = i().document, n = zr(e.id);
		return t.documentElement.querySelector(`#${n}`);
	}, c = () => o ? o.shadowRoot : null, l = () => a ? a.shadowRoot : null, u = Io((e) => (l() !== null || c() !== null || (a = s()), e), r, ({ step: { virtualizedContent: e } }) => {
		t(c() ?? l(), e);
	});
	return {
		render: Rt(async ({ input: e }) => new Promise((t) => {
			t(u(e));
		})),
		unmount: () => t(null, Aa("!")),
		setContainer: ({ context: e, event: { container: t } }) => {
			let { theme: n, themeSystem: r, accountId: a } = e.experience, { id: s } = e.step;
			o && o.remove(), o = Jr({
				accountId: a,
				id: s,
				...!r && { theme: n },
				getWindowReference: i
			}), t.parentNode.replaceChild(o, t);
		},
		resetRender: () => {
			a = null, o && o.remove(), o = null, n();
		},
		getContainer: () => c() ?? l() ?? s().shadowRoot,
		getRoot: () => o ?? s(),
		hasCustomContainer: ({ event: e }) => e.type === "UPDATE_ROOT_STYLE" && e.options?.forceUpdate || !!c()
	};
}, zo = ({ container: e, nodes: t }, n = 0) => e.replace(/<% node %>/, t[n]), Bo = (e) => e.replaceAll("//twemoji.maxcdn.com/2/svg/", "//cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/"), Vo = "…[truncated]", Ho = new TextEncoder(), Uo = (e) => Ho.encode(e).length;
function Wo(e, t) {
	if (typeof e != "string") return e;
	let n = t ?? 1024;
	if (Uo(e) <= n) return e;
	let r = n - Uo(Vo);
	if (r < 0) return "";
	let i = 0, a = "";
	for (let t of e) {
		let e = Uo(t);
		if (i + e > r) break;
		i += e, a += t;
	}
	return a + Vo;
}
//#endregion
//#region src/core/lib/core-events.js
var Go = "step_target_resolved", Ko = (e) => e.split("_").map((e) => e.charAt(0).toUpperCase() + e.slice(1)).join(" "), Z = ({ experience: e, experienceInstanceId: t }, n) => ({
	experienceId: e.id,
	experienceName: e.name,
	experienceType: e.type,
	isCoreEvent: !0,
	localeName: e.context?.locale_name || "default",
	localeId: Mi(e) || "default",
	...e.campaignId != null && { campaignId: e.campaignId },
	...e.tacticId != null && { tacticId: e.tacticId },
	timestamp: Date.now(),
	version: e.version,
	name: Ko(n),
	experienceInstanceId: t
}), qo = ({ step: e }) => ({
	stepId: e.id,
	stepName: e.name,
	stepType: e.type
}), Jo = `${Gn}:`, Yo = (e) => `${Jo}${e}`, Xo = ({ context: e, event: t }) => t.type === "TARGET_RESOLVED" ? t.status !== "broken" && !e.blockedEvents[Yo(t.targetId)] : !e.blockedEvents[t.type], Zo = (e) => {
	let t = ({ context: t }) => {
		let n = "experience_started", r = Z(t, n);
		e("sendEvent")(n, r);
	}, n = ({ context: t }) => {
		let n = "experience_completed", r = Z(t, n);
		e("sendEvent")(n, r);
	}, r = ({ context: t, event: { message: n } }) => {
		let r = "experience_error", i = Z(t, r);
		e("sendEvent")(r, {
			...i,
			message: n
		});
	}, i = ({ context: t }) => {
		let n = "experience_dismissed", r = Z(t, n), i = qo(t);
		e("sendEvent")(n, {
			...r,
			...i
		});
	}, a = ({ context: t }) => {
		let n = "experience_snoozed", r = Z(t, n), i = qo(t);
		e("sendEvent")(n, {
			...r,
			...i
		});
	}, o = ({ context: t }) => {
		let n = "step_seen", r = Z(t, n), i = qo(t);
		e("sendEvent")(n, {
			...r,
			...i
		});
	}, s = ({ context: t }) => {
		let n = "step_completed", r = Z(t, n), i = qo(t);
		e("sendEvent")(n, {
			...r,
			...i
		});
	}, c = ({ context: t, event: n }) => {
		let r = Z(t, n.name), i = qo(t), a = e("sendEvent"), { name: o, ...s } = n;
		a(o, {
			...r,
			...i,
			...s
		});
	}, l = ({ context: t, event: { interactionType: n, interactionData: r } }) => {
		let i = "step_interaction", a = Z(t, i), o = qo(t);
		e("sendEvent")(i, {
			...a,
			...o,
			interactionType: n,
			interactionData: r
		});
	}, u = ({ context: t, event: { message: n, errorId: r, error: i, reason: a, selector: o, targetId: s } }) => {
		let c = "step_error", l = Z(t, c), u = qo(t);
		e("sendEvent")(c, {
			...l,
			...u,
			message: n ?? i?.message,
			errorId: r,
			...a == null ? {} : { reason: a },
			...o == null ? {} : { selector: Wo(o) },
			...s == null ? {} : { targetId: s }
		});
	}, d = ({ context: t, event: { targetId: n, status: r, strategy: i, confidence: a, resolutionTimeMs: o, waited: s } }) => {
		if (r === "broken") return;
		let c = Go;
		try {
			e("sendEvent")(c, {
				...Z(t, c),
				...qo(t),
				targetId: n,
				status: r,
				strategy: i,
				confidence: a,
				resolutionTimeMs: o,
				waited: s
			});
		} catch {}
	}, f = ({ context: t, event: { errorId: n } }) => {
		let r = "step_recovered", i = Z(t, r), a = qo(t);
		e("sendEvent")(r, {
			...i,
			...a,
			errorId: n
		});
	}, p = G(({ context: e, event: { type: t, name: n = "", targetId: r } }) => {
		let i = t;
		return t === "EXTENDED_EVENT" ? i = n : t === "TARGET_RESOLVED" && (i = Yo(r)), { blockedEvents: {
			...e.blockedEvents,
			[i]: !0
		} };
	}), m = G(({ context: e }) => ({ blockedEvents: Object.fromEntries(Object.entries(e.blockedEvents).filter(([e]) => !e.startsWith(Jo))) }));
	return {
		experienceActions: {
			experienceStarted: t,
			experienceError: r,
			experienceCompleted: n
		},
		stepActions: {
			experienceDismissed: i,
			experienceSnoozed: a,
			stepSeen: o,
			stepInteraction: l,
			stepError: u,
			stepRecovered: f,
			stepExtendedEvent: c,
			stepCompleted: s,
			targetResolved: d
		},
		helpers: {
			blockEvent: p,
			clearTargetResolvedBlocks: m,
			isEventEnabled: Xo
		}
	};
}, Qo = an({
	initial: "waitingForAsyncEvents",
	context: { runHooksDone: !1 },
	states: {
		waitingForAsyncEvents: { on: {
			UPDATE_STEP: "update_step",
			ERROR: "error",
			RUN_HOOKS_DONE: {
				target: "",
				actions: G({ runHooksDone: !0 })
			}
		} },
		update_step: {
			always: [{
				target: "done",
				guard: ({ context: e }) => e.runHooksDone,
				actions: [K({ type: "RERENDER" })]
			}],
			on: {
				UPDATE_STEP: "",
				ERROR: "error",
				RUN_HOOKS_DONE: {
					target: "done",
					actions: [G({ runHooksDone: !0 }), K({ type: "RERENDER" })]
				}
			}
		},
		error: {
			always: [{
				target: "done",
				guard: ({ context: e }) => e.runHooksDone,
				actions: [K({ type: "FORCE_ERROR" })]
			}],
			on: {
				UPDATE_STEP: "",
				ERROR: "",
				RUN_HOOKS_DONE: {
					target: "done",
					actions: [G({ runHooksDone: !0 }), K({ type: "FORCE_ERROR" })]
				}
			}
		},
		done: { type: "final" }
	}
}), $o = an({
	initial: "waitingForAsyncEvents",
	context: { runHooksDone: !1 },
	states: {
		waitingForAsyncEvents: { on: {
			RECOVER_STEP: "recover_step",
			RUN_HOOKS_DONE: {
				target: "",
				actions: G({ runHooksDone: !0 })
			}
		} },
		recover_step: {
			always: [{
				target: "done",
				guard: ({ context: e }) => e.runHooksDone,
				actions: [K({ type: "FORCE_RECOVER" })]
			}],
			on: { RUN_HOOKS_DONE: {
				target: "done",
				actions: [G({ runHooksDone: !0 }), K({ type: "FORCE_RECOVER" })]
			} }
		},
		done: { type: "final" }
	}
}), es = {
	initial: "waiting_to_render",
	on: {
		SET_STEP_CONTAINER_TARGET: {
			actions: ["setContainer", "runStepContainerChangeHooks"],
			target: ""
		},
		UPDATE_ROOT_STYLE: {
			actions: "updateRootStyle",
			target: "",
			guard: "hasCustomContainer"
		},
		UPDATE_STEP_CONTENT: {
			actions: "setContent",
			target: ""
		},
		RUN_HOOKS_ERROR: ".destroyed",
		BIND_ACTIONS_ERROR: ".destroyed",
		STOP_STEP: [{
			guard: "hasPendingActions",
			target: ".waitingPendingActions",
			actions: ["saveStopReason", "addStoppedCallback"]
		}, {
			target: ".running_end_hooks",
			actions: ["saveStopReason", "addStoppedCallback"]
		}],
		PARENT_RECOVER_STEP: {
			actions: [
				"stepRecovered",
				"clearErrorFlags",
				"clearTargetResolvedBlocks"
			],
			target: ".rendering"
		},
		EXPERIENCE_DISMISSED: {
			target: "",
			actions: ["experienceDismissed", K({
				type: An,
				reason: jn.DISMISSED
			})]
		},
		EXPERIENCE_SNOOZED: {
			target: "",
			actions: ["experienceSnoozed", K({
				type: An,
				reason: jn.DISMISSED
			})]
		},
		STEP_SEEN: {
			target: "",
			actions: ["queueStepSeen", "blockEvent"],
			guard: "isEventEnabled"
		},
		STEP_INTERACTION: {
			target: "",
			actions: ["stepInteraction"]
		},
		TARGET_RESOLVED: {
			target: "",
			actions: ["targetResolved", "blockEvent"],
			guard: "isEventEnabled"
		},
		EXTENDED_EVENT: {
			actions: ["stepExtendedEvent", "blockEvent"],
			guard: "isEventEnabled"
		},
		RELOAD: [
			{
				target: ".reload",
				actions: [
					"updateTheme",
					"updateStepContext",
					"clearErrorFlags"
				],
				guard: "didThemeChange"
			},
			{
				target: ".reloading_traits",
				actions: [
					"setVirtualizedContent",
					"updateStepContext",
					"saveChangedStepTraits",
					"saveChangedExperienceTraits",
					"clearErrorFlags"
				],
				guard: "shouldOnlyReloadTraits"
			},
			{
				target: ".reload",
				actions: [
					"setVirtualizedContent",
					"updateStepContext",
					"clearErrorFlags"
				],
				guard: "shouldStepReload"
			},
			{
				target: ".rendering",
				actions: [
					"setVirtualizedContent",
					"updateStepContext",
					"rebindActions",
					"clearErrorFlags"
				],
				guard: "didContentChanged"
			}
		],
		[An]: { actions: [K({ type: An })] },
		FORWARD_TO_PARENT: [{ actions: [K(({ event: { eventType: e, ...t } }) => ({
			...t,
			type: e
		}))] }],
		ACTIONS_STARTED: {
			target: "",
			actions: "setActionsRunning"
		},
		ACTIONS_FINISHED: {
			target: "",
			actions: "setActionsFinished"
		}
	},
	invoke: [
		{
			id: "hooksService",
			src: "hooksService"
		},
		{
			id: "actionsService",
			src: "actionsService"
		},
		{
			id: "themeRemovalService",
			src: "themeRemovalService"
		}
	],
	states: {
		waiting_to_render: { on: { START_STEP: "running_traits" } },
		reload: {
			entry: [
				"removeCustomContainer",
				"unmount",
				"resetRender",
				"clearOverrides",
				"runStepEndHooks"
			],
			exit: ["removeStepHooks"],
			on: { RUN_HOOKS_DONE: {
				target: "running_traits",
				guard: "isHooksDoneEventEndType"
			} }
		},
		reloading_traits: {
			initial: "running_end_hooks",
			exit: ["clearChangedStepTraits", "clearChangedExperienceTraits"],
			onDone: {
				target: "rendering",
				actions: "ensuresElementsAreAccessible"
			},
			on: { ERROR: {
				target: "error",
				actions: "stepError"
			} },
			states: {
				running_end_hooks: {
					entry: ["runStepEndHooks"],
					on: { RUN_HOOKS_DONE: {
						target: "running_pre_begin_hooks",
						guard: "isHooksDoneEventEndType"
					} }
				},
				running_pre_begin_hooks: {
					entry: ["runStepPreBeginHooks"],
					exit: ["rebindActions"],
					on: { RUN_HOOKS_DONE: {
						target: "running_begin_hooks",
						guard: "isHooksDoneEventPreBeginType"
					} }
				},
				running_begin_hooks: {
					entry: ["runStepBeginHooks"],
					on: { RUN_HOOKS_DONE: {
						target: "done",
						guard: "isHooksDoneEventBeginType"
					} }
				},
				done: { type: "final" }
			}
		},
		running_traits: {
			invoke: {
				src: "runStepTraits",
				input: ({ context: e }) => ({ step: e.step })
			},
			on: {
				RUN_TRAITS_DONE: {
					target: "pre_begin",
					actions: "rebindActions"
				},
				RUN_TRAITS_ERROR: "destroyed"
			}
		},
		pre_begin: {
			entry: ["runStepPreBeginHooks"],
			on: {
				ERROR: {
					target: "error",
					actions: "reportStepErrorOnce"
				},
				RUN_HOOKS_DONE: {
					target: "begin",
					guard: "isHooksDoneEventPreBeginType"
				}
			}
		},
		begin: {
			entry: ["runStepBeginHooks"],
			on: {
				ERROR: {
					target: "error",
					actions: "reportStepErrorOnce"
				},
				RUN_HOOKS_DONE: {
					target: "rendering",
					actions: "ensuresElementsAreAccessible",
					guard: "isHooksDoneEventBeginType"
				}
			}
		},
		rendering: {
			initial: "pre-render",
			on: { STEP_CONTAINER_REMOVED: { target: "error" } },
			states: {
				"pre-render": {
					entry: ["runStepPreRenderHooks"],
					on: { RUN_HOOKS_DONE: [{
						target: "render",
						actions: ["applyOverrides"],
						guard: "isHooksDoneEventPreRenderType"
					}] }
				},
				render: { invoke: {
					src: "render",
					input: ({ context: e }) => e,
					onDone: [{
						target: "post-render",
						guard: "hasCustomContainer",
						actions: "startThemeRemovalListener"
					}, { target: "post-render" }],
					onError: {
						target: "#error",
						actions: "stepError"
					}
				} },
				"post-render": {
					invoke: {
						id: "postRenderAsyncEventsHandler",
						src: Qo
					},
					entry: ["runStepPostRenderHooks"],
					on: {
						FORCE_ERROR: "#error",
						RERENDER: "pre-render",
						UPDATE_STEP: {
							target: "",
							actions: [tn("postRenderAsyncEventsHandler")]
						},
						ERROR: [{
							guard: "isRemovalHandoff",
							actions: "advancePastRemovedTarget"
						}, {
							target: "",
							actions: [
								tn("postRenderAsyncEventsHandler"),
								"reportStepErrorOnce",
								"markErrorReported"
							]
						}],
						RUN_HOOKS_DONE: {
							target: "",
							guard: "isHooksDoneEventPostRenderType",
							actions: [
								"notifyExperienceStarted",
								"commitPendingStepSeen",
								tn("postRenderAsyncEventsHandler")
							]
						}
					}
				}
			}
		},
		running_end_hooks: {
			entry: ["runStepEndHooks"],
			on: {
				RUN_HOOKS_DONE: [{
					guard: "shouldFireStepCompletedEvent",
					target: "calling_stopped_callbacks",
					actions: [
						"removeCustomContainer",
						"unmount",
						"stepCompleted",
						"removeStepHooks"
					]
				}, {
					guard: "isHooksDoneEventEndType",
					target: "calling_stopped_callbacks",
					actions: [
						"removeCustomContainer",
						"unmount",
						"removeStepHooks"
					]
				}],
				RUN_HOOKS_ERROR: {
					target: "destroyed",
					actions: ["callStoppedCallbacks"]
				}
			}
		},
		calling_stopped_callbacks: {
			entry: ["callStoppedCallbacks", "deferTransitionToEnd"],
			on: { [Qn]: "end" }
		},
		end: {
			type: "final",
			entry: ["notifyStepStopped"]
		},
		error: {
			id: "error",
			invoke: [{
				id: "errorAsyncEventsHandler",
				src: $o
			}],
			entry: [
				"unmount",
				"runStepErrorHooks",
				"stopThemeRemovalListener"
			],
			on: {
				RUN_HOOKS_DONE: {
					target: "",
					guard: "isHooksDoneEventErrorType",
					actions: [tn("errorAsyncEventsHandler"), "autoRecover"]
				},
				RECOVER_STEP: {
					target: "",
					actions: [tn("errorAsyncEventsHandler")]
				},
				FORCE_RECOVER: {
					target: "pre_begin",
					actions: [
						"resetRender",
						"stepRecovered",
						"clearErrorFlags",
						"clearTargetResolvedBlocks"
					]
				},
				AUTO_RECOVER_STEP: {
					target: "pre_begin",
					actions: [
						"resetRender",
						"clearErrorFlags",
						"clearTargetResolvedBlocks"
					],
					guard: "isAutoRecoverEvent"
				}
			}
		},
		destroyed: { entry: ["reportStepErrorOnce", "unmount"] },
		waitingPendingActions: { on: { ACTIONS_FINISHED: {
			target: "running_end_hooks",
			actions: "setActionsFinished"
		} } }
	}
}, ts = (e, { createStepHooks: t, createHooksService: n, experience: r, get: i, experienceInstanceId: a }) => {
	let { virtualizeContent: o, createVnodeTree: s, wrapContent: c, applyOverridesToVnode: l } = i("vNodeHandlers"), { makeElementsAccessible: u } = i("accessibilityHandlers"), { applyOverrides: d, createOverrideCallback: f, clearOverrides: p } = Yi({ applyOverridesToVnode: l }), m = f("style"), h = i("getWindowReference"), { onRender: g, onRenderReset: _ } = i("createRenderListener")(), { render: v, unmount: y, setContainer: b, resetRender: x, getContainer: S, hasCustomContainer: C, getRoot: w } = Ro({
		experience: r,
		onRender: g,
		onRenderReset: _,
		wrapContent: c,
		getWindowReference: h
	}), { addHook: T, runStepPreBeginHooks: E, runStepBeginHooks: D, runStepPreRenderHooks: O, runStepPostRenderHooks: k, runStepEndHooks: A, runStepErrorHooks: j, removeStepHooks: M, runStepContainerChangeHooks: N } = t({
		step: e,
		overrideStyle: m
	}), P = Ui({ addHook: T }), F = Hi({
		overrideStyle: m,
		getContainer: S,
		getRoot: w
	}, i), ee = n({
		overrideStyle: m,
		getContainer: S,
		getRoot: w
	}, i), te = ti({
		getRoot: w,
		getWindowReference: h
	}), I = wi(i), L = Zo(i), { currentWaitUrl: R, nextWaitUrl: z } = Ji(r, e), ne = (e) => {
		let t = h?.().location?.href, n = i("handleNavigation")?.doesLocationMatch;
		return !e || t == null || typeof n != "function" ? !1 : n(e, t);
	}, B = (e) => e.contentType === "text/html" ? o(Bo(zo(e.content))) : s(e.content);
	return an({
		...es,
		context: {
			id: `step-machine-${e.id}`,
			step: {
				...e,
				activeNodeIndex: 0,
				virtualizedContent: B(e)
			},
			experience: r,
			currentWaitUrl: R,
			nextWaitUrl: z,
			blockedEvents: {},
			pendingStepSeen: !1,
			errorReported: !1,
			stepErrorEmitted: !1,
			stepSeenEmitted: !1,
			actionsRunning: !1,
			experienceInstanceId: a,
			stopReason: null,
			stoppedCallbacks: [],
			changedStepTraits: null,
			changedExperienceTraits: null
		}
	}, {
		actions: {
			setContent: vi,
			updateRootStyle: Ci,
			unmount: y,
			setContainer: b,
			updateTheme: I,
			resetRender: x,
			runStepPreBeginHooks: E,
			runStepBeginHooks: D,
			runStepPreRenderHooks: O,
			runStepPostRenderHooks: k,
			runStepEndHooks: A,
			runStepErrorHooks: j,
			runStepContainerChangeHooks: N,
			updateStepContext: bi,
			rebindActions: en("actionsService", ({ context: e }) => ({
				type: br,
				step: e.step,
				experience: e.experience
			})),
			removeStepHooks: () => M(),
			clearOverrides: () => p(),
			setVirtualizedContent: yi(B),
			applyOverrides: d,
			startThemeRemovalListener: ni,
			stopThemeRemovalListener: ri,
			removeCustomContainer: $r({ getRoot: w }),
			ensuresElementsAreAccessible: Ti(u),
			notifyExperienceStarted: xi,
			notifyStepStopped: Si,
			...L.stepActions,
			blockEvent: L.helpers.blockEvent,
			clearTargetResolvedBlocks: L.helpers.clearTargetResolvedBlocks,
			queueStepSeen: G({ pendingStepSeen: !0 }),
			markErrorReported: G({ errorReported: !0 }),
			markStepErrorEmitted: G({ stepErrorEmitted: !0 }),
			clearErrorFlags: G({
				stepErrorEmitted: !1,
				errorReported: !1
			}),
			reportStepErrorOnce: rn(({ context: e, enqueue: t }) => {
				e.stepErrorEmitted || (t("stepError"), t("markStepErrorEmitted"));
			}),
			commitPendingStepSeen: G(({ context: e }) => !e.pendingStepSeen || e.errorReported ? {} : (L.stepActions.stepSeen({ context: e }), {
				pendingStepSeen: !1,
				stepSeenEmitted: !0
			})),
			autoRecover: Ei,
			setActionsRunning: Di,
			setActionsFinished: Oi,
			saveStopReason: G({ stopReason: ({ event: e }) => e.reason }),
			addStoppedCallback: G({ stoppedCallbacks: ({ context: e, event: t }) => t.onStopped ? [...e.stoppedCallbacks, t.onStopped] : e.stoppedCallbacks }),
			callStoppedCallbacks: ({ context: e }) => e.stoppedCallbacks.forEach((e) => {
				try {
					e();
				} catch {}
			}),
			deferTransitionToEnd: Mt({ type: Qn }, { delay: 0 }),
			saveChangedStepTraits: G({ changedStepTraits: ({ event: e }) => e.changedStepTraits ?? null }),
			clearChangedStepTraits: G({ changedStepTraits: () => null }),
			saveChangedExperienceTraits: G({ changedExperienceTraits: ({ event: e }) => e.changedExperienceTraits ?? null }),
			clearChangedExperienceTraits: G({ changedExperienceTraits: () => null }),
			advancePastRemovedTarget: K({ type: Fn })
		},
		actors: {
			runStepTraits: P,
			render: v,
			hooksService: ee,
			actionsService: F,
			themeRemovalService: te
		},
		guards: {
			hasCustomContainer: C,
			isAutoRecoverEvent: ({ event: e }) => e.isAutoRecoverEvent,
			isEventEnabled: L.helpers.isEventEnabled,
			didContentChanged: ({ context: e, event: t }) => !(0, Dn.default)(e.step.content, t.stepConfig.content),
			shouldOnlyReloadTraits: ki,
			shouldStepReload: ({ context: e, event: t }) => !(0, Dn.default)(e.step.traits, t.stepConfig.traits) || !(0, Dn.default)(e.step.actions, t.stepConfig.actions) || !(0, Dn.default)(e.experience.traits, t.experience.traits),
			didThemeChange: ({ context: e, event: t }) => e.experience.theme !== t.experience.theme,
			isHooksDoneEventPostRenderType: ({ event: e }) => e.hookType === or,
			isHooksDoneEventPreRenderType: ({ event: e }) => e.hookType === ar,
			isHooksDoneEventPreBeginType: ({ event: e }) => e.hookType === rr,
			isHooksDoneEventBeginType: ({ event: e }) => e.hookType === ir,
			isHooksDoneEventErrorType: ({ event: e }) => e.hookType === cr,
			isHooksDoneEventEndType: ({ event: e }) => e.hookType === sr,
			isRemovalHandoff: ({ context: e, event: t }) => Ki(t.message) && e.currentWaitUrl != null && e.nextWaitUrl != null && !ne(e.currentWaitUrl) && ne(e.nextWaitUrl),
			hasPendingActions: ({ context: e }) => e.actionsRunning,
			shouldFireStepCompletedEvent: ({ context: e, event: t }) => t.hookType === "step.end" && e.stepSeenEmitted && e.stopReason !== jn.NAVIGATION && e.stopReason !== jn.DISMISSED && e.stopReason !== jn.ERROR
		}
	});
}, ns = ({ createStepHooks: e, createHooksService: t, get: n }) => G({ stepMachines: ({ context: { experience: r, experienceInstanceId: i }, spawn: a }) => {
	let o = {
		experience: r,
		experienceInstanceId: i,
		createStepHooks: e,
		createHooksService: t,
		get: n
	};
	return r.steps.reduce((e, t) => (e[`${t.id}`] = a(ts(t, o), { id: `step-machine - ${t.id}` }), e), {});
} }), rs = ({ createStepHooks: e, createHooksService: t, get: n }) => G({ stepMachines: ({ context: { experience: r, stepMachines: i }, event: a, spawn: o }) => {
	let s = {
		experience: r,
		createStepHooks: e,
		createHooksService: t,
		get: n
	}, c = r.steps.find((e) => e.id === a.id);
	return c ? {
		...i,
		[`${a.id}`]: o(ts(c, s), { id: `step-machine - ${a.id}` })
	} : i;
} }), is = (e) => ({ context: t, event: { id: n, ...r } }) => {
	t.stepMachines[n]?.send({
		...r,
		type: e
	});
}, as = is(Nn), os = ({ context: e, event: t }) => {
	let n = e.stepMachines[t.id];
	n && (n.getSnapshot().status === "done" && t.onStopped ? t.onStopped() : n.send({
		...t,
		type: Pn
	}));
}, ss = is(In), cs = is(Ln), ls = is(Vn), us = is(Rn), ds = ({ context: e, event: t }) => {
	Object.values(e.stepMachines).forEach((e) => {
		e.send({
			type: Pn,
			reason: t.reason
		});
	});
}, fs = (e = [], t = []) => {
	let n = new Map(e.map((e) => [e.id, e])), r = new Map(t.map((e) => [e.id, e]));
	return {
		addedTraits: t.filter((e) => {
			let t = n.get(e.id);
			return !t || t.type !== e.type;
		}),
		removedTraits: e.filter((e) => {
			let t = r.get(e.id);
			return !t || t.type !== e.type;
		}),
		changedTraits: t.filter((e) => {
			let t = n.get(e.id);
			return !t || t.type !== e.type ? !1 : !(0, Dn.default)(t.config || {}, e.config || {});
		})
	};
}, ps = G(({ context: e, event: t }) => {
	let n = fs(e.experience.traits, t.experience.traits);
	return Object.entries(e.stepMachines).forEach(([r, i]) => {
		let a = e.experience.steps.find((e) => e.id === r), o = t.experience.steps.find((e) => e.id === r);
		if (!a || !o) return;
		let s = fs(a.traits, o.traits);
		i.send({
			type: qn,
			stepConfig: o,
			experience: t.experience,
			changedExperienceTraits: n,
			changedStepTraits: s
		});
	}), { experience: t.experience };
}), ms = ({ context: e }) => {
	Object.values(e.stepMachines).forEach((e) => {
		e.send({ type: hr });
	});
}, hs = G({ experienceInstanceId: () => Tn() }), gs = G({ stepMachines: ({ context: e, event: t }) => Object.entries(e.stepMachines).reduce((e, [n, r]) => (n !== t.id && (e[n] = r), e), {}) }), _s = G({ experience: ({ context: { experience: e }, event: t }) => {
	let n = e.steps.findIndex((e) => e.id === t.id);
	return n === -1 ? e : bn(e, `steps.${n}.traits`, (e) => e.filter(({ once: e = !1 }) => !e));
} }), vs = ({ addHook: e }) => Pt(({ sendBack: t, input: n }) => {
	let { experience: r } = n;
	try {
		r.traits.forEach((t) => Or({
			getTrait: kr,
			trait: t,
			addHook: (n, r) => {
				e(n, {
					callback: r,
					traitId: t.id
				});
			},
			registerAction: (e, n) => zi(`${r.id}.${t.type}.${e}`, n)
		})), t({ type: br });
	} catch {
		t({ type: xr });
	}
}), ys = (e, t) => (n, { callback: r, traitId: i }) => {
	let a = e();
	a.get(n) || a.set(n, []), t(n, [...a.get(n), {
		callback: r,
		traitId: i
	}]);
}, bs = (e, t) => en("hooksService", ({ context: n, event: r }) => {
	let i = t, a = r.changedExperienceTraits ?? n.changedExperienceTraits;
	a && (i = {
		...i,
		onlyExperienceTraits: a.changedTraits.filter((e) => e.id != null).map(({ id: e }) => e)
	});
	let o = r.changedStepTraits ?? n.changedStepTraits;
	return o && (i = {
		...i,
		onlyStepTraits: o.changedTraits.filter((e) => e.id != null).map(({ id: e }) => e)
	}), {
		type: ur,
		hookType: e,
		experience: n.experience,
		step: n.step,
		...i
	};
}), xs = bs(tr), Ss = bs(nr), Cs = bs(rr), ws = bs(ir), Ts = bs(ar), Es = bs(or), Ds = bs(sr), Os = rn(({ enqueue: e, event: t }) => {
	e(bs(cr, { errorEvent: t }));
}), ks = bs(lr), As = () => {
	let e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
	return {
		addHook: ys(() => e, (t, n) => e.set(t, n)),
		createStepHooks: ({ step: e }) => (t.get(e.id) || t.set(e.id, /* @__PURE__ */ new Map()), {
			addHook: ys(() => t.get(e.id), (n, r) => t.get(e.id).set(n, r)),
			removeStepHooks: () => t.set(e.id, /* @__PURE__ */ new Map()),
			runStepPreBeginHooks: Cs,
			runStepBeginHooks: ws,
			runStepPreRenderHooks: Ts,
			runStepPostRenderHooks: Es,
			runStepEndHooks: Ds,
			runStepErrorHooks: Os,
			runStepContainerChangeHooks: ks
		}),
		createHooksService: (n = {}, r) => Pt(({ sendBack: i, receive: a }) => {
			a(async ({ type: a, hookType: o, experience: s, step: c, ...l }) => {
				if (a !== "RUN_HOOKS") return;
				let u = {
					experience: s,
					step: c,
					callback: i,
					get: r,
					getContainer: n.getContainer
				};
				[
					"step.prebegin",
					"step.begin",
					"step.container_change",
					"step.end"
				].includes(o) && (u = {
					...u,
					...n
				});
				let d = ({ callback: e, trait: t }) => ({
					callback: e,
					context: {
						...Pi({
							...u,
							getAction: Ri,
							handleNavigation: r("handleNavigation")
						}),
						getTraitConfig: () => t.config
					}
				}), f = (e.get(o) ?? []).filter(({ traitId: e }) => !l.onlyExperienceTraits || l.onlyExperienceTraits && l.onlyExperienceTraits.includes(e)).map((e) => d({
					...e,
					trait: (s.traits ?? []).find((t) => t.id === e.traitId)
				}));
				try {
					await Lo(f), c && await Lo((t.get(c.id)?.get(o) ?? []).filter(({ traitId: e }) => !l.onlyStepTraits || l.onlyStepTraits && l.onlyStepTraits.includes(e)).map((e) => d({
						...e,
						trait: (c.traits ?? []).find((t) => t.id === e.traitId)
					}))), i({
						type: dr,
						hookType: o,
						...l
					});
				} catch {
					i({ type: "RUN_HOOKS_ERROR" });
				}
			});
		}),
		runExperienceBeginHooks: xs,
		runExperienceEndHooks: Ss
	};
}, js = /* @__PURE__ */ new Map();
function Ms(e, t) {
	return e == null || typeof t != "function" ? () => {} : (js.set(e, t), () => {
		js.get(e) === t && js.delete(e);
	});
}
function Ns(e) {
	js.get(e)?.();
}
//#endregion
//#region src/core/experience/machine.js
var Ps = {
	id: "experience",
	initial: "idle",
	invoke: [{
		src: "hooksService",
		id: "hooksService"
	}, {
		id: "themeRemovalService",
		src: "globalThemeRemovalService",
		input: ({ context: e }) => ({ experience: e.experience })
	}],
	on: {
		RUN_HOOKS_ERROR: ".destroyed",
		EXPERIENCE_STARTED: {
			target: "",
			actions: ["experienceStarted", "blockEvent"],
			guard: "isEventEnabled"
		},
		SHOW: ".running-traits",
		[Fn]: { actions: "runPageHandoff" }
	},
	states: {
		idle: { on: { SHOW: [{
			target: "running-traits",
			actions: ["updateExperienceInstanceId"]
		}, { target: "destroyed" }] } },
		"running-traits": {
			invoke: {
				src: "runGlobalExperienceTraits",
				input: ({ context: e }) => ({ experience: e.experience })
			},
			on: {
				RUN_TRAITS_ERROR: "destroyed",
				RUN_TRAITS_DONE: "rendering-steps"
			}
		},
		"rendering-steps": {
			on: {
				STOP_EXPERIENCE: [{
					target: "end",
					actions: ["experienceCompleted", "stopSteps"],
					guard: "shouldFireCompletedEvent"
				}, {
					target: "end",
					actions: ["stopSteps"]
				}],
				START_STEP: [{
					target: "",
					guard: "doesStepInstanceExist",
					actions: "startStep"
				}, {
					target: "",
					actions: ["startStepMachine", "startStep"]
				}],
				STOP_STEP: {
					target: "",
					actions: "stopStep"
				},
				UPDATE_STEP: {
					target: "",
					actions: "updateStep"
				},
				SET_STEP_CONTAINER_TARGET: {
					target: "",
					actions: "setStepContainerTarget"
				},
				RECOVER_STEP: {
					target: "",
					actions: "recoverStep"
				},
				GLOBAL_CONTAINER_REMOVED: {
					target: "",
					actions: [
						"createGlobalThemeComponent",
						"startThemeRemovalListener",
						"notifyStepsContainerRemoved"
					]
				},
				UPDATE_STEP_CONTENT: {
					target: "",
					actions: "updateStepContent"
				},
				SHOW: {
					target: "",
					actions: ["reloadSteps"]
				},
				STEP_STOPPED: [
					{
						target: "end-final",
						guard: "areAllStepsStoppedFromError",
						actions: ["removeGlobalThemeComponent", "runExperienceEndHooks"]
					},
					{
						target: "end-final",
						guard: "areAllStepsStopped",
						actions: [
							"experienceCompleted",
							"removeGlobalThemeComponent",
							"runExperienceEndHooks"
						]
					},
					{
						target: "",
						actions: ["cleanStepMachines", "cleanRunOnceTraits"]
					}
				]
			},
			entry: [
				"createGlobalThemeComponent",
				"startStepMachines",
				"runExperienceBeginHooks",
				"startThemeRemovalListener"
			]
		},
		end: {
			entry: ["removeGlobalThemeComponent", "runExperienceEndHooks"],
			on: { [Jn]: {
				target: "end-final",
				guard: "areAllStepsStopped"
			} }
		},
		"end-final": { final: !0 },
		destroyed: {
			entry: "experienceError",
			type: "final"
		}
	}
}, Fs = (e, t) => {
	let { addHook: n, createStepHooks: r, createHooksService: i, runExperienceBeginHooks: a, runExperienceEndHooks: o } = As(), s = i({}, t), c = ns({
		createStepHooks: r,
		createHooksService: i,
		get: t
	}), l = rs({
		createStepHooks: r,
		createHooksService: i,
		get: t
	}), u = vs({ addHook: n }), d = Zo(t), f = Xr(t), p = Zr(t), m = ei(t);
	return an({
		...Ps,
		context: {
			experience: e,
			blockedEvents: {},
			experienceInstanceId: null
		}
	}, {
		actions: {
			startStep: as,
			stopStep: os,
			updateStep: ss,
			setStepContainerTarget: cs,
			recoverStep: ls,
			startStepMachines: c,
			stopSteps: ds,
			notifyStepsContainerRemoved: ms,
			updateStepContent: us,
			reloadSteps: ps,
			updateExperienceInstanceId: hs,
			cleanStepMachines: gs,
			startStepMachine: l,
			runExperienceBeginHooks: a,
			runExperienceEndHooks: o,
			createGlobalThemeComponent: f,
			removeGlobalThemeComponent: p,
			startThemeRemovalListener: ni,
			cleanRunOnceTraits: _s,
			runPageHandoff: ({ context: e }) => {
				Ns(e.experience.id);
			},
			...d.experienceActions,
			blockEvent: d.helpers.blockEvent
		},
		actors: {
			runGlobalExperienceTraits: u,
			hooksService: s,
			globalThemeRemovalService: m
		},
		guards: {
			isEventEnabled: d.helpers.isEventEnabled,
			areAllStepsStopped: ({ context: e }) => Object.values(e.stepMachines).every((e) => e.getSnapshot().status === "done"),
			areAllStepsStoppedFromError: ({ context: e, event: t }) => t.reason === jn.ERROR && Object.values(e.stepMachines).every((e) => e.getSnapshot().status === "done"),
			doesStepInstanceExist: ({ context: e, event: t }) => e.stepMachines?.[t.id] !== void 0,
			shouldFireCompletedEvent: ({ event: e }) => e.reason !== jn.NAVIGATION && e.reason !== jn.DISMISSED
		}
	});
};
//#endregion
//#region src/core/lib/patch.js
Fo();
var Is = Ta([
	io,
	vo,
	Oo,
	ho,
	to
], void 0, { experimental: { fragments: !0 } });
function Ls(e) {
	let t = (e.ownerDocument || document).createElement("div");
	return e.append(t), Is(t, Aa("div"));
}
var Rs = () => {
	let e = null;
	return {
		onRender: (t, n) => {
			!e && !t || (e ||= Ls(t), e = Is(e, n));
		},
		onRenderReset: () => {
			e = null;
		}
	};
}, zs = /* @__PURE__ */ s(((e, t) => {
	t.exports = {
		area: !0,
		base: !0,
		br: !0,
		col: !0,
		embed: !0,
		hr: !0,
		img: !0,
		input: !0,
		keygen: !0,
		link: !0,
		menuitem: !0,
		meta: !0,
		param: !0,
		source: !0,
		track: !0,
		wbr: !0
	};
})), Bs = /* @__PURE__ */ s(((e, t) => {
	var n = /([\w-]+)|=|(['"])([.\s\S]*?)\2/g, r = zs();
	t.exports = function(e) {
		var t = 0, i, a = !0, o = {
			type: "tag",
			name: "",
			voidElement: !1,
			attrs: {},
			children: []
		};
		return e.replace(n, function(n) {
			if (n === "=") {
				a = !0, t++;
				return;
			}
			a ? t === 0 ? ((r[n] || e.charAt(e.length - 2) === "/") && (o.voidElement = !0), o.name = n) : (o.attrs[i] = n.replace(/^['"]|['"]$/g, ""), i = void 0) : (i && (o.attrs[i] = i), i = n), t++, a = !1;
		}), o;
	};
})), Vs = /* @__PURE__ */ s(((e, t) => {
	var n = /(?:<!--[\S\s]*?-->|<(?:"[^"]*"|'[^']*'|[^'">])+>)/g, r = Bs(), i = Object.create ? Object.create(null) : {};
	function a(e, t, n, r, i) {
		var a = t.indexOf("<", r), o = t.slice(r, a === -1 ? void 0 : a);
		/^\s*$/.test(o) && (o = " "), (!i && a > -1 && n + e.length >= 0 || o !== " ") && e.push({
			type: "text",
			content: o
		});
	}
	t.exports = function(e, t) {
		t ||= {}, t.components ||= i;
		var o = [], s, c = -1, l = [], u = {}, d = !1;
		return e.replace(n, function(n, i) {
			if (d) {
				if (n !== "</" + s.name + ">") return;
				d = !1;
			}
			var f = n.charAt(1) !== "/", p = n.indexOf("<!--") === 0, m = i + n.length, h = e.charAt(m), g;
			f && !p && (c++, s = r(n), s.type === "tag" && t.components[s.name] && (s.type = "component", d = !0), !s.voidElement && !d && h && h !== "<" && a(s.children, e, c, m, t.ignoreWhitespace), u[s.tagName] = s, c === 0 && o.push(s), g = l[c - 1], g && g.children.push(s), l[c] = s), (p || !f || s.voidElement) && (p || c--, !d && h !== "<" && h && (g = c === -1 ? o : l[c].children, a(g, e, c, m, t.ignoreWhitespace)));
		}), !o.length && e.length && a(o, e, 0, 0, t.ignoreWhitespace), o;
	};
})), Hs = /* @__PURE__ */ s(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.createTextVNode = n, e.transformName = r, e.unescapeEntities = o;
	var t = (Fo(), d(Po));
	function n(e, n) {
		return (0, t.vnode)(void 0, void 0, void 0, o(e, n));
	}
	function r(e) {
		return e = e.replace(/-(\w)/g, function(e, t) {
			return t.toUpperCase();
		}), "" + e.charAt(0).toLowerCase() + e.substring(1);
	}
	var i = /* @__PURE__ */ RegExp("&[a-z0-9#]+;", "gi"), a = null;
	function o(e, t) {
		return a ||= t.createElement("div"), e.replace(i, function(e) {
			return a.innerHTML = e, a.textContent;
		});
	}
})), Us = /* @__PURE__ */ s(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.default = function(e) {
		var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.context || document;
		if (!e) return null;
		var i = [], a = o((0, t.default)(e), i, r), c = void 0;
		return c = a ? a.length === 1 ? a[0] : a : s({
			type: "text",
			content: e
		}, i, r), n.hooks && n.hooks.create && i.forEach(function(e) {
			n.hooks.create(e);
		}), c;
	};
	var t = i(Vs()), n = (Fo(), d(Po)), r = Hs();
	function i(e) {
		return e && e.__esModule ? e : { default: e };
	}
	function a(e, t, n) {
		return t in e ? Object.defineProperty(e, t, {
			value: n,
			enumerable: !0,
			configurable: !0,
			writable: !0
		}) : e[t] = n, e;
	}
	function o(e, t, n) {
		if (e instanceof Array && e.length > 0) return e.map(function(e) {
			return s(e, t, n);
		});
	}
	function s(e, t, i) {
		var a = void 0;
		return a = e.type === "text" ? (0, r.createTextVNode)(e.content, i) : (0, n.h)(e.name, c(e, i), o(e.children, t, i)), t.push(a), a;
	}
	function c(e, t) {
		var n = {};
		if (!e.attrs) return n;
		var i = Object.keys(e.attrs).reduce(function(n, i) {
			if (i !== "style" && i !== "class") {
				var o = (0, r.unescapeEntities)(e.attrs[i], t);
				n ? n[i] = o : n = a({}, i, o);
			}
			return n;
		}, null);
		i && (n.attrs = i);
		var o = l(e);
		o && (n.style = o);
		var s = u(e);
		return s && (n.class = s), n;
	}
	function l(e) {
		try {
			return e.attrs.style.split(";").reduce(function(e, t) {
				var n = t.split(":"), i = (0, r.transformName)(n[0].trim());
				if (i) {
					var o = n[1].replace("!important", "").trim();
					e ? e[i] = o : e = a({}, i, o);
				}
				return e;
			}, null);
		} catch {
			return null;
		}
	}
	function u(e) {
		try {
			return e.attrs.class.split(" ").reduce(function(e, t) {
				return t = t.trim(), t && (e ? e[t] = !0 : e = a({}, t, !0)), e;
			}, null);
		} catch {
			return null;
		}
	}
})), Ws = /* @__PURE__ */ s(((e, t) => {
	t.exports = Us();
})), Gs = /* @__PURE__ */ c({
	applyOverridesToVnode: () => nc,
	createStyleState: () => Zs,
	createVnodeTree: () => tc,
	findId: () => Qs,
	injectHandlers: () => ic,
	mergeVnodeData: () => $s,
	traverseTree: () => ec,
	virtualizeContent: () => qs,
	wrapContent: () => rc
});
Fo();
var Ks = /* @__PURE__ */ u(Ws(), 1), qs = typeof Ks.default == "function" ? Ks.default : Ks.default.default, Js = "data-interaction-style", Ys = (e) => e.replace(/([A-Z])/g, (e) => `-${e[0].toLowerCase()}`), Xs = (e) => e.replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&#39;/g, "'").replace(/&quot;/g, "\""), Zs = ({ nodeId: e, interactionId: t, state: n }) => {
	let r = t ? `[${Js}="${t}"]` : `#${e}`;
	return Object.keys(n).map((e) => `${r}:${e} {
        ${Object.entries(n[e]).map(([e, t]) => {
		let n = Xs(String(t));
		return `${Ys(e)}:${n} !important`;
	}).join(";")}
      }`).join(" ");
}, Qs = (e) => e.data && e.data.attrs ? e.data.attrs.id : void 0, $s = (e, t) => Object.keys(t).reduce((e, n) => ({
	...e,
	[n]: {
		...e[n],
		...t[n]
	}
}), e.data || {}), ec = (e, t) => {
	e && (t(e), e.children && e.children.forEach((e) => ec(e, t)));
}, tc = (e) => {
	if (typeof e == "string") return Xs(e);
	if (e == null) return ja([]);
	let { is: t = "div", children: n = [], style: r, behaviors: i, htmlCode: a, ...o } = e.props, { state: s, ...c } = r ?? {}, l = e.props.id, u = e.props[Js], d = Aa(t, {
		...Object.keys(c).length > 0 && { style: c },
		...Object.keys(o).length > 0 && { attrs: o }
	}, n.map(tc));
	return s ? ja([Aa("style", Zs({
		nodeId: l,
		interactionId: u,
		state: s
	})), d]) : d;
}, nc = (e, t) => {
	let n = t(Qs(e)) ?? {};
	return {
		...e,
		data: $s(e, n),
		children: e.children?.map((e) => nc(e, t))
	};
}, rc = ({ step: e }) => {
	let t = zr(e.id), n = Aa("div", {
		attrs: { [yr]: t },
		style: {
			width: "100%",
			display: "contents"
		}
	}, [e.virtualizedContent]);
	return { step: {
		...e,
		virtualizedContent: n
	} };
}, ic = (e, t) => (e.data = {
	...e.data,
	on: t.on,
	hook: t.hook
}, e), ac = /* @__PURE__ */ c({ makeElementsAccessible: () => cc }), oc = (e, t) => t.includes(e.data?.attrs?.id) && typeof e.data?.attrs?.tabindex != "string" && typeof e.data?.attrs?.tabIndex != "number", sc = (e) => {
	e.data.attrs.tabindex = 0, e.sel = "button", e.data.style = {
		...e.data.style,
		border: e.data?.style?.border ?? "none",
		...e?.children?.length > 0 && { backgroundColor: e.data?.style?.backgroundColor ?? "transparent" }
	};
}, cc = ({ virtualizedContent: e, index: t }, { interactiveEls: n = [], focusableEls: r = [] }) => (ec(e, (e) => {
	oc(e, n) ? sc(e) : oc(e, r) && (e.data.attrs = {
		...e.data.attrs,
		tabindex: 0,
		role: "dialog",
		"aria-labelledby": `content-${t}`,
		"aria-describedby": `content-${t}`
	}), e.data?.class?.canvas && (e.data.attrs = {
		...e.data.attrs,
		id: `content-${t}`
	});
}), e), lc = "@appcues/close", uc = { markComplete: !0 };
zi(lc, ({ markComplete: e = uc.markComplete } = uc, { stopExperience: t, step: n }) => {
	e ? t() : n.dismissExperience();
});
//#endregion
//#region src/actions/redirectTo/redirect-to.js
var dc = "@appcues/redirectTo";
function fc(e, t) {
	if (/^https?:\/\//i.test(t)) return t;
	try {
		return new URL(t, e.location.origin).href;
	} catch {
		return t;
	}
}
zi(dc, ({ url: e = "", openInNewWindow: t = !1 } = {}, { reportError: n, getWindowReference: r }) => {
	if (!e) {
		n("Can't redirect to undefined URL");
		return;
	}
	let i = r(), a = fc(i, e);
	i.open(a, t ? "_blank" : "_self", "noopener");
}), zi("@appcues/trackEvent", ({ name: e, properties: t = {} }, { sendCustomEvent: n }) => {
	n(e, t);
}), zi("@appcues/triggerFlow", ({ flowId: e, url: t, prefetch: n = !1 } = {}, { showFlow: r }) => {
	r({
		flowId: e,
		url: t,
		prefetch: n
	});
});
//#endregion
//#region src/lib/objects.js
var pc = (e) => Object.keys(e).length === 0, mc = (e) => {
	switch (e) {
		case "date.now": return Date.now();
		default: return null;
	}
}, hc = (e) => typeof e == "string" && e.startsWith("{") && e.endsWith("}"), gc = (e) => Object.entries(e).reduce((e, [t, n]) => {
	if (hc(n)) {
		let r = mc(n.slice(1, -1));
		return {
			...e,
			[t]: r ?? n
		};
	}
	return {
		...e,
		[t]: n
	};
}, {});
zi("@appcues/setUserProperties", (e, { updateUserProfile: t }) => {
	pc(e) || t(gc(e));
}), zi("@appcues/toggleActions", ({ actions: e = [], target: t } = {}, n) => {
	let r = n.querySelector(t.selector);
	r.length !== 0 && e.forEach((e) => {
		let t = `toggleActions_${e.id}`, i = n.getAction(e.type), [a] = r, o = !a.getAttribute(t);
		i && o && (i(e.config, n), a.setAttribute(t, !0)), o || a.removeAttribute(t);
	});
});
//#endregion
//#region src/actions/conditional/evaluate.js
var _c = (e) => {
	let t = e == null ? "" : String(e);
	try {
		let e = JSON.parse(t);
		if (Array.isArray(e)) return {
			raw: t,
			items: e.map(String)
		};
	} catch {}
	return {
		raw: t,
		items: [t]
	};
}, vc = (e) => {
	if (typeof e == "string" && e.trim() === "") return NaN;
	let t = Number(e);
	return Number.isFinite(t) ? t : NaN;
}, yc = (e, t, n) => {
	let { raw: r, items: i } = _c(e), a = n == null ? "" : String(n);
	switch (t) {
		case "==": return i.includes(a) || r === a;
		case "!=": return !i.includes(a) && r !== a;
		case "*": return i.some((e) => e.includes(a)) || r.includes(a);
		case "!*": return i.every((e) => !e.includes(a)) && !r.includes(a);
		case "^": return i.some((e) => e.startsWith(a)) || r.startsWith(a);
		case "!^": return i.every((e) => !e.startsWith(a)) && !r.startsWith(a);
		case "$": return i.some((e) => e.endsWith(a)) || r.endsWith(a);
		case "!$": return i.every((e) => !e.endsWith(a)) && !r.endsWith(a);
		case "regex": try {
			let e = new RegExp(a);
			return i.some((t) => e.test(t)) || e.test(r);
		} catch {
			return !1;
		}
		case ">": return vc(r) > vc(a);
		case ">=": return vc(r) >= vc(a);
		case "<": return vc(r) < vc(a);
		case "<=": return vc(r) <= vc(a);
		default: return !1;
	}
}, bc = (e) => String(e ?? "").replace(/^\{\{|\}\}$/g, "").replace(/^user\./, ""), xc = "_appcuesSatisfaction_MostRecentNPSScore", Sc = [
	"promoter",
	"passive",
	"detractor"
], Cc = (e) => {
	if (e == null || e === "") return;
	let t = vc(e);
	if (Number.isFinite(t)) {
		if (t >= 9 && t <= 10) return "promoter";
		if (t >= 7 && t <= 8) return "passive";
		if (t >= 0 && t <= 6) return "detractor";
	}
}, wc = (e) => e === null, Tc = (e) => !!e?.block && !!e?.operator, Ec = (e) => !!bc(e?.token) && !!e?.operator, Dc = (e) => Sc.includes(e?.category), Oc = (e) => e == null ? !1 : e.survey ? !Tc(e.survey) : e.token ? !Ec(e.token) : e.nps ? !Dc(e.nps) : !0, kc = "survey-", Ac = /* @__PURE__ */ new Map(), jc = (e, t) => {
	if (!e) return;
	let n = new FormData(e).getAll(`${kc}${t}`);
	if (n.length !== 0) return n.length > 1 ? JSON.stringify(n) : n[0];
}, Mc = (e) => e?.target?.form ?? e?.target?.closest?.("form") ?? null, Nc = (e, t) => {
	if (!e || !t) return;
	let n = new FormData(t), r = { ...Ac.get(e) };
	for (let e of new Set(n.keys())) if (e.startsWith("survey-")) {
		let t = e.slice(7), i = n.getAll(e);
		r[t] = i.length > 1 ? JSON.stringify(i) : i[0] ?? "";
	}
	Ac.set(e, r);
}, Pc = (e, t) => Ac.get(e)?.[t], Fc = (e, t) => jc(Mc(e), t), Ic = (e, t, n) => {
	let r = Fc(n, t);
	return r === void 0 ? Pc(e, t) : r;
}, Lc = (e) => {
	e && Ac.delete(e);
}, Rc = "@appcues/conditional", zc = (e, t) => {
	let n = bc(e);
	if (!n) return;
	let r = typeof t == "function" ? t() : {};
	if (r != null && Object.hasOwn(r, n)) return r[n];
}, Bc = (e, t, n) => {
	if (wc(e)) return !0;
	if (Oc(e)) return !1;
	if (e.survey) {
		let { block: r, operator: i, value: a } = e.survey, o = Ic(t.getExperienceId?.(), r, n);
		return o === void 0 || o === "" && !(i === "==" && (a == null || a === "")) ? !1 : yc(o, i, a);
	}
	if (e.token) {
		let { token: n, operator: r, value: i } = e.token, a = zc(n, t.getUserProfile);
		return a == null ? !1 : yc(a, r, i);
	}
	if (e.nps) {
		let n = (typeof t.getUserProfile == "function" ? t.getUserProfile() : {})?.[xc], r = Cc(n);
		return r ? r === e.nps.category : !1;
	}
	return !1;
};
zi(Rc, (e = {}, t, n) => {
	((e.checks ?? []).find((e) => Bc(e.condition, t, n))?.actions ?? []).forEach((e) => {
		let r = t.getAction?.(e.type);
		r && r(ji(e.config, t.getLocaleId?.()), t, n);
	});
});
//#endregion
//#region ../../node_modules/intl-locale-textinfo-polyfill/lib/Locale.js
var Vc = /([\.\*\+\^\$\[\]\\\(\)\|\{\}\,\-\:\?])/g, Hc = /^([a-zA-Z]{2,3}|[a-zA-Z]{5,8})(-[a-zA-Z]{4})?(-(?:[a-zA-Z]{2}|\d{3}))?(-(?:[a-zA-Z\d]{5,8}|\d[a-zA-Z\d]{3}))?$/, Uc = class e {
	constructor(e) {
		if (typeof e != "string") throw TypeError("A string argument is expected");
		if (!Hc.test(e)) throw RangeError("A proper locale must be provided");
		this._locale = e;
	}
	static _escapeRegExpPattern(e) {
		return typeof e == "string" ? e.replace(Vc, "\\$1") : e;
	}
	static _toLowerCase(e, t) {
		return typeof e == "string" ? e.toLowerCase() : t && e;
	}
	static _toUpperCase(e, t) {
		return typeof e == "string" ? e.toUpperCase() : t && e;
	}
	static _trim(e, t, n) {
		let r = [], i, a = function(e) {
			r.push("^" + e + "+|" + e + "+$");
		};
		if (typeof t == "boolean" && (n = t, t = null), typeof e != "string") return n ? e : void 0;
		Array.isArray(t) && t.map((e) => {
			a(this._escapeRegExpPattern(e));
		}), typeof t == "string" && a(this._escapeRegExpPattern(t)), t || a("\\s");
		let o = "(" + r.join("|") + ")";
		for (i = new RegExp(o, "g"); e.match(i);) e = e.replace(i, "");
		return e;
	}
	static _parseLocale(e) {
		if (typeof e != "string") return;
		let t = Hc.exec(e), n, r, i;
		if (!e || !t) return;
		let a = this._trim(t[2], ["-", "_"]), o = this._trim(t[3], ["-", "_"]);
		return n = this._toLowerCase(t[1]), r = this._toLowerCase(a) || r, i = this._toUpperCase(o) || i, {
			lang: n,
			script: r,
			countryCode: i
		};
	}
	_isRtlLang() {
		let { lang: t, script: n } = e._parseLocale(this._locale);
		return n ? e._RTL_SCRIPTS.indexOf(n) >= 0 : e._BIDI_RTL_LANGS.indexOf(t) >= 0;
	}
	get textInfo() {
		return { direction: this._isRtlLang() ? "rtl" : "ltr" };
	}
};
Uc._RTL_SCRIPTS = /* @__PURE__ */ "adlm.arab.armi.avst.chrs.cprt.elym.hatr.hebr.hung.khar.lydi.mand.mani.mend.merc.mero.narb.nbat.nkoo.orkh.ougr.palm.phli.phlp.phnx.prti.rohg.samr.sarb.sogd.sogo.syrc.thaa.yezi".split("."), Uc._BIDI_RTL_LANGS = /* @__PURE__ */ "ae.aeb.ajt.apc.apd.ar.ara.arb.arc.arq.ars.ary.arz.ave.avl.bal.bcc.bej.bft.bgn.bqi.brh.cja.ckb.cld.dcc.dgl.div.drw.dv.fa.fas.fia.fub.gbz.gjk.gju.glk.grc.gwc.gwt.haz.he.heb.hnd.hno.iw.ji.kas.kby.khw.ks.kvx.kxp.kzh.lad.lah.lki.lrc.luz.mde.mfa.mki.mvy.myz.mzn.nqo.oru.ota.otk.oui.pal.pbu.per.pes.phl.phn.pnb.pra.prd.prs.ps.pus.rhg.rmt.scl.sd.sdh.shu.skr.smp.snd.sog.swb.syr.tnf.trw.ug.uig.ur.urd.wni.xco.xld.xmn.xmr.xna.xpr.xsa.ydd.yi.yid.zdj".split(".");
//#endregion
//#region src/traits/contentDirection/content-direction.js
var Wc = "@appcues/content-direction";
function Gc(e) {
	try {
		return new Uc(e).textInfo;
	} catch {
		return { direction: "ltr" };
	}
}
var Kc = ({ updateRootStyle: e, getTraitConfig: t }) => {
	let n = navigator.languages ? navigator.languages[0] : navigator.language || navigator.userLanguage, { currentLanguage: r = n, forceDirection: i = null } = t(), a = Gc(r);
	e({ direction: i ?? a.direction }, { forceUpdate: !0 });
};
Y(Wc, ({ addHook: e }) => {
	e("step.begin", Kc), e("step.container_change", Kc);
});
//#endregion
//#region ../../node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
var qc = [
	"top",
	"right",
	"bottom",
	"left"
], Jc = ["start", "end"], Yc = /* @__PURE__ */ qc.reduce((e, t) => e.concat(t, t + "-" + Jc[0], t + "-" + Jc[1]), []), Xc = Math.min, Zc = Math.max, Qc = Math.round, $c = (e) => ({
	x: e,
	y: e
}), el = {
	left: "right",
	right: "left",
	bottom: "top",
	top: "bottom"
}, tl = {
	start: "end",
	end: "start"
};
function nl(e, t, n) {
	return Zc(e, Xc(t, n));
}
function rl(e, t) {
	return typeof e == "function" ? e(t) : e;
}
function il(e) {
	return e.split("-")[0];
}
function al(e) {
	return e.split("-")[1];
}
function ol(e) {
	return e === "x" ? "y" : "x";
}
function sl(e) {
	return e === "y" ? "height" : "width";
}
var cl = /* @__PURE__ */ new Set(["top", "bottom"]);
function ll(e) {
	return cl.has(il(e)) ? "y" : "x";
}
function ul(e) {
	return ol(ll(e));
}
function dl(e, t, n) {
	n === void 0 && (n = !1);
	let r = al(e), i = ul(e), a = sl(i), o = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
	return t.reference[a] > t.floating[a] && (o = pl(o)), [o, pl(o)];
}
function fl(e) {
	return e.replace(/start|end/g, (e) => tl[e]);
}
function pl(e) {
	return e.replace(/left|right|bottom|top/g, (e) => el[e]);
}
function ml(e) {
	return {
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		...e
	};
}
function hl(e) {
	return typeof e == "number" ? {
		top: e,
		right: e,
		bottom: e,
		left: e
	} : ml(e);
}
function gl(e) {
	let { x: t, y: n, width: r, height: i } = e;
	return {
		width: r,
		height: i,
		top: n,
		left: t,
		right: t + r,
		bottom: n + i,
		x: t,
		y: n
	};
}
//#endregion
//#region node_modules/@floating-ui/core/dist/floating-ui.core.mjs
function _l(e, t, n) {
	let { reference: r, floating: i } = e, a = ll(t), o = ul(t), s = sl(o), c = il(t), l = a === "y", u = r.x + r.width / 2 - i.width / 2, d = r.y + r.height / 2 - i.height / 2, f = r[s] / 2 - i[s] / 2, p;
	switch (c) {
		case "top":
			p = {
				x: u,
				y: r.y - i.height
			};
			break;
		case "bottom":
			p = {
				x: u,
				y: r.y + r.height
			};
			break;
		case "right":
			p = {
				x: r.x + r.width,
				y: d
			};
			break;
		case "left":
			p = {
				x: r.x - i.width,
				y: d
			};
			break;
		default: p = {
			x: r.x,
			y: r.y
		};
	}
	switch (al(t)) {
		case "start":
			p[o] -= f * (n && l ? -1 : 1);
			break;
		case "end":
			p[o] += f * (n && l ? -1 : 1);
			break;
	}
	return p;
}
var vl = async (e, t, n) => {
	let { placement: r = "bottom", strategy: i = "absolute", middleware: a = [], platform: o } = n, s = a.filter(Boolean), c = await (o.isRTL == null ? void 0 : o.isRTL(t)), l = await o.getElementRects({
		reference: e,
		floating: t,
		strategy: i
	}), { x: u, y: d } = _l(l, r, c), f = r, p = {}, m = 0;
	for (let n = 0; n < s.length; n++) {
		let { name: a, fn: h } = s[n], { x: g, y: _, data: v, reset: y } = await h({
			x: u,
			y: d,
			initialPlacement: r,
			placement: f,
			strategy: i,
			middlewareData: p,
			rects: l,
			platform: o,
			elements: {
				reference: e,
				floating: t
			}
		});
		u = g ?? u, d = _ ?? d, p = {
			...p,
			[a]: {
				...p[a],
				...v
			}
		}, y && m <= 50 && (m++, typeof y == "object" && (y.placement && (f = y.placement), y.rects && (l = y.rects === !0 ? await o.getElementRects({
			reference: e,
			floating: t,
			strategy: i
		}) : y.rects), {x: u, y: d} = _l(l, f, c)), n = -1);
	}
	return {
		x: u,
		y: d,
		placement: f,
		strategy: i,
		middlewareData: p
	};
};
async function yl(e, t) {
	t === void 0 && (t = {});
	let { x: n, y: r, platform: i, rects: a, elements: o, strategy: s } = e, { boundary: c = "clippingAncestors", rootBoundary: l = "viewport", elementContext: u = "floating", altBoundary: d = !1, padding: f = 0 } = rl(t, e), p = hl(f), m = o[d ? u === "floating" ? "reference" : "floating" : u], h = gl(await i.getClippingRect({
		element: await (i.isElement == null ? void 0 : i.isElement(m)) ?? !0 ? m : m.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(o.floating)),
		boundary: c,
		rootBoundary: l,
		strategy: s
	})), g = u === "floating" ? {
		x: n,
		y: r,
		width: a.floating.width,
		height: a.floating.height
	} : a.reference, _ = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(o.floating)), v = await (i.isElement == null ? void 0 : i.isElement(_)) && await (i.getScale == null ? void 0 : i.getScale(_)) || {
		x: 1,
		y: 1
	}, y = gl(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
		elements: o,
		rect: g,
		offsetParent: _,
		strategy: s
	}) : g);
	return {
		top: (h.top - y.top + p.top) / v.y,
		bottom: (y.bottom - h.bottom + p.bottom) / v.y,
		left: (h.left - y.left + p.left) / v.x,
		right: (y.right - h.right + p.right) / v.x
	};
}
var bl = (e) => ({
	name: "arrow",
	options: e,
	async fn(t) {
		let { x: n, y: r, placement: i, rects: a, platform: o, elements: s, middlewareData: c } = t, { element: l, padding: u = 0 } = rl(e, t) || {};
		if (l == null) return {};
		let d = hl(u), f = {
			x: n,
			y: r
		}, p = ul(i), m = sl(p), h = await o.getDimensions(l), g = p === "y", _ = g ? "top" : "left", v = g ? "bottom" : "right", y = g ? "clientHeight" : "clientWidth", b = a.reference[m] + a.reference[p] - f[p] - a.floating[m], x = f[p] - a.reference[p], S = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(l)), C = S ? S[y] : 0;
		(!C || !await (o.isElement == null ? void 0 : o.isElement(S))) && (C = s.floating[y] || a.floating[m]);
		let w = b / 2 - x / 2, T = C / 2 - h[m] / 2 - 1, E = Xc(d[_], T), D = Xc(d[v], T), O = E, k = C - h[m] - D, A = C / 2 - h[m] / 2 + w, j = nl(O, A, k), M = !c.arrow && al(i) != null && A !== j && a.reference[m] / 2 - (A < O ? E : D) - h[m] / 2 < 0, N = M ? A < O ? A - O : A - k : 0;
		return {
			[p]: f[p] + N,
			data: {
				[p]: j,
				centerOffset: A - j - N,
				...M && { alignmentOffset: N }
			},
			reset: M
		};
	}
});
function xl(e, t, n) {
	return (e ? [...n.filter((t) => al(t) === e), ...n.filter((t) => al(t) !== e)] : n.filter((e) => il(e) === e)).filter((n) => e ? al(n) === e || (t ? fl(n) !== n : !1) : !0);
}
var Sl = function(e) {
	return e === void 0 && (e = {}), {
		name: "autoPlacement",
		options: e,
		async fn(t) {
			let { rects: n, middlewareData: r, placement: i, platform: a, elements: o } = t, { crossAxis: s = !1, alignment: c, allowedPlacements: l = Yc, autoAlignment: u = !0, ...d } = rl(e, t), f = c !== void 0 || l === Yc ? xl(c || null, u, l) : l, p = await yl(t, d), m = r.autoPlacement?.index || 0, h = f[m];
			if (h == null) return {};
			let g = dl(h, n, await (a.isRTL == null ? void 0 : a.isRTL(o.floating)));
			if (i !== h) return { reset: { placement: f[0] } };
			let _ = [
				p[il(h)],
				p[g[0]],
				p[g[1]]
			], v = [...r.autoPlacement?.overflows || [], {
				placement: h,
				overflows: _
			}], y = f[m + 1];
			if (y) return {
				data: {
					index: m + 1,
					overflows: v
				},
				reset: { placement: y }
			};
			let b = v.map((e) => {
				let t = al(e.placement);
				return [
					e.placement,
					t && s ? e.overflows.slice(0, 2).reduce((e, t) => e + t, 0) : e.overflows[0],
					e.overflows
				];
			}).sort((e, t) => e[1] - t[1]), x = b.filter((e) => e[2].slice(0, al(e[0]) ? 2 : 3).every((e) => e <= 0))[0]?.[0] || b[0][0];
			return x === i ? {} : {
				data: {
					index: m + 1,
					overflows: v
				},
				reset: { placement: x }
			};
		}
	};
};
function Cl(e, t) {
	return {
		top: e.top - t.height,
		right: e.right - t.width,
		bottom: e.bottom - t.height,
		left: e.left - t.width
	};
}
function wl(e) {
	return qc.some((t) => e[t] >= 0);
}
var Tl = function(e) {
	return e === void 0 && (e = {}), {
		name: "hide",
		options: e,
		async fn(t) {
			let { rects: n } = t, { strategy: r = "referenceHidden", ...i } = rl(e, t);
			switch (r) {
				case "referenceHidden": {
					let e = Cl(await yl(t, {
						...i,
						elementContext: "reference"
					}), n.reference);
					return { data: {
						referenceHiddenOffsets: e,
						referenceHidden: wl(e)
					} };
				}
				case "escaped": {
					let e = Cl(await yl(t, {
						...i,
						altBoundary: !0
					}), n.floating);
					return { data: {
						escapedOffsets: e,
						escaped: wl(e)
					} };
				}
				default: return {};
			}
		}
	};
}, El = /* @__PURE__ */ new Set(["left", "top"]);
async function Dl(e, t) {
	let { placement: n, platform: r, elements: i } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), o = il(n), s = al(n), c = ll(n) === "y", l = El.has(o) ? -1 : 1, u = a && c ? -1 : 1, d = rl(t, e), { mainAxis: f, crossAxis: p, alignmentAxis: m } = typeof d == "number" ? {
		mainAxis: d,
		crossAxis: 0,
		alignmentAxis: null
	} : {
		mainAxis: d.mainAxis || 0,
		crossAxis: d.crossAxis || 0,
		alignmentAxis: d.alignmentAxis
	};
	return s && typeof m == "number" && (p = s === "end" ? m * -1 : m), c ? {
		x: p * u,
		y: f * l
	} : {
		x: f * l,
		y: p * u
	};
}
var Ol = function(e) {
	return e === void 0 && (e = 0), {
		name: "offset",
		options: e,
		async fn(t) {
			var n;
			let { x: r, y: i, placement: a, middlewareData: o } = t, s = await Dl(t, e);
			return a === o.offset?.placement && (n = o.arrow) != null && n.alignmentOffset ? {} : {
				x: r + s.x,
				y: i + s.y,
				data: {
					...s,
					placement: a
				}
			};
		}
	};
}, kl = function(e) {
	return e === void 0 && (e = {}), {
		name: "shift",
		options: e,
		async fn(t) {
			let { x: n, y: r, placement: i } = t, { mainAxis: a = !0, crossAxis: o = !1, limiter: s = { fn: (e) => {
				let { x: t, y: n } = e;
				return {
					x: t,
					y: n
				};
			} }, ...c } = rl(e, t), l = {
				x: n,
				y: r
			}, u = await yl(t, c), d = ll(il(i)), f = ol(d), p = l[f], m = l[d];
			if (a) {
				let e = f === "y" ? "top" : "left", t = f === "y" ? "bottom" : "right", n = p + u[e], r = p - u[t];
				p = nl(n, p, r);
			}
			if (o) {
				let e = d === "y" ? "top" : "left", t = d === "y" ? "bottom" : "right", n = m + u[e], r = m - u[t];
				m = nl(n, m, r);
			}
			let h = s.fn({
				...t,
				[f]: p,
				[d]: m
			});
			return {
				...h,
				data: {
					x: h.x - n,
					y: h.y - r,
					enabled: {
						[f]: a,
						[d]: o
					}
				}
			};
		}
	};
};
//#endregion
//#region ../../node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
function Al() {
	return typeof window < "u";
}
function jl(e) {
	return Nl(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Q(e) {
	var t;
	return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Ml(e) {
	return ((Nl(e) ? e.ownerDocument : e.document) || window.document)?.documentElement;
}
function Nl(e) {
	return Al() ? e instanceof Node || e instanceof Q(e).Node : !1;
}
function Pl(e) {
	return Al() ? e instanceof Element || e instanceof Q(e).Element : !1;
}
function Fl(e) {
	return Al() ? e instanceof HTMLElement || e instanceof Q(e).HTMLElement : !1;
}
function Il(e) {
	return !Al() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Q(e).ShadowRoot;
}
var Ll = /* @__PURE__ */ new Set(["inline", "contents"]);
function Rl(e) {
	let { overflow: t, overflowX: n, overflowY: r, display: i } = $(e);
	return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !Ll.has(i);
}
var zl = /* @__PURE__ */ new Set([
	"table",
	"td",
	"th"
]);
function Bl(e) {
	return zl.has(jl(e));
}
var Vl = [":popover-open", ":modal"];
function Hl(e) {
	return Vl.some((t) => {
		try {
			return e.matches(t);
		} catch {
			return !1;
		}
	});
}
var Ul = [
	"transform",
	"translate",
	"scale",
	"rotate",
	"perspective"
], Wl = [
	"transform",
	"translate",
	"scale",
	"rotate",
	"perspective",
	"filter"
], Gl = [
	"paint",
	"layout",
	"strict",
	"content"
];
function Kl(e) {
	let t = Jl(), n = Pl(e) ? $(e) : e;
	return Ul.some((e) => n[e] ? n[e] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || Wl.some((e) => (n.willChange || "").includes(e)) || Gl.some((e) => (n.contain || "").includes(e));
}
function ql(e) {
	let t = Ql(e);
	for (; Fl(t) && !Xl(t);) {
		if (Kl(t)) return t;
		if (Hl(t)) return null;
		t = Ql(t);
	}
	return null;
}
function Jl() {
	return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
var Yl = /* @__PURE__ */ new Set([
	"html",
	"body",
	"#document"
]);
function Xl(e) {
	return Yl.has(jl(e));
}
function $(e) {
	return Q(e).getComputedStyle(e);
}
function Zl(e) {
	return Pl(e) ? {
		scrollLeft: e.scrollLeft,
		scrollTop: e.scrollTop
	} : {
		scrollLeft: e.scrollX,
		scrollTop: e.scrollY
	};
}
function Ql(e) {
	if (jl(e) === "html") return e;
	let t = e.assignedSlot || e.parentNode || Il(e) && e.host || Ml(e);
	return Il(t) ? t.host : t;
}
function $l(e) {
	let t = Ql(e);
	return Xl(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Fl(t) && Rl(t) ? t : $l(t);
}
function eu(e, t, n) {
	t === void 0 && (t = []), n === void 0 && (n = !0);
	let r = $l(e), i = r === e.ownerDocument?.body, a = Q(r);
	if (i) {
		let e = tu(a);
		return t.concat(a, a.visualViewport || [], Rl(r) ? r : [], e && n ? eu(e) : []);
	}
	return t.concat(r, eu(r, [], n));
}
function tu(e) {
	return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
//#endregion
//#region node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs
function nu(e) {
	let t = $(e), n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0, i = Fl(e), a = i ? e.offsetWidth : n, o = i ? e.offsetHeight : r, s = Qc(n) !== a || Qc(r) !== o;
	return s && (n = a, r = o), {
		width: n,
		height: r,
		$: s
	};
}
function ru(e) {
	return Pl(e) ? e : e.contextElement;
}
function iu(e) {
	let t = ru(e);
	if (!Fl(t)) return $c(1);
	let n = t.getBoundingClientRect(), { width: r, height: i, $: a } = nu(t), o = (a ? Qc(n.width) : n.width) / r, s = (a ? Qc(n.height) : n.height) / i;
	return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
		x: o,
		y: s
	};
}
var au = /* @__PURE__ */ $c(0);
function ou(e) {
	let t = Q(e);
	return !Jl() || !t.visualViewport ? au : {
		x: t.visualViewport.offsetLeft,
		y: t.visualViewport.offsetTop
	};
}
function su(e, t, n) {
	return t === void 0 && (t = !1), !n || t && n !== Q(e) ? !1 : t;
}
function cu(e, t, n, r) {
	t === void 0 && (t = !1), n === void 0 && (n = !1);
	let i = e.getBoundingClientRect(), a = ru(e), o = $c(1);
	t && (r ? Pl(r) && (o = iu(r)) : o = iu(e));
	let s = su(a, n, r) ? ou(a) : $c(0), c = (i.left + s.x) / o.x, l = (i.top + s.y) / o.y, u = i.width / o.x, d = i.height / o.y;
	if (a) {
		let e = Q(a), t = r && Pl(r) ? Q(r) : r, n = e, i = tu(n);
		for (; i && r && t !== n;) {
			let e = iu(i), t = i.getBoundingClientRect(), r = $(i), a = t.left + (i.clientLeft + parseFloat(r.paddingLeft)) * e.x, o = t.top + (i.clientTop + parseFloat(r.paddingTop)) * e.y;
			c *= e.x, l *= e.y, u *= e.x, d *= e.y, c += a, l += o, n = Q(i), i = tu(n);
		}
	}
	return gl({
		width: u,
		height: d,
		x: c,
		y: l
	});
}
function lu(e, t) {
	let n = Zl(e).scrollLeft;
	return t ? t.left + n : cu(Ml(e)).left + n;
}
function uu(e, t) {
	let n = e.getBoundingClientRect();
	return {
		x: n.left + t.scrollLeft - lu(e, n),
		y: n.top + t.scrollTop
	};
}
function du(e) {
	let { elements: t, rect: n, offsetParent: r, strategy: i } = e, a = i === "fixed", o = Ml(r), s = t ? Hl(t.floating) : !1;
	if (r === o || s && a) return n;
	let c = {
		scrollLeft: 0,
		scrollTop: 0
	}, l = $c(1), u = $c(0), d = Fl(r);
	if ((d || !d && !a) && ((jl(r) !== "body" || Rl(o)) && (c = Zl(r)), Fl(r))) {
		let e = cu(r);
		l = iu(r), u.x = e.x + r.clientLeft, u.y = e.y + r.clientTop;
	}
	let f = o && !d && !a ? uu(o, c) : $c(0);
	return {
		width: n.width * l.x,
		height: n.height * l.y,
		x: n.x * l.x - c.scrollLeft * l.x + u.x + f.x,
		y: n.y * l.y - c.scrollTop * l.y + u.y + f.y
	};
}
function fu(e) {
	return Array.from(e.getClientRects());
}
function pu(e) {
	let t = Ml(e), n = Zl(e), r = e.ownerDocument.body, i = Zc(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), a = Zc(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight), o = -n.scrollLeft + lu(e), s = -n.scrollTop;
	return $(r).direction === "rtl" && (o += Zc(t.clientWidth, r.clientWidth) - i), {
		width: i,
		height: a,
		x: o,
		y: s
	};
}
var mu = 25;
function hu(e, t) {
	let n = Q(e), r = Ml(e), i = n.visualViewport, a = r.clientWidth, o = r.clientHeight, s = 0, c = 0;
	if (i) {
		a = i.width, o = i.height;
		let e = Jl();
		(!e || e && t === "fixed") && (s = i.offsetLeft, c = i.offsetTop);
	}
	let l = lu(r);
	if (l <= 0) {
		let e = r.ownerDocument, t = e.body, n = getComputedStyle(t), i = e.compatMode === "CSS1Compat" && parseFloat(n.marginLeft) + parseFloat(n.marginRight) || 0, o = Math.abs(r.clientWidth - t.clientWidth - i);
		o <= mu && (a -= o);
	} else l <= mu && (a += l);
	return {
		width: a,
		height: o,
		x: s,
		y: c
	};
}
var gu = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function _u(e, t) {
	let n = cu(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, a = Fl(e) ? iu(e) : $c(1);
	return {
		width: e.clientWidth * a.x,
		height: e.clientHeight * a.y,
		x: i * a.x,
		y: r * a.y
	};
}
function vu(e, t, n) {
	let r;
	if (t === "viewport") r = hu(e, n);
	else if (t === "document") r = pu(Ml(e));
	else if (Pl(t)) r = _u(t, n);
	else {
		let n = ou(e);
		r = {
			x: t.x - n.x,
			y: t.y - n.y,
			width: t.width,
			height: t.height
		};
	}
	return gl(r);
}
function yu(e, t) {
	let n = Ql(e);
	return n === t || !Pl(n) || Xl(n) ? !1 : $(n).position === "fixed" || yu(n, t);
}
function bu(e, t) {
	let n = t.get(e);
	if (n) return n;
	let r = eu(e, [], !1).filter((e) => Pl(e) && jl(e) !== "body"), i = null, a = $(e).position === "fixed", o = a ? Ql(e) : e;
	for (; Pl(o) && !Xl(o);) {
		let t = $(o), n = Kl(o);
		!n && t.position === "fixed" && (i = null), (a ? !n && !i : !n && t.position === "static" && i && gu.has(i.position) || Rl(o) && !n && yu(e, o)) ? r = r.filter((e) => e !== o) : i = t, o = Ql(o);
	}
	return t.set(e, r), r;
}
function xu(e) {
	let { element: t, boundary: n, rootBoundary: r, strategy: i } = e, a = [...n === "clippingAncestors" ? Hl(t) ? [] : bu(t, this._c) : [].concat(n), r], o = a[0], s = a.reduce((e, n) => {
		let r = vu(t, n, i);
		return e.top = Zc(r.top, e.top), e.right = Xc(r.right, e.right), e.bottom = Xc(r.bottom, e.bottom), e.left = Zc(r.left, e.left), e;
	}, vu(t, o, i));
	return {
		width: s.right - s.left,
		height: s.bottom - s.top,
		x: s.left,
		y: s.top
	};
}
function Su(e) {
	let { width: t, height: n } = nu(e);
	return {
		width: t,
		height: n
	};
}
function Cu(e, t, n) {
	let r = Fl(t), i = Ml(t), a = n === "fixed", o = cu(e, !0, a, t), s = {
		scrollLeft: 0,
		scrollTop: 0
	}, c = $c(0);
	function l() {
		c.x = lu(i);
	}
	if (r || !r && !a) if ((jl(t) !== "body" || Rl(i)) && (s = Zl(t)), r) {
		let e = cu(t, !0, a, t);
		c.x = e.x + t.clientLeft, c.y = e.y + t.clientTop;
	} else i && l();
	a && !r && i && l();
	let u = i && !r && !a ? uu(i, s) : $c(0);
	return {
		x: o.left + s.scrollLeft - c.x - u.x,
		y: o.top + s.scrollTop - c.y - u.y,
		width: o.width,
		height: o.height
	};
}
function wu(e) {
	return $(e).position === "static";
}
function Tu(e, t) {
	if (!Fl(e) || $(e).position === "fixed") return null;
	if (t) return t(e);
	let n = e.offsetParent;
	return Ml(e) === n && (n = n.ownerDocument.body), n;
}
function Eu(e, t) {
	let n = Q(e);
	if (Hl(e)) return n;
	if (!Fl(e)) {
		let t = Ql(e);
		for (; t && !Xl(t);) {
			if (Pl(t) && !wu(t)) return t;
			t = Ql(t);
		}
		return n;
	}
	let r = Tu(e, t);
	for (; r && Bl(r) && wu(r);) r = Tu(r, t);
	return r && Xl(r) && wu(r) && !Kl(r) ? n : r || ql(e) || n;
}
var Du = async function(e) {
	let t = this.getOffsetParent || Eu, n = this.getDimensions, r = await n(e.floating);
	return {
		reference: Cu(e.reference, await t(e.floating), e.strategy),
		floating: {
			x: 0,
			y: 0,
			width: r.width,
			height: r.height
		}
	};
};
function Ou(e) {
	return $(e).direction === "rtl";
}
var ku = {
	convertOffsetParentRelativeRectToViewportRelativeRect: du,
	getDocumentElement: Ml,
	getClippingRect: xu,
	getOffsetParent: Eu,
	getElementRects: Du,
	getClientRects: fu,
	getDimensions: Su,
	getScale: iu,
	isElement: Pl,
	isRTL: Ou
}, Au = Ol, ju = Sl, Mu = kl, Nu = Tl, Pu = bl, Fu = (e, t, n) => {
	let r = /* @__PURE__ */ new Map(), i = {
		platform: ku,
		...n
	}, a = {
		...i.platform,
		_c: r
	};
	return vl(e, t, {
		...i,
		platform: a
	});
}, Iu = /* @__PURE__ */ s(((e, t) => {
	var n = "Expected a function", r = NaN, i = "[object Symbol]", a = /^\s+|\s+$/g, o = /^[-+]0x[0-9a-f]+$/i, s = /^0b[01]+$/i, c = /^0o[0-7]+$/i, l = parseInt, u = typeof global == "object" && global && global.Object === Object && global, d = typeof self == "object" && self && self.Object === Object && self, f = u || d || Function("return this")(), p = Object.prototype.toString, m = Math.max, h = Math.min, g = function() {
		return f.Date.now();
	};
	function _(e, t, r) {
		var i, a, o, s, c, l, u = 0, d = !1, f = !1, p = !0;
		if (typeof e != "function") throw TypeError(n);
		t = x(t) || 0, v(r) && (d = !!r.leading, f = "maxWait" in r, o = f ? m(x(r.maxWait) || 0, t) : o, p = "trailing" in r ? !!r.trailing : p);
		function _(t) {
			var n = i, r = a;
			return i = a = void 0, u = t, s = e.apply(r, n), s;
		}
		function y(e) {
			return u = e, c = setTimeout(C, t), d ? _(e) : s;
		}
		function b(e) {
			var n = e - l, r = e - u, i = t - n;
			return f ? h(i, o - r) : i;
		}
		function S(e) {
			var n = e - l, r = e - u;
			return l === void 0 || n >= t || n < 0 || f && r >= o;
		}
		function C() {
			var e = g();
			if (S(e)) return w(e);
			c = setTimeout(C, b(e));
		}
		function w(e) {
			return c = void 0, p && i ? _(e) : (i = a = void 0, s);
		}
		function T() {
			c !== void 0 && clearTimeout(c), u = 0, i = l = a = c = void 0;
		}
		function E() {
			return c === void 0 ? s : w(g());
		}
		function D() {
			var e = g(), n = S(e);
			if (i = arguments, a = this, l = e, n) {
				if (c === void 0) return y(l);
				if (f) return c = setTimeout(C, t), _(l);
			}
			return c === void 0 && (c = setTimeout(C, t)), s;
		}
		return D.cancel = T, D.flush = E, D;
	}
	function v(e) {
		var t = typeof e;
		return !!e && (t == "object" || t == "function");
	}
	function y(e) {
		return !!e && typeof e == "object";
	}
	function b(e) {
		return typeof e == "symbol" || y(e) && p.call(e) == i;
	}
	function x(e) {
		if (typeof e == "number") return e;
		if (b(e)) return r;
		if (v(e)) {
			var t = typeof e.valueOf == "function" ? e.valueOf() : e;
			e = v(t) ? t + "" : t;
		}
		if (typeof e != "string") return e === 0 ? e : +e;
		e = e.replace(a, "");
		var n = s.test(e);
		return n || c.test(e) ? l(e.slice(2), n ? 2 : 8) : o.test(e) ? r : +e;
	}
	t.exports = _;
})), Lu = /* @__PURE__ */ s(((e, t) => {
	var n = 200, r = "__lodash_hash_undefined__", i = Infinity, a = "[object Function]", o = "[object GeneratorFunction]", s = /[\\^$.*+?()[\]{}|]/g, c = /^\[object .+?Constructor\]$/, l = typeof global == "object" && global && global.Object === Object && global, u = typeof self == "object" && self && self.Object === Object && self, d = l || u || Function("return this")();
	function f(e, t) {
		return !!(e && e.length) && h(e, t, 0) > -1;
	}
	function p(e, t, n) {
		for (var r = -1, i = e ? e.length : 0; ++r < i;) if (n(t, e[r])) return !0;
		return !1;
	}
	function m(e, t, n, r) {
		for (var i = e.length, a = n + (r ? 1 : -1); r ? a-- : ++a < i;) if (t(e[a], a, e)) return a;
		return -1;
	}
	function h(e, t, n) {
		if (t !== t) return m(e, g, n);
		for (var r = n - 1, i = e.length; ++r < i;) if (e[r] === t) return r;
		return -1;
	}
	function g(e) {
		return e !== e;
	}
	function _(e, t) {
		return e.has(t);
	}
	function v(e, t) {
		return e?.[t];
	}
	function y(e) {
		var t = !1;
		if (e != null && typeof e.toString != "function") try {
			t = !!(e + "");
		} catch {}
		return t;
	}
	function b(e) {
		var t = -1, n = Array(e.size);
		return e.forEach(function(e) {
			n[++t] = e;
		}), n;
	}
	var x = Array.prototype, S = Function.prototype, C = Object.prototype, w = d["__core-js_shared__"], T = function() {
		var e = /[^.]+$/.exec(w && w.keys && w.keys.IE_PROTO || "");
		return e ? "Symbol(src)_1." + e : "";
	}(), E = S.toString, D = C.hasOwnProperty, O = C.toString, k = RegExp("^" + E.call(D).replace(s, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), A = x.splice, j = ge(d, "Map"), M = ge(d, "Set"), N = ge(Object, "create");
	function P(e) {
		var t = -1, n = e ? e.length : 0;
		for (this.clear(); ++t < n;) {
			var r = e[t];
			this.set(r[0], r[1]);
		}
	}
	function F() {
		this.__data__ = N ? N(null) : {};
	}
	function ee(e) {
		return this.has(e) && delete this.__data__[e];
	}
	function te(e) {
		var t = this.__data__;
		if (N) {
			var n = t[e];
			return n === r ? void 0 : n;
		}
		return D.call(t, e) ? t[e] : void 0;
	}
	function I(e) {
		var t = this.__data__;
		return N ? t[e] !== void 0 : D.call(t, e);
	}
	function L(e, t) {
		var n = this.__data__;
		return n[e] = N && t === void 0 ? r : t, this;
	}
	P.prototype.clear = F, P.prototype.delete = ee, P.prototype.get = te, P.prototype.has = I, P.prototype.set = L;
	function R(e) {
		var t = -1, n = e ? e.length : 0;
		for (this.clear(); ++t < n;) {
			var r = e[t];
			this.set(r[0], r[1]);
		}
	}
	function z() {
		this.__data__ = [];
	}
	function ne(e) {
		var t = this.__data__, n = de(t, e);
		return n < 0 ? !1 : (n == t.length - 1 ? t.pop() : A.call(t, n, 1), !0);
	}
	function B(e) {
		var t = this.__data__, n = de(t, e);
		return n < 0 ? void 0 : t[n][1];
	}
	function V(e) {
		return de(this.__data__, e) > -1;
	}
	function re(e, t) {
		var n = this.__data__, r = de(n, e);
		return r < 0 ? n.push([e, t]) : n[r][1] = t, this;
	}
	R.prototype.clear = z, R.prototype.delete = ne, R.prototype.get = B, R.prototype.has = V, R.prototype.set = re;
	function H(e) {
		var t = -1, n = e ? e.length : 0;
		for (this.clear(); ++t < n;) {
			var r = e[t];
			this.set(r[0], r[1]);
		}
	}
	function ie() {
		this.__data__ = {
			hash: new P(),
			map: new (j || R)(),
			string: new P()
		};
	}
	function U(e) {
		return he(this, e).delete(e);
	}
	function ae(e) {
		return he(this, e).get(e);
	}
	function oe(e) {
		return he(this, e).has(e);
	}
	function se(e, t) {
		return he(this, e).set(e, t), this;
	}
	H.prototype.clear = ie, H.prototype.delete = U, H.prototype.get = ae, H.prototype.has = oe, H.prototype.set = se;
	function ce(e) {
		var t = -1, n = e ? e.length : 0;
		for (this.__data__ = new H(); ++t < n;) this.add(e[t]);
	}
	function le(e) {
		return this.__data__.set(e, r), this;
	}
	function ue(e) {
		return this.__data__.has(e);
	}
	ce.prototype.add = ce.prototype.push = le, ce.prototype.has = ue;
	function de(e, t) {
		for (var n = e.length; n--;) if (xe(e[n][0], t)) return n;
		return -1;
	}
	function fe(e) {
		return !Se(e) || ve(e) ? !1 : (W(e) || y(e) ? k : c).test(ye(e));
	}
	function pe(e, t, r) {
		var i = -1, a = f, o = e.length, s = !0, c = [], l = c;
		if (r) s = !1, a = p;
		else if (o >= n) {
			var u = t ? null : me(e);
			if (u) return b(u);
			s = !1, a = _, l = new ce();
		} else l = t ? [] : c;
		outer: for (; ++i < o;) {
			var d = e[i], m = t ? t(d) : d;
			if (d = r || d !== 0 ? d : 0, s && m === m) {
				for (var h = l.length; h--;) if (l[h] === m) continue outer;
				t && l.push(m), c.push(d);
			} else a(l, m, r) || (l !== c && l.push(m), c.push(d));
		}
		return c;
	}
	var me = M && 1 / b(new M([, -0]))[1] == i ? function(e) {
		return new M(e);
	} : Ce;
	function he(e, t) {
		var n = e.__data__;
		return _e(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
	}
	function ge(e, t) {
		var n = v(e, t);
		return fe(n) ? n : void 0;
	}
	function _e(e) {
		var t = typeof e;
		return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
	}
	function ve(e) {
		return !!T && T in e;
	}
	function ye(e) {
		if (e != null) {
			try {
				return E.call(e);
			} catch {}
			try {
				return e + "";
			} catch {}
		}
		return "";
	}
	function be(e) {
		return e && e.length ? pe(e) : [];
	}
	function xe(e, t) {
		return e === t || e !== e && t !== t;
	}
	function W(e) {
		var t = Se(e) ? O.call(e) : "";
		return t == a || t == o;
	}
	function Se(e) {
		var t = typeof e;
		return !!e && (t == "object" || t == "function");
	}
	function Ce() {}
	t.exports = be;
})), Ru = /* @__PURE__ */ u(Iu(), 1), zu = /* @__PURE__ */ u(Lu(), 1), Bu = (e, t, n, r, i, a) => {
	let o = `-${15 / 2}px`, s = e.split("-")[0], { staticSide: c, rotation: l, shadowOpacity: u } = {
		top: {
			staticSide: "bottom",
			rotation: 45,
			shadowOpacity: 40
		},
		bottom: {
			staticSide: "top",
			rotation: 225,
			shadowOpacity: 7
		},
		right: {
			staticSide: "left",
			rotation: 135,
			shadowOpacity: 7
		},
		left: {
			staticSide: "right",
			rotation: -45,
			shadowOpacity: 40
		}
	}[s], d = s === "top" || s === "bottom", f = 15 / 2, p = t != null && d && r > 0 ? Number.parseFloat(((t + f) / r * 100).toFixed(4)) : null, m = n != null && !d && i > 0 ? Number.parseFloat(((n + f) / i * 100).toFixed(4)) : null, h = p == null ? "" : `calc(${p}% - ${f}px)`, g = m == null ? "" : `calc(${m}% - ${f}px)`;
	return {
		boxShadow: `1px 1px 1px hsl(0deg 0% 13% / ${u}%)`,
		transform: `rotate(${l}deg)`,
		clipPath: "polygon(0% 100%, 100% 100%, 100% 0%)",
		left: h,
		top: g,
		right: "",
		bottom: "",
		[c]: o,
		zIndex: a
	};
}, Vu = (e, t) => {
	let n = e.slice(1);
	return t.find(({ config: e, type: t }) => t === "@appcues/overlay" && n === e.rootId);
}, Hu = (e, t) => {
	let n = 17.5;
	return t.includes("start") ? e - n : e + n;
}, Uu = ({ placementUnit: e, distance: t, skidding: n, placement: r, targetEl: i }) => {
	let a = r.startsWith("left") || r.startsWith("right"), o = a ? t : n, s = a ? n : t;
	if (e !== "percentage" || !i) return {
		mainAxis: t,
		crossAxis: n
	};
	let { width: c, height: l } = i.getBoundingClientRect();
	return {
		mainAxis: a ? c * o / 100 : l * s / 100,
		crossAxis: a ? l * s / 100 : c * o / 100
	};
}, Wu = (e, t) => {
	try {
		let n = t(), r = n.document, i = n.getComputedStyle(e), { overflow: a, overflowY: o, overflowX: s } = i, c = new Set([
			a,
			o,
			s
		]);
		if (i.position === "fixed" || i.position === "sticky" || c.has("auto") || c.has("hidden")) return !0;
		let { host: l = null } = e?.getRootNode() ?? {}, u = l?.tagName?.includes("APPCUES-EXPERIENCE-CONTAINER") || l?.tagName?.includes("APPCUES-EXPERIENCE-CONTAINER-BUILDER");
		return e.parentElement === null && l && !u ? Wu(l.parentElement, t) : e.parentElement !== null && e.parentElement !== r.body ? Wu(e.parentElement, t) : !1;
	} catch {
		return !1;
	}
};
function Gu(e) {
	return e === "fixed" || e === "relative" || e === "absolute" || e === "sticky";
}
function Ku(e) {
	return e.display === "flex" || e.display === "inline-flex";
}
function qu(e, t, n, r, i) {
	let a = i, o = t.zIndex, s = t.position, c = e.parentElement, l = c ? r.getComputedStyle(c) : {};
	if (o !== "" && o !== "auto" && !Gu(s) && !Ku(l) && (o = "auto"), (!a || o !== "" && o !== "auto" && (Gu(s) || Ku(l))) && (a = o), c && c !== n.body && c !== n.documentElement) return qu(c, l, n, r, a);
	if (/^\d+$/.test(a)) {
		let e = Number.parseInt(a, 10);
		e += 1, a = e;
	}
	return a;
}
var Ju = (e, t) => {
	let n = t(), r = n.document;
	return qu(e, n.getComputedStyle(e), r, n);
}, Yu = ({ targetEl: e, rootStyle: t, shouldAutoCalculateZIndex: n, getWindowReference: r }) => {
	let i = t;
	if (n) {
		let n = Ju(e, r);
		i = {
			...t,
			zIndex: n
		};
	}
	return i;
}, { addEventListener: Xu, removeEventListener: Zu } = (() => {
	let e = /* @__PURE__ */ new Map();
	function t(t) {
		t.composedPath().forEach((n) => {
			(e.get(n) ?? {})[t.type]?.map((e) => e(t));
		});
	}
	return {
		addEventListener: (n, r, i) => {
			e.get(n) || e.set(n, {});
			let a = e.get(n);
			a[r] || (a[r] = []), a[r].includes(i) || (a[r] = [...a[r], i], e.set(n, a)), a[r].length === 1 && n.addEventListener(r, t, !0);
		},
		removeEventListener: (n, r, i) => {
			let a = e.get(n);
			a && (a[r] = (a[r] ?? []).filter((e) => e !== i), e.set(n, a), a[r].length === 0 && n.removeEventListener(r, t, !0));
		}
	};
})(), Qu = (() => {
	let e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map(), n = (n) => {
		if (t.has(n)) return;
		let r = setInterval(() => {
			e.get(n).forEach((e) => e());
		}, n);
		t.set(n, r);
	}, r = (n, r) => {
		let i = e.get(r);
		if (i) {
			let a = i.filter((e) => e !== n);
			if (a.length > 0) {
				e.set(r, a);
				return;
			}
			let o = t.get(r);
			clearInterval(o), e.delete(r), t.delete(r);
		}
	};
	return (t, i) => {
		let a = e.get(i) ?? [];
		return e.set(i, [...a, t]), n(i), () => r(t, i);
	};
})(), $u = (e, { onLost: t, onFound: n }) => {
	let r = e().length === 1;
	return Qu(() => {
		try {
			let i = e().length === 1;
			if (i === r) return;
			r = i;
			let a = i ? n?.() : t?.();
			Promise.resolve(a).catch(() => {});
		} catch {}
	}, 500);
}, ed = (e, t) => {
	if (!t) return e;
	let { order: n, text: r } = t, i = [...e];
	return r && r !== "" && (i = i.filter((e) => e.textContent.replace(/\r\n|\r|\n/g, " ").toLowerCase().trim() === r.toString().toLowerCase().trim())), n == null ? i : i.length > n ? [i[n]] : [];
}, td = 1000000007;
function nd(e) {
	let { selector: t, filters: n } = e, r = t ?? "";
	n?.order != null && (r += `|o=${n.order}`), n?.text && (r += `|t=${n.text}`);
	let i = 0;
	for (let e of r) i = (i * 31 + (e.codePointAt(0) ?? 0)) % td;
	return `t_${i.toString(36)}`;
}
//#endregion
//#region src/core/lib/appcues-owned.ts
var rd = new Set([
	_r,
	vr,
	"APPCUES-BUILDER",
	"APPCUES-BUILDER-STANDALONE",
	"APPCUES-TEST-BANNER",
	"APPCUES-DEBUGGER"
]), id = 1, ad = 11, od = (e) => e.nodeType === id, sd = (e) => e.nodeType === ad && "host" in e, cd = (e) => {
	let t = e;
	for (; t;) {
		if (od(t) && (rd.has(t.tagName) || t.hasAttribute("data-appcues-container-id"))) return !0;
		t = t.parentNode, t && sd(t) && (t = t.host);
	}
	return !1;
}, ld = (e) => {
	let t = e.performance;
	return typeof t?.now == "function" ? () => t.now() : () => Date.now();
}, ud = (e) => {
	let t = null, n = !1;
	return {
		start() {
			t == null ? t = e() : n = !0;
		},
		take() {
			let r = {
				resolutionTimeMs: t == null ? 0 : Math.max(0, Math.round(e() - t)),
				waited: n
			};
			return t = null, n = !1, r;
		}
	};
}, dd = (e) => e.includes(Ir), fd = (e, t) => e != null && e.ownerDocument !== t.document, pd = (e, t) => ({ getBoundingClientRect() {
	let n = 0, r = 0, i = e.ownerDocument?.defaultView, a = 0;
	for (; i && i !== t && a < 20;) {
		a += 1;
		try {
			let e = i.frameElement;
			if (!e) break;
			let t = e.getBoundingClientRect(), a = e.ownerDocument.defaultView.getComputedStyle(e);
			n += t.left + e.clientLeft + Number.parseFloat(a.paddingLeft || "0"), r += t.top + e.clientTop + Number.parseFloat(a.paddingTop || "0");
			let o = i.parent;
			if (o === i) break;
			i = o;
		} catch {
			break;
		}
	}
	let o = e.getBoundingClientRect(), s = n + o.left, c = r + o.top;
	return {
		x: s,
		y: c,
		left: s,
		top: c,
		right: s + o.width,
		bottom: c + o.height,
		width: o.width,
		height: o.height,
		toJSON() {
			return this;
		}
	};
} }), md = "@appcues/overlay", hd = 500, gd = "top 200ms, left 200ms, right 200ms, bottom 200ms", _d = {
	top: "top",
	"top-left": "top-start",
	"top-right": "top-end",
	right: "right",
	"right-top": "right-start",
	"right-bottom": "right-end",
	bottom: "bottom",
	"bottom-right": "bottom-end",
	"bottom-left": "bottom-start",
	left: "left",
	"left-bottom": "left-end",
	"left-top": "left-start",
	center: "top-start"
}, vd = (e, t) => {
	let n, r, i, a = [], o, s = () => {}, c, l = !1;
	function u() {
		if (t()?.__appcuesIsResizing) {
			l = !0;
			return;
		}
		l = !1, e();
	}
	let d = (0, Ru.default)(u, 100);
	function f(t) {
		!t.detail?.isResizing && l && (l = !1, d.cancel(), e());
	}
	function p() {
		let e = n.getBoundingClientRect();
		c && (e.x !== c.x || e.y !== c.y || e.width !== c.width || e.height !== c.height) && d(), c = e;
	}
	return {
		setElements(e, t, o) {
			return n = e, r = t, i = o, a = [], this;
		},
		start() {
			i && (a = (0, zu.default)([...eu(i)])), a.forEach((e) => {
				Xu(e, "scroll", d), Xu(e, "resize", d);
			}), o = new ResizeObserver(d), o.observe(r), c = n.getBoundingClientRect(), s = Qu(p, 200), t()?.addEventListener("isResizing", f);
		},
		remove() {
			a.forEach((e) => {
				Zu(e, "scroll", d), Zu(e, "resize", d);
			}), o?.unobserve(r), s(), t()?.removeEventListener("isResizing", f);
		}
	};
};
Y(md, ({ addHook: e, registerAction: t }) => {
	let n, r, i, a = !1, o = null, s = !1, c, l, u, d, f = () => {
		d &&= (d(), void 0);
	}, p, m, h, g, _, v = !1, y = "absolute", b, x, S, C;
	e("step.begin", ({ onElementInserted: e, onElementRemoved: t, querySelector: w, reportError: T, step: E, updateStyle: D, getWindowReference: O, getTraitConfig: k, getContainer: A }) => {
		let { traits: j } = E.getConfig(), { arrowId: M = "arrow", target: N, rootId: P, placement: F = "auto", distance: ee, skidding: te, placementUnit: I = "pixels", shouldAutoCalculateZIndex: L = !0 } = k(), R = Vu(N.selector, j);
		C ||= ud(ld(O()));
		let z = j.find((e) => e.type === "@appcues/toggle")?.config?.startHidden ?? !0;
		z || D(P, { position: "absolute" }), m = () => {
			let e = E.querySelector(`#${P}`), t = E.querySelector(`#${M}`), n = ed(w(N.selector), N.filters);
			return {
				matchingElements: n,
				targetEl: n[0],
				rootEl: e[0],
				arrowEl: t[0]
			};
		};
		let ne = async () => {
			let { targetEl: e, rootEl: t, arrowEl: n } = m();
			if (!a && e && t) {
				a = !0;
				let r = Date.now();
				o === null && (o = r);
				let i = r - o > hd, s = Uu({
					placement: F,
					targetEl: e,
					distance: ee,
					skidding: te,
					placementUnit: I
				}), c = [Au(({ placement: e }) => ({
					...s,
					crossAxis: n && /start|end/gm.test(e) ? Hu(te, e) : s.crossAxis
				}))];
				F === "auto" && c.push(Mu(), ju({ crossAxis: !0 })), n && c.push(Pu({
					element: n,
					padding: 10
				}));
				let l = O(), u = fd(e, l), d = R != null && dd(R.config.target.selector), f = u ? pd(e, l) : e, p = /translateX\(calc\(-50%/.test(t.style.transform || "");
				p && (t.style.transform = "none"), !u && !d && c.push(Nu());
				let { middlewareData: m, strategy: h, x: b, y: x, placement: S } = await Fu(f, t, {
					middleware: c,
					placement: _d[F] ?? "auto",
					strategy: y
				}), { referenceHidden: C } = m.hide ?? { referenceHidden: !1 };
				if (n) {
					let { x: e, y: n } = m.arrow, r = t.getBoundingClientRect();
					D(M, {
						...Bu(S, e, n, r.width, r.height),
						transition: i ? gd : "none"
					});
				}
				t.dataset.placement = S;
				let w = Yu({
					targetEl: e,
					rootStyle: {
						left: `${b}px`,
						position: h,
						top: `${x}px`
					},
					shouldAutoCalculateZIndex: L,
					getWindowReference: O
				});
				e.style.visibility === "hidden" && (w.visibility = "hidden", _ = e.style.visibility), C && t.style.visibility !== "hidden" && (g = t.style.visibility, v = !0, w.visibility = "hidden"), !C && v && (w.visibility = g ?? "visible", v = !1), !C && e.style.visibility !== "hidden" && e.style.visibility !== "" && _ === "hidden" && (w.visibility = "visible"), F === "center" ? w.transform = "translate(-50%, 50%)" : p && (w.transform = "none"), w.transition = i ? gd : "none", D(P, w), Object.assign(t.style, w);
			}
		};
		b = () => {
			a = !1, ne();
		}, x = async () => {
			h.remove(), a = !1, s = !1, await n();
		}, h = vd(b, O);
		let B = () => ed(w(N.selector), N.filters), V = () => {
			if (!R) return B();
			let { selector: e, filters: t } = R.config.target;
			return ed(w(e), t);
		}, re = () => R ? R.config.target.selector : N.selector, H = () => R ? R.config.target : N, ie = (e) => ({
			reason: e,
			selector: N.selector,
			targetId: nd(N)
		}), U = (e) => ({
			reason: e,
			selector: re(),
			targetId: nd(H())
		});
		r = () => {
			c &&= (c(), void 0), c = e({
				getTarget: V,
				onInserted: async () => {
					a = !1, s = !1, R && await new Promise((e) => {
						setTimeout(e, 0);
					}), await n() && (s = !0);
				}
			});
		}, i = () => {
			if (u &&= (u(), void 0), !p) return;
			let t = p, n = S, r = !1, i = [], o = () => {
				i.forEach((e) => e()), i = [];
			}, c = () => {
				r = !0, a = !1, s = !1, o(), u = void 0, E.recover({ errorId: n });
			}, l = () => {
				r || t().length !== 1 || c();
			};
			if (t().length === 1) {
				c();
				return;
			}
			i.push(e({
				getTarget: t,
				onInserted: l
			}));
			let d = () => l(), f = O().document;
			i.push($u(t, { onFound: l }), Nr(f.body, d));
			let m = A?.();
			m && m !== f.body && i.push(Nr(m, d)), u = o;
		}, n = async () => {
			C.start(), c && c(), l && l(), f(), u &&= (u(), void 0);
			let { matchingElements: e, rootEl: n } = m(), i = e.length === 1, o = e.length > 1, s = V(), _ = s.length === 1, b = s.length > 1, w = () => {
				R || (l = t({
					getTarget: B,
					onRemoved: () => {
						f(), a = !1, C.start(), S = T(`Target got removed => ${N.selector}`, ie("target_not_found")), p = B, h.remove();
					}
				}), f(), d = $u(B, { onLost: x }));
			};
			if (i && !n) return S = T(`Could not find root element #${P} for overlay positioning.`, ie("root_missing")), p = () => E.querySelector(`#${P}`), !1;
			if (o) return S = T(`Found ${e.length} elements for selector ${N.selector}.`, ie("target_duplicated")), p = B, !1;
			if (b) return S = T(`Found ${s.length} elements for selector ${re()}.`, U("target_duplicated")), p = V, !1;
			if (!i || !_) {
				let e = re();
				return s.length === 0 && dd(e) ? r() : (S = T(`Could not find element for selector ${e}.`, _ ? void 0 : U("target_not_found")), p = V), !1;
			}
			if (i) {
				let t = R ? s : null;
				if (z) {
					if (fd(e[0], O())) y = "absolute";
					else {
						let n = t != null && t[0] != null ? Wu(t[0].parentElement, O) : !1;
						y = Wu(e[0]?.parentElement, O) || n ? "fixed" : "absolute";
					}
					D(P, { position: y });
				}
				await ne(), (fd(e[0], O()) || R != null && dd(R.config.target.selector)) && !v && D(P, { visibility: g ?? "visible" }), w(), p = void 0, h.setElements(e[0], n, t ? t[0] : null).start();
				let r = C.take();
				return !R && !cd(e[0]) && E.targetResolved({
					targetId: nd(N),
					status: "healthy",
					strategy: "selector",
					confidence: 1,
					...r
				}), !0;
			}
			return !1;
		};
	}), e("step.postrender", async () => {
		s || await n() && (s = !0);
	}), e("step.end", () => {
		c && c(), l && l(), f(), u &&= (u(), void 0), h.remove(), a = !1, s = !1, o = null;
	}), e("step.error", () => {
		f(), a = !1, s = !1, o = null, i && i();
	});
}), Y("@appcues/persistent", ({ addHook: e }) => {
	e("experience.begin", ({ steps: e }) => {
		e.map((e) => e.start());
	});
});
//#endregion
//#region src/traits/inline/inline.js
var yd = {
	left: "beforebegin",
	"inner-left": "afterbegin",
	right: "afterend",
	"inner-right": "beforeend"
}, bd = "@appcues/inline", xd = "data-appcues-replaced", Sd = "data-appcues-inline", Cd = [
	`[${Sd}]`,
	_r.toLowerCase(),
	vr.toLowerCase()
], wd = `
[${xd}] > ${Cd.map((e) => `:not(${e})`).join("")} { display: none !important; }
[${xd}="text"] { font-size: 0 !important; line-height: 0 !important; visibility: hidden !important; }
${Cd.map((e) => `[${xd}] > ${e}`).join(", ")} { visibility: visible; }`, Td = /* @__PURE__ */ new WeakMap(), Ed = (e) => Array.from(e.childNodes).some((e) => e.nodeType === Node.TEXT_NODE && e.nodeValue.trim()), Dd = ({ distanceUnit: e, yOffset: t, xOffset: n, targetEl: r }) => {
	if (e !== "%" || !r) return {
		x: `${n}px`,
		y: `${t}px`
	};
	let { width: i, height: a } = r.getBoundingClientRect();
	return {
		x: `${i * n / 100}px`,
		y: `${a * t / 100}px`
	};
};
function Od({ addHook: e }) {
	let t, n, r, i, a = null, o = null, s = null, c = {}, l = (e) => {
		if (o) return;
		let t = e.getRootNode();
		o = e.ownerDocument.createElement("style"), o.textContent = wd, (t.head ?? t).append(o);
	}, u = () => {
		if (a) {
			let e = Td.get(a);
			e?.delete(c), e?.size || (a.removeAttribute(xd), Td.delete(a)), a = null;
		}
		o &&= (o.remove(), null);
	};
	e("step.begin", ({ step: e, getTraitConfig: o, reportError: d, onElementRemoved: f, updateRootStyle: p, querySelector: m, getWindowReference: h }) => {
		let { target: g, placement: _ = "right", verticalAlignment: v = "bottom", allowOverlap: y = !1, xOffset: b = 0, yOffset: x = 0, distanceUnit: S = "px", sticky: C = !1, rootDisplay: w = "inline-block", clearContainer: T = !1 } = o();
		i ||= ud(ld(h())), i.start(), t && t(), n && n();
		let E = ed(m(g.selector), g.filters), D = E.length === 1, O = E.length > 1, k = E.length === 0, A = (t) => {
			let n = h().document.createElement("div");
			if (n.setAttribute(Sd, ""), s &&= (s.remove(), null), u(), T && _.includes("inner")) if (T === "hide" || T === "restore") {
				l(t);
				let e = Td.get(t) ?? /* @__PURE__ */ new Set();
				e.add(c), Td.set(t, e), t.setAttribute(xd, Ed(t) ? "text" : ""), a = t;
			} else for (; t.firstChild;) t.firstChild.remove();
			return t.insertAdjacentElement(yd[_], n) == null ? (r = d(`can't insert inline container on the ${_}`), !1) : (s = n, e.setStepContainerTarget(n), !0);
		}, j = () => ed(m(g.selector), g.filters), M = nd(g), N = (e) => ({
			reason: e,
			selector: g.selector,
			targetId: M
		}), P = () => {
			n = f({
				getTarget: j,
				onRemoved: () => {
					i.start(), r = d(`Target got removed => ${g.selector}`, N("target_not_found"));
				}
			});
		};
		if (D) {
			let t = A(E[0]), n = {
				display: w,
				verticalAlign: v
			}, { x: r, y: a } = Dd({
				distanceUnit: S,
				xOffset: b,
				yOffset: x,
				targetEl: E[0]
			});
			if (y) n.position = "absolute", n.transform = `translate(${r}, ${a})`;
			else {
				let e = _.includes("left") ? "right" : "left";
				n[`margin-${e}`] = r, n[`margin-${v}`] = a;
			}
			if (C) {
				n.position = "sticky";
				let e = _.includes("left") ? "top" : "bottom";
				n[e] = 0, n.zIndex = wr;
			}
			if (p(n), P(), t) {
				let t = i.take();
				cd(E[0]) || e.targetResolved({
					targetId: M,
					status: "healthy",
					strategy: "selector",
					confidence: 1,
					...t
				});
			}
			return;
		}
		O && (r = d(`Found ${E.length} elements for selector ${g.selector}.`, N("target_duplicated"))), k && (r = d(`Could not find element for selector ${g.selector}.`, N("target_not_found")));
	}), e("step.error", ({ step: e, getTraitConfig: n, onElementInserted: i, querySelector: a }) => {
		let { target: o } = n();
		t = i({
			getTarget: () => ed(a(o.selector), o.filters),
			onInserted: () => {
				e.recover({ errorId: r });
			}
		});
	}), e("step.end", () => {
		t && t(), n && n(), s &&= (s.remove(), null);
	}), e("experience.end", u);
}
Y(bd, Od);
//#endregion
//#region src/traits/toggle/helpers.js
var kd = (e, t, n) => {
	let { height: r, width: i, left: a, top: o } = e.getBoundingClientRect();
	return Math.floor(Math.hypot(t - (a + i / 2), n - (o + r / 2)) / 2);
}, Ad = (e, t) => {
	let { height: n, width: r } = e.getBoundingClientRect(), i = Math.floor(Math.hypot(n, r) / 4);
	return Math.max(t, 0) + i;
}, jd = (e) => e.key === "Escape", Md = (e, t) => ![...e.composedPath()].filter((e) => e.nodeType === Node.ELEMENT_NODE).some((e) => e?.contains?.(t) ?? !1), Nd = (e, t) => ({
	remove: () => {
		e.removeEventListener("keydown", t), e.removeEventListener("click", t, !0);
	},
	start: () => {
		e.addEventListener("click", t, !0), e.addEventListener("keydown", t);
	}
}), Pd = (e, t, n) => t.length === 0 ? (n("Element not found"), !1) : t.length > 1 ? (n(`More than one element found with id: ${e}`), !1) : !0, Fd = "@appcues/toggle.style", Id = ({ targetId: e, styles: t = {} }, { updateStyle: n }) => {
	n(e, t);
}, Ld = { [Fd]: Id };
Y("@appcues/toggle", ({ addHook: e, registerAction: t }, { startHidden: n = !0, targetId: r, transition: i, closeOnClickOutside: a = !0, closeRadius: o }) => {
	let s, c, l, u = !1, d = [], f = null, p = [], m = () => {
		d.forEach((e) => e.remove()), d = [];
	};
	n && e("step.begin", ({ updateStyle: e, getWindowReference: t }) => {
		e(r, {
			opacity: "0",
			visibility: "hidden",
			"pointer-events": "none"
		}), p = [...t().document.querySelectorAll("iframe")];
	}), e("step.end", () => {
		a && m(), f?.remove(), f = null;
	}), e("step.error", () => {
		a && m(), f?.remove(), f = null;
	});
	let h = ({ on: e } = {}, t) => {
		let { reportError: n, step: c, updateStyle: l, getWindowReference: d } = t, f = d().document;
		if (!Pd(r, c.querySelector(`#${r}`), n)) return;
		a && m();
		let h = {};
		i || (h.visibility = "hidden", h["pointer-events"] = "none"), l(r, {
			...h,
			opacity: "0"
		}), i && setTimeout(() => {
			l(r, {
				visibility: "hidden",
				"pointer-events": "none"
			});
		}, i.duration * 1e3), o && u && (Zu(f, "mousemove", s), p.forEach((e) => {
			e.contentDocument?.body && Zu(e.contentDocument.body, "mousemove", s);
		}), u = !1), e?.close?.forEach((e) => Ld[e.type](e.config, t));
	}, g = ({ on: e } = {}, t) => {
		let { reportError: n, step: m, updateStyle: g, getWindowReference: _ } = t, v = _().document, y = m.querySelector(`#${r}`);
		if (!Pd(r, y, n)) return;
		let b = {};
		if (i && (b.transition = `opacity ${i.duration}s ${i.easing}`), g(r, {
			...b,
			visibility: "visible",
			opacity: "1",
			"pointer-events": "auto"
		}), e?.open?.forEach((e) => Ld[e.type](e.config, t)), a && d.length === 0) {
			let n = m.querySelector(":first-child")[0];
			l = (n) => {
				(jd(n) || Md(n, y[0])) && h({ on: e }, t);
			};
			let r = p.map((e) => e.contentDocument?.body ? Nd(e.contentDocument.body, l) : null).filter(Boolean);
			d.push(Nd(v, l), Nd(n, l), ...r), d.forEach((e) => e.start());
		}
		if (f || (c = (n) => {
			if (n.type === "keydown" && !["Enter", " "].includes(n.key)) return;
			let r = [...n.composedPath()];
			["a", "button"].includes(r[0].tagName.toLowerCase()) && h({ on: e }, t);
		}, f = Nd(y[0], c), f.start()), o && !u) {
			let t = Ad(y[0], o);
			s = (0, Ru.default)((r) => {
				kd(y[0], r.clientX, r.clientY) > t && h({ on: e }, {
					reportError: n,
					step: m,
					updateStyle: g,
					getWindowReference: _
				});
			}, 60), Xu(v, "mousemove", s), p.forEach((e) => {
				e.contentDocument?.body && Xu(e.contentDocument.body, "mousemove", s);
			}), u = !0;
		}
	};
	t("run", ({ on: e } = {}, t) => {
		let { step: n, reportError: i, getWindowReference: a } = t, o = n.querySelector(`#${r}`);
		if (Pd(r, o, i)) {
			if (a().getComputedStyle(o[0]).visibility === "hidden") {
				g({ on: e }, t);
				return;
			}
			h({ on: e }, t);
		}
	}), t("open", g), t("close", h), t("style", Id);
}), Y("@appcues/coreEvents", ({ registerAction: e }) => {
	e("step_seen", (e, { step: t }) => {
		t.seen();
	}), e("extended_event", ({ name: e, ...t }, { step: n }) => {
		n.extendedEvent(e, t);
	}), e("step_interaction", (e, { step: t }) => {
		t.interaction(e.interactionType, e.interactionData);
	}), e("experience_dismissed", (e, { step: t }) => {
		t.dismissExperience();
	}), e("experience_snoozed", (e, { step: t }) => {
		t.snoozeExperience();
	});
});
//#endregion
//#region src/traits/store/helpers.js
var Rd = (e, t = {}, n = () => window) => {
	let r = t, i = [], a = n().document, o = (e) => {
		let { el: t, callbackFn: n } = e.detail;
		i.push([t, n]), t[n].apply(e.target, [r]);
	};
	return a.addEventListener(`${e}:connect`, o), {
		getState: () => r,
		setState: (e) => {
			r = {
				...r,
				...e
			}, i.forEach(([e, t]) => {
				e[t].apply(e, [r]);
			});
		},
		destroy: () => {
			a.removeEventListener(`${e}:connect`, o);
		}
	};
};
Y("@appcues/store", ({ addHook: e, registerAction: t }, { id: n, initialState: r = {} }) => {
	let i;
	e("step.begin", ({ getWindowReference: e }) => {
		i = Rd(n, r, e);
	}), e("step.end", () => {
		i && i.destroy();
	}), t("setState", ({ stateKey: e }, t, n) => {
		i && i.setState({ [e]: n?.detail });
	});
});
//#endregion
//#region src/traits/animate/animations.js
var zd = {
	slide_in_down: [{
		transform: "translate3d(0, -100%, 0)",
		visibility: "visible"
	}, { transform: "translate3d(0, 0, 0)" }],
	slide_out_down: [
		{
			transform: "translate3d(0, 0, 0)",
			offset: 0
		},
		{
			transform: "translate3d(0, 100%, 0)",
			offset: .99
		},
		{
			visibility: "hidden",
			offset: 1
		}
	],
	slide_in_up: [{
		transform: "translate3d(0, 100%, 0)",
		visibility: "visible"
	}, { transform: "translate3d(0, 0, 0)" }],
	pulse: [
		{ transform: "scale3d(1, 1, 1)" },
		{ transform: "scale3d(1.05, 1.05, 1.05)" },
		{ transform: "scale3d(1, 1, 1)" }
	]
}, Bd = "@appcues/animate", Vd = 500, Hd = "none", Ud = "button, [href], input, select, textarea, [tabindex]:not([tabindex=\"-1\"])", Wd = (e) => {
	let t = e?.activeElement;
	for (; t?.shadowRoot?.activeElement;) t = t.shadowRoot.activeElement;
	return t;
}, Gd = /* @__PURE__ */ new WeakMap(), Kd = (e) => {
	let t = zd[e?.effect] || e?.keyframes, n = Array.isArray(t) ? t[t.length - 1] : null;
	return n ? Number(n.opacity) === 0 || n.visibility === "hidden" || n.display === "none" : !1;
}, qd = (e, t) => new Promise((n) => {
	let { keyframes: r, duration: i = Vd, iterations: a, effect: o, fill: s = Hd, easing: c = "linear", composite: l } = t, u = zd[o] || r, d = {
		duration: i,
		iterations: a,
		fill: s,
		easing: c,
		...l ? { composite: l } : {}
	};
	if (!u) {
		n();
		return;
	}
	let f = e.animate(u, d);
	f?.addEventListener ? f.addEventListener("finish", n, { once: !0 }) : n();
});
Y(Bd, ({ addHook: e, registerAction: t }, n) => {
	if (n.phase === "exit") e("step.end", ({ querySelector: e }) => {
		let { target: t } = n;
		if (!t) return;
		let r = e(t.selector);
		if (r.length !== 0) return qd(r[0], n);
	});
	else {
		let t = !1;
		e("step.postrender", ({ querySelector: e }) => {
			if (t) return;
			let { target: r } = n;
			if (!r) return;
			let i = e(r.selector);
			i.length !== 0 && (t = !0, qd(i[0], n));
		});
	}
	t("toggle", ({ toggleGroupId: e, target: t, animations: n, autoFocus: r = !0 }, { querySelector: i, getWindowReference: a }) => {
		let o = i(t.selector);
		if (o.length === 0) return;
		let [s] = o, c = s.getAttribute(e) === n[0].id ? n[1] : n[0];
		if (!c) return;
		let l = Kd(c);
		l || (s.inert = !1);
		let u = r ? Wd(a?.()?.document) : null, d = qd(s, c);
		c.id && s.setAttribute(e, c.id);
		let f = () => c.id != null && s.getAttribute(e) !== c.id;
		if (!r) {
			l && d.then(() => {
				f() || (s.inert = !0);
			});
			return;
		}
		d.then(() => {
			if (!f()) if (l) {
				let e = Gd.get(s);
				e?.isConnected && e.focus({ preventScroll: !0 }), Gd.delete(s), s.inert = !0;
			} else u && Gd.set(s, u), (s.querySelector(Ud) ?? s).focus({ preventScroll: !0 });
		});
	}), t("run", async (e, t) => {
		let { querySelector: n, getAction: r } = t, { toggleGroupId: i, target: a, animation: o, ignoreToggleGroup: s = !1, onFinish: c = [] } = e;
		if (!a) return;
		let l = n(a.selector);
		if (l.length === 0) return;
		let u = l[0], d = u.getAttribute(i);
		(!d || d === o.id) && !s || (await qd(u, o ?? e), c.forEach((e) => {
			r(e.type)(e?.config ?? {}, t);
		}), s || u.setAttribute(i, o.id));
	});
});
//#endregion
//#region src/traits/dismissible/dismissible.js
var Jd = "@appcues/dismissible";
function Yd(e) {
	return `_experience_dismissed_${e}`;
}
Y(Jd, ({ addHook: e, registerAction: t }, { strategy: n = "permanent" }) => {
	function r(e, t) {
		return n === "session" ? t().sessionStorage.getItem(Yd(e)) === "1" : !1;
	}
	e("experience.begin", ({ stopExperience: e, getExperienceId: t, getWindowReference: n }) => {
		r(t(), n) && e();
	}), t("dismiss", (e, { stopExperience: t, updateUserProfile: r, getExperienceId: i, getWindowReference: a }) => {
		let o = Yd(i());
		n === "session" ? a().sessionStorage.setItem(o, "1") : n === "permanent" && r({ [o]: "permanently_dismissed" }), t();
	});
}), Y("@appcues/experienceStyle", ({ addHook: e }) => {
	e("step.begin", ({ updateRootStyle: e, getTraitConfig: t }) => {
		e(t(), { forceUpdate: !0 });
	}), e("step.container_change", ({ updateRootStyle: e, getTraitConfig: t }) => {
		e(t(), { forceUpdate: !0 });
	}), e("step.end", ({ updateRootStyle: e, getTraitConfig: t }) => {
		e(Object.keys(t()).reduce((e, t) => (e[t] = null, e), {}), { forceUpdate: !0 });
	});
});
//#endregion
//#region src/traits/rootStyle/root-style.js
var Xd = "@appcues/rootStyle", Zd = ({ getTraitConfig: e, updateRootStyle: t }) => {
	let { forceUpdate: n = !1, ...r } = e();
	t(r, { forceUpdate: n });
};
function Qd({ addHook: e }) {
	e("step.begin", Zd), e("step.container_change", Zd);
}
Y(Xd, Qd);
//#endregion
//#region ../sdk-middleware-events/dist/index.js
var $d = "appcues:launchpad_close", ef = "appcues:launchpad_search", tf = "appcues:launchpad_search_error", nf = "appcues:launchpad_search_response", rf = function(e, t) {
	return window.addEventListener(e, t), function() {
		return window.removeEventListener(e, t);
	};
}, af = function(e) {
	return rf($d, e);
}, of = function(e, t, n) {
	var r = new CustomEvent(ef, { detail: {
		integrationId: e,
		query: t,
		experienceId: n
	} });
	window.dispatchEvent(r);
}, sf = function(e, t) {
	return rf(`${nf}:${e}`, t);
}, cf = function(e, t) {
	return rf(`${tf}:${e}`, t);
};
Y("@appcues/sdk-middleware-events", ({ addHook: e }, { onLaunchpadClose: t }) => {
	let n;
	e("step.begin", (e) => {
		n = af(() => {
			t.forEach((t) => {
				e.getAction(t.type)?.(t.config, e);
			});
		});
	}), e("step.end", () => {
		n?.();
	});
});
//#endregion
//#region src/traits/knowledgeBaseIntegration/knowledge-base-integration.js
var lf = "@appcues/knowledge-base-integration", uf = (e, { querySelector: t, reportError: n }) => {
	let r = t(e), i = r.length > 1, a = r.length === 0;
	return i && n("The target element is duplicated, please provide a more specific selector"), a && n("The target element is not found"), r[0];
};
Y(lf, ({ addHook: e, registerAction: t }, n) => {
	let { integrationConnected: r = !1 } = n, i, a, o, s, c, l = () => {
		r && a?.prev();
	}, u = (e) => {
		if (!r) return;
		let { integrationId: t } = n, { inputValue: l } = e.detail;
		o.setAttribute("searchTerm", l), o.setAttribute("state", "loading"), i.setAttribute("loading", !0), s && (s.scrollTop = 0), a?.next(), of(t, l, c);
	};
	e("step.begin", ({ getExperienceId: e }) => {
		c = e(), sf(c, (e) => {
			let t = e.detail, n = t.results?.length === 0 ? "empty" : "showing_results";
			o.setAttribute("state", n), o.setAttribute("results", JSON.stringify(t.results)), i.setAttribute("loading", !1);
		}), cf(c, () => {
			o.setAttribute("state", "error"), i.setAttribute("loading", !1);
		});
	}), e("step.end", () => {
		i?.removeEventListener("onSearch", u), i?.removeEventListener("onCancel", l);
	}), t("bindListeners", (e, t) => {
		let { navigation: r } = n;
		(!a || !i) && (a = uf(r.selector, t), i = uf("appcues-search-header", t), o = uf("appcues-search-results", t), s = uf("#launchpad-container", t), i?.addEventListener("onSearch", u), i?.addEventListener("onCancel", l));
	});
});
//#endregion
//#region src/traits/sequential/sequential.js
var df = "@appcues/sequential", ff = (e, t) => e.findIndex((e) => e.getConfig()?.id === t);
Y(df, ({ addHook: e, registerAction: t }) => {
	let n, r = "forward", i, a = (e, { steps: t }, i) => {
		r = "backward", n !== 0 && t[n].stop(() => {
			--n, t[n].start();
		}, i);
	}, o = (e) => {
		let { steps: t, handleNavigation: r, getWindowReference: i } = e ?? {};
		if (typeof r?.armWaitForUrl != "function" || n == null || n >= t.length - 1) return;
		let a = t[n].getConfig?.() ?? {}, o = t[n + 1].getConfig?.() ?? {}, s = qi(o), c = qi(a);
		if (!s || !c || o.id == null) return;
		let l = i?.().location?.href, u = r.doesLocationMatch, d = !!c && typeof u == "function" && l != null && !u(c.urlPattern, l);
		r.armWaitForUrl({
			stepId: o.id,
			urlPattern: s.urlPattern,
			pageCheckLimit: s.pageCheckLimit,
			resolved: d
		});
	}, s = (e, t, i) => {
		let { steps: a } = t;
		if (r = "forward", o(t), n === a.length - 1) {
			a[n].stop(void 0, i);
			return;
		}
		a[n].stop(() => {
			n += 1, a[n].start();
		}, i);
	};
	e("experience.begin", (e) => {
		let { steps: t, getTraitConfig: r, reportError: a, getExperienceId: o } = e;
		i?.(), i = Ms(o?.(), () => s({}, e));
		let { startStepId: c } = r() ?? {};
		if (c) {
			let e = ff(t, c);
			e === -1 && a(`startStepId "${c}" did not match any step; starting at 0`), n = e === -1 ? 0 : e;
		} else n = 0;
		t[n].start();
	}), e("experience.end", () => {
		i?.(), i = void 0;
	}), t("next", s), t("prev", a), t("goTo", (e, { step: t, steps: i }, a) => {
		let o = ff(i, e.stepId);
		o !== -1 && (r = "forward", t.stop(() => {
			n = o, i[n].start();
		}, a));
	}), t("skip", (e, t, n) => r === "backward" ? a(e, t, n) : s(e, t, n));
});
//#endregion
//#region src/traits/delay/delay.js
var pf = "@appcues/delay", mf = 3e5;
Y(pf, ({ addHook: e }, t) => {
	let n = null;
	e("step.begin", () => {
		let e = t?.duration;
		if (!e) return;
		let r = Math.min(e, mf);
		return r !== e && console.warn(`[@appcues/delay] duration ${e}ms exceeds the 5-minute maximum (${mf}ms) and has been capped.`), new Promise((e) => {
			n = setTimeout(e, r);
		});
	}), e("step.end", () => {
		n !== null && (clearTimeout(n), n = null);
	});
});
//#endregion
//#region src/traits/dialog/backdrops/constants.js
var hf = "appcues-cutout-backdrop", gf = "appcues-custom-backdrop", _f = "apc-spotlight", vf = "\n  :where(dialog) { all: unset; }\n", yf = "\n  ::backdrop { backdrop-filter: var(--backdrop-blur); background-color: var(--backdrop-color); }\n", bf = ({ backdropBlur: e, backdropColor: t }) => ({
	...e && { "--backdrop-blur": e },
	...t && { "--backdrop-color": t }
}), xf = ({ getWindowReference: e, backdropZIndex: t, backdropBlur: n, backdropColor: r }) => {
	if (e().document.querySelector("#appcues-custom-backdrop")) return null;
	let i = e().document.createElement("div");
	return i.id = gf, i.style.cssText = `
    z-index: ${t};
    position: fixed;
    inset: 0;
    backdrop-filter: ${n};
    background-color: ${r};
    pointer-events: none;
  `, i;
}, Sf = /* @__PURE__ */ c({
	build: () => Df,
	update: () => Of
}), Cf = 1500, wf = .67, Tf = (e) => {
	Object.assign(e.style, {
		position: "fixed",
		top: "0",
		left: "0",
		width: "100vw",
		height: "100vh",
		overflow: "hidden",
		pointerEvents: "none"
	});
}, Ef = (e, t) => {
	let { top: n, left: r, width: i, height: a } = t;
	Object.assign(e.style, {
		position: "absolute",
		top: `${n - Cf}px`,
		left: `${r - Cf}px`,
		height: `${a ? a + 2 * Cf : 0}px`,
		width: `${i ? i + 2 * Cf : 0}px`,
		boxSizing: "border-box",
		border: `${Cf}px solid transparent`,
		pointerEvents: "none",
		borderImage: `radial-gradient(transparent 2%, rgba(0,0,0,${wf}) 28%) 49% 49% 49% 49%`,
		boxShadow: `0 0 0 2500px rgba(0,0,0,${wf})`
	});
}, Df = ({ document: e, rect: t, zIndex: n }) => {
	let r = e.createElement("div");
	r.id = hf, Tf(r), r.style.zIndex = n;
	let i = e.createElement("div");
	return i.className = _f, Ef(i, t), r.append(i), r;
}, Of = ({ container: e, rect: t }) => {
	let n = e.firstElementChild;
	n && Ef(n, t);
}, kf = /* @__PURE__ */ c({
	build: () => Ff,
	update: () => If
}), Af = .5, jf = (e) => {
	Object.assign(e.style, {
		position: "fixed",
		top: "0",
		left: "0",
		width: "100vw",
		height: "100vh",
		pointerEvents: "none"
	});
}, Mf = (e, t, n) => {
	let { top: r, left: i, width: a, height: o } = n;
	Object.assign(e.style, {
		position: "absolute",
		top: `${r}px`,
		left: `${i}px`,
		width: `${a}px`,
		height: `${o}px`,
		overflow: "hidden",
		pointerEvents: "none"
	}), Object.assign(t.style, {
		position: "relative",
		width: `${a}px`,
		height: `${o}px`,
		boxShadow: `0px 0px 0px 2000px rgba(0,0,0,${Af})`,
		borderRadius: "0px",
		pointerEvents: "none"
	});
}, Nf = (e, t, n, r, i) => {
	Object.assign(e.style, {
		position: "absolute",
		top: `${t}px`,
		left: `${n}px`,
		width: `${r}px`,
		height: `${i}px`,
		background: `rgba(0,0,0,${Af})`,
		pointerEvents: "all"
	});
}, Pf = ([e, t, n, r], i, a) => {
	let { top: o, left: s, right: c, bottom: l, width: u } = i, d = a.innerWidth, f = a.innerHeight;
	Nf(e, 0, s, u, Math.max(0, o)), Nf(t, 0, c, Math.max(0, d - c), f), Nf(n, l, s, u, Math.max(0, f - l)), Nf(r, 0, 0, Math.max(0, s), f);
}, Ff = ({ document: e, win: t, rect: n, zIndex: r }) => {
	let i = e.createElement("div");
	i.id = hf, jf(i), i.style.zIndex = r;
	let a = e.createElement("div"), o = e.createElement("div");
	return o.className = _f, Mf(a, o, n), a.append(o), i.append(a), Pf([
		"top",
		"right",
		"bottom",
		"left"
	].map((t) => {
		let n = e.createElement("div");
		return n.className = _f, n.setAttribute("aria-label", `${t}-panel`), i.append(n), n;
	}), n, t), i;
}, If = ({ container: e, win: t, rect: n }) => {
	let r = e.children[0], i = r?.firstElementChild;
	r && i && Mf(r, i, n);
	let a = [...e.children].slice(1);
	a.length === 4 && Pf(a, n, t);
}, Lf = {
	soft: Sf,
	hard: kf
}, Rf = (e) => e in Lf, zf = ({ getWindowReference: e, target: t, backdropType: n, zIndex: r }) => {
	let i = e(), a;
	try {
		a = i.document.querySelector(t);
	} catch {
		a = null;
	}
	if (!a) return null;
	let o = a.getBoundingClientRect(), s = {
		document: i.document,
		win: i,
		rect: o,
		zIndex: r
	};
	return Lf[n].build(s);
}, Bf = ({ container: e, getWindowReference: t, target: n, backdropType: r }) => {
	let i = t(), a;
	try {
		a = i.document.querySelector(n);
	} catch {
		a = null;
	}
	if (!a || !e) return;
	let o = a.getBoundingClientRect();
	Lf[r].update({
		container: e,
		win: i,
		rect: o
	});
}, Vf = new Set([_r, vr]), Hf = (e) => e.id === "appcues-cutout-backdrop" || Vf.has(e.tagName), Uf = (e, t) => {
	if (!t) return null;
	try {
		return e.querySelector(t);
	} catch {
		return null;
	}
}, Wf = (e, { targetSelector: t } = {}) => {
	let { body: n } = e.document, r = /* @__PURE__ */ new Set(), i = Uf(n, t);
	for (let e of n.children) !Hf(e) && !e.inert && !e.contains(i) && (e.inert = !0, r.add(e));
	return () => {
		for (let e of r) e.inert = !1;
	};
}, Gf = "@appcues/dialog", Kf = "h1, h2, h3, h4, h5, h6", qf = "[inert], [hidden], [aria-hidden=\"true\"]", Jf = (e) => {
	if (e.getAttribute("aria-labelledby")) return;
	let t = [...e.querySelectorAll(Kf)].find((e) => e.textContent?.trim() && !e.closest(qf))?.textContent?.trim();
	t ? e.setAttribute("aria-label", t) : e.removeAttribute("aria-label");
};
Y(Gf, ({ addHook: e }, t) => {
	let { backdrop: n, variables: r, customBackdrop: i, inlineBackdrop: a = !1, target: o, autoFocus: s = !0 } = t, { dialogZIndex: c, backdropZIndex: l, backdropBlur: u, backdropColor: d } = r || {}, f = {
		backdrop: null,
		dialog: null
	}, p, m, h, g, _, v, y = (e, t, n) => {
		f[e]?.remove();
		let r = n.document.createElement("style");
		r.textContent = t, p.prepend(r), f[e] = r;
	}, b = () => {
		g && _ && (g.removeEventListener("scroll", _, !0), g.removeEventListener("resize", _));
	};
	if (n === !0 && !i && !o) {
		let t = ({ getTraitConfig: e, updateRootStyle: t }) => {
			let { variables: n } = e();
			t(bf(n || {}), { forceUpdate: !0 });
		};
		e("step.begin", t), e("step.container_change", t);
	}
	e("step.postrender", ({ step: e, getWindowReference: t, getTraitConfig: x }) => {
		let S = x(), C = S.backdrop ?? n, w = S.customBackdrop ?? i, T = S.target ?? o, E = S.autoFocus ?? s, D = S.inlineBackdrop ?? a, O = S.variables ?? r ?? {}, k = O.dialogZIndex ?? c, A = O.backdropZIndex ?? l, j = O.backdropBlur ?? u, M = O.backdropColor ?? d;
		[p] = e.querySelector("dialog") ?? [];
		let N = t();
		if (p) {
			C === !0 && w ? (m?.remove(), m = xf({
				getWindowReference: t,
				backdropZIndex: A,
				backdropBlur: j,
				backdropColor: M
			}), m && (D && p.parentNode ? p.parentNode.insertBefore(m, p) : N.document.body.append(m))) : (m?.remove(), m = void 0), C === !0 && !w && !T ? y("backdrop", yf, N) : (f.backdrop?.remove(), f.backdrop = null), y("dialog", vf, N), p.style.zIndex = k, p.removeAttribute("autofocus");
			let e = C === !0 && !w && !T ? "showModal" : "show";
			if (e === "show" && !T) return;
			p.hasAttribute("tabindex") || p.setAttribute("tabindex", "-1"), Jf(p);
			let n = {
				x: N.scrollX,
				y: N.scrollY
			}, r = p.open;
			p[e](), (N.scrollX !== n.x || N.scrollY !== n.y) && N.scrollTo(n.x, n.y), E && !r && (p.focus({ preventScroll: !0 }), p.scrollTop = 0);
		}
		b(), v?.(), h?.remove(), h = void 0, T && Rf(C) && (g = t(), h = zf({
			getWindowReference: t,
			target: T,
			backdropType: C,
			zIndex: (k ?? 2) - 1
		}), h && (g.document.body.append(h), _ = () => Bf({
			container: h,
			getWindowReference: t,
			target: T,
			backdropType: C
		}), g.addEventListener("scroll", _, !0), g.addEventListener("resize", _), C === "hard" && (v = Wf(g, { targetSelector: T }))));
	}), e("step.end", () => {
		p?.close(), f.backdrop?.remove(), f.dialog?.remove(), m?.remove(), h?.remove(), b(), v?.();
	});
}), Y("@appcues/experienceTheme", ({ addHook: e }) => {
	let t = null;
	function n({ getContainer: e, getExperienceId: n, getWindowReference: r, getTraitConfig: i }) {
		let { css: a } = i(), o = e();
		if (!a || t && t.parentNode === o) return;
		let s = n();
		o && (t = r().document.createElement("style"), t.id = `appcues-experience-style-${s}`, t.textContent = a, o.prepend(t));
	}
	function r() {
		t &&= (t.remove(), null);
	}
	e("step.begin", n), e("experience.end", r);
}), Y("@appcues/navigation", ({ addHook: e }, t) => {
	e("step.begin", async ({ handleNavigation: e, reportError: n }) => {
		if (t?.type) try {
			await e(t);
		} catch (e) {
			n(e?.message ?? "Navigation failed");
		}
	});
});
//#endregion
//#region src/traits/scrollIntoView/scroll-into-view.js
var Yf = "@appcues/scroll-into-view", Xf = new Set(["auto", "scroll"]), Zf = (e, t) => Xf.has(e) || Xf.has(t), Qf = (e, t) => {
	try {
		return e.getComputedStyle?.(t) ?? null;
	} catch {
		return null;
	}
}, $f = (e) => e?.nodeType === Node.DOCUMENT_FRAGMENT_NODE && "host" in e, ep = (e) => {
	if (e.assignedSlot) {
		let t = e.assignedSlot.parentNode;
		return $f(t) ? t.host : t;
	}
	return $f(e.parentNode) ? e.parentNode.host : e.parentElement;
}, tp = (e, t) => e.top < 0 || e.left < 0 || e.bottom > t.innerHeight || e.right > t.innerWidth, np = (e, t, n) => {
	if (Qf(n, e)?.position === "fixed") return !1;
	let { body: r, documentElement: i } = n.document, a = ep(e);
	for (; a && a !== r && a !== i;) {
		let e = Qf(n, a);
		if (!e) break;
		let r = a.getBoundingClientRect(), i = Zf(e.overflowY, e.overflow) && a.scrollHeight > a.clientHeight, o = Zf(e.overflowX, e.overflow) && a.scrollWidth > a.clientWidth, s = i && (t.top < r.top || t.bottom > r.bottom), c = o && (t.left < r.left || t.right > r.right);
		if (s || c) return !0;
		if (e.position === "fixed") break;
		a = ep(a);
	}
	return !1;
}, rp = (e, t) => {
	if (!t?.document || e.ownerDocument !== t.document) return !0;
	let n = e.getBoundingClientRect();
	return tp(n, t) ? !0 : np(e, n, t);
}, ip = 800, ap = 2, op = (e, t) => {
	let { top: n, left: r, bottom: i, right: a } = t.getBoundingClientRect();
	return [
		e.scrollX ?? 0,
		e.scrollY ?? 0,
		n,
		r,
		i,
		a
	].join(",");
}, sp = (e, t) => typeof e.requestAnimationFrame == "function" ? new Promise((n) => {
	let r = e.performance?.now?.() ?? Date.now(), i = null, a = 0, o = () => {
		let s = op(e, t), c = e.performance?.now?.() ?? Date.now();
		s === i ? a += 1 : a = 0, i = s;
		let l = c - r > ip;
		if (a >= ap || l) {
			n();
			return;
		}
		e.requestAnimationFrame(o);
	};
	e.requestAnimationFrame(o);
}) : Promise.resolve();
Y(Yf, ({ addHook: e }) => {
	let t = !1;
	e("step.postrender", ({ getTraitConfig: e, querySelector: n, getWindowReference: r }) => {
		if (t) return;
		let { target: i, behavior: a = "smooth", block: o = "center", inline: s = "nearest" } = e();
		if (!i?.selector) return;
		let c = ed(n(i.selector), i.filters);
		if (c.length === 0) return;
		let l = c[0], u = r();
		if (!rp(l, u)) {
			t = !0;
			return;
		}
		return l.scrollIntoView({
			behavior: a,
			block: o,
			inline: s
		}), t = !0, sp(u, l);
	}), e("step.end", () => {
		t = !1;
	});
});
//#endregion
//#region src/traits/advance-on-error/advance-on-error.js
var cp = "@appcues/advance-on-error", lp = 3e5, up = "@appcues/sequential.next", dp = "@appcues/sequential.skip", fp = (e) => e === up ? dp : e;
Y(cp, ({ addHook: e }, t) => {
	let n = null, r = () => {
		n !== null && (clearTimeout(n), n = null);
	};
	e("step.error", (e) => {
		r();
		let { getAction: i } = e, a = Number(t?.duration ?? 500), o = Number.isFinite(a) ? a : 500, s = t?.action;
		s?.type && (n = setTimeout(() => {
			n = null;
			let t = i(fp(s.type));
			t && t(s.config ?? {}, e, jn.ERROR);
		}, Math.min(Math.max(o, 0), lp)));
	}), e("step.prebegin", r), e("step.end", r);
});
var pp = "[id^=\"counter-\"]", mp = "input[maxlength], textarea[maxlength]", hp = (e, t) => `${e}/${t}`, gp = (e) => e?.tagName === "INPUT" || e?.tagName === "TEXTAREA", _p = 3, vp = (e, t) => {
	let { firstChild: n } = e;
	if (n?.nodeType === _p && !n.nextSibling) {
		n.nodeValue !== t && (n.nodeValue = t);
		return;
	}
	e.textContent = t;
}, yp = (e) => {
	for (let t of e.querySelectorAll(pp)) {
		let e = t.closest("fieldset")?.querySelector(mp) ?? null;
		gp(e) && e.maxLength > 0 && vp(t, hp(e.value.length, e.maxLength));
	}
}, bp = "@appcues/survey", xp = (e) => (t) => {
	t.preventDefault(), Nc(e, t.target);
}, Sp = "data-appcues-survey-min-options", Cp = "data-appcues-survey-max-options", wp = (e) => [...e.querySelectorAll("input, select, textarea")].some((e) => e.willValidate && !e.validity.valid), Tp = (e, t) => Number(e.getAttribute(t) ?? 0), Ep = (e) => {
	let t = [...e.querySelectorAll("input[type=\"checkbox\"]")];
	if (t.length === 0) return !1;
	let n = t.filter((e) => e.checked).length, r = Math.min(Tp(e, Sp), t.length), i = Tp(e, Cp);
	return n < r || i > 0 && n > i;
}, Dp = (e) => wp(e) || Ep(e), Op = (e) => e.checkValidity() && ![...e.querySelectorAll("fieldset")].some(Ep);
Y(bp, ({ addHook: e }) => {
	let t = /* @__PURE__ */ new Map(), n = null, r = !1, i = (e) => {
		let t = e.closest("fieldset");
		return r && t && Dp(t);
	}, a = () => {
		if (n) for (let e of n.querySelectorAll("[id^=\"error-\"]")) e.style.visibility = i(e) ? "visible" : "hidden";
	}, o = () => {
		r && a();
	}, s = () => {
		n && yp(n);
	}, c = (e) => {
		let t = e.target?.closest?.("button, input");
		if (!t || t.type !== "submit") return;
		let { form: n } = t;
		if (!(!n || !n.isConnected)) {
			if (e.preventDefault(), r = !0, a(), !Op(n)) {
				e.stopImmediatePropagation();
				return;
			}
			n.requestSubmit(t);
		}
	}, l = () => {
		for (let [e, n] of t) e.removeEventListener("submit", n);
		t.clear(), n &&= (n.removeEventListener("click", c, !0), n.removeEventListener("input", o), n.removeEventListener("input", s), null);
	}, u = ({ getContainer: e, getExperienceId: r }) => {
		l();
		let i = e?.();
		if (!i) return;
		let u = xp(r?.());
		for (let e of i.querySelectorAll("form")) e.addEventListener("submit", u), t.set(e, u);
		i.addEventListener("click", c, !0), i.addEventListener("input", o), i.addEventListener("input", s), n = i, a(), s();
	};
	e("step.postrender", u), e("step.container_change", u), e("step.end", () => {
		l(), r = !1;
	});
});
//#endregion
//#region src/core/components/appcues-container.js
var kp = (e) => class extends e.HTMLElement {
	constructor() {
		super();
		let t = this.ownerDocument || e.document;
		this.hideContentStyles = t.createElement("style"), this.hideContentStyles.innerHTML = "\n        * {\n          visibility: hidden;\n        }\n      ";
		try {
			this.attachShadow({ mode: "open" });
		} catch {}
		this.webComponentStyles = t.createElement("style"), this.webComponentStyles.innerHTML = "\n        :host {\n          all: initial;\n          font-family: inherit;\n          display: inline;\n        }\n      ";
	}
	async connectedCallback() {
		this.shadowRoot.append(this.hideContentStyles), this.shadowRoot.append(...this.childNodes), this.getAttribute("themeId") && await gi(this), this.shadowRoot.prepend(this.webComponentStyles), this.hideContentStyles.remove();
	}
}, Ap = /* @__PURE__ */ new WeakMap(), jp = (e = () => window) => {
	let t = e();
	if (Ap.has(t)) return Ap.get(t);
	if (!t.customElements.get("appcues-experience-container")) {
		let e = kp(t);
		t.customElements.define(gr, e);
	}
	let n = t.customElements.whenDefined(gr);
	return Ap.set(t, n), n;
};
//#endregion
//#region src/core/index.js
function Mp({ runningExperiences: e = /* @__PURE__ */ new Map(), sendEvent: t = () => {}, sendCustomEvent: n = () => {}, showFlow: r = () => {}, updateUserProfile: i = () => {}, getUserProfile: a = () => ({}), handleNavigation: o = () => {}, createRenderListener: s = Rs, vNodeHandlers: c = Gs, accessibilityHandlers: l = ac, getWindowReference: u = () => window, apiOverrides: d = {} } = {}) {
	li(d);
	let f = /* @__PURE__ */ new Map(), p = /* @__PURE__ */ new Map(), m = {
		sendEvent: t,
		sendCustomEvent: n,
		showFlow: r,
		updateUserProfile: i,
		getUserProfile: a,
		handleNavigation: o,
		createRenderListener: s,
		vNodeHandlers: c,
		accessibilityHandlers: l,
		getWindowReference: u,
		apiOverrides: d,
		getExperienceSend: (e) => p.get(e)
	}, h = (e) => e ? m?.[e] ? m[e] : () => {
		throw Error(`can't find external dependency called ${e}`);
	} : m, g = (e, t) => {
		p.set(e, (e) => t.send(e));
	}, _ = (e) => {
		h("handleNavigation")?.cancel?.(e);
	}, v = ({ reason: t = jn.NAVIGATION, except: n } = {}) => {
		e.forEach((r, i) => {
			n != null && i === n || (_(i), r.experienceService.send({
				type: An,
				reason: t
			}), r.experienceService.subscribe((e) => {
				e.matches("end-final") && r.experienceService.stop();
			}), e.delete(i), p.delete(i));
		});
	}, y = (t, { reason: n = jn.NAVIGATION } = {}) => {
		e.has(t) && (_(t), e.get(t).experienceService.send({
			type: An,
			reason: n
		}), e.delete(t), p.delete(t));
	};
	return {
		registerAction: zi,
		registerTrait: Y,
		show: async (t) => {
			jp(u), await u().customElements.whenDefined(gr), Lc(t.id);
			let n = bn(bn(t, "traits", (e) => (e ?? []).map((e, t) => ({
				...e,
				id: e.id || `${e.type}:${t}`
			}))), "steps", (e) => (e ?? []).map((e) => bn(e, "traits", (e) => (e ?? []).map((e, t) => ({
				...e,
				id: e.id || `${e.type}:${t}`
			}))))), r = e.get(t.id)?.experienceService ?? se(Fs(n, h)).start();
			g(t.id, r), r.send({
				type: kn,
				experience: n
			}), e.set(t.id, {
				experienceService: r,
				experience: n
			});
		},
		stopAll: v,
		stop: y,
		pause: (t) => {
			if (f.get(t)) return;
			let n = e.get(t);
			n && (y(t), f.set(t, {
				experienceService: n.experienceService,
				experience: n.experience
			}));
		},
		resume: (t) => {
			let n = f.get(t);
			n && (n.experienceService.send({ type: kn }), e.set(t, {
				experienceService: n.experienceService,
				experience: n.experience
			}), g(t, n.experienceService), f.delete(t));
		},
		getRunningExperiences: () => [...e].map(([, { experience: e }]) => e),
		isExperiencePaused: (e) => f.has(e)
	};
}
//#endregion
export { Mp as default };
